/**
 * Deutsche Oberflaechentexte — die Quelle der Wahrheit.
 *
 * Diese Datei bestimmt den Schluesselbestand. `en.ts` wird gegen den hier
 * abgeleiteten Typ geprueft: fehlt dort ein Schluessel, schlaegt der Typecheck
 * fehl. Eine fehlende Uebersetzung kann damit gar nicht erst ausgeliefert
 * werden -- sie faellt nicht erst im Test auf, sondern schon beim Bauen.
 *
 * WAS HIER NICHT HINEINGEHOERT: fachliche Datenwerte. Produktkategorien,
 * Produktfamilien, Artikelnummern, Bezeichnungen und Lieferantennamen kommen
 * aus der Datenbank und werden unveraendert angezeigt. Uebersetzt werden
 * ausschliesslich Oberflaechen- und Systemtexte sowie die Beschriftungen
 * technischer Codes aus Nachschlagetabellen.
 *
 * Platzhalter stehen in geschweiften Klammern: {name}.
 */
export const de = {
  // ── Allgemein ──────────────────────────────────────────────────────────
  "common.loading": "Wird geladen …",
  "common.errorTitle": "Es ist ein Fehler aufgetreten",
  "common.retry": "Erneut versuchen",
  "common.cancel": "Abbrechen",
  "common.close": "Schließen",
  "common.none": "keine",
  "common.unknownValue": "nicht bestimmt",
  "common.unknownValueTitle": "Wert nicht bestimmt",
  // ── Sprachumschaltung ──────────────────────────────────────────────────
  "language.label": "Sprache",
  "language.toGerman": "Auf Deutsch umschalten",
  "language.toEnglish": "Auf Englisch umschalten",
  // ── Anmeldung ──────────────────────────────────────────────────────────
  "login.title": "Anmeldung",
  "login.username": "Benutzername",
  "login.password": "Passwort",
  "login.submit": "Anmelden",
  "login.submitBusy": "Anmeldung läuft …",
  "login.foot": "Interne Anwendung. Zugang nur für berechtigte Mitarbeiter.",
  "login.passwordChanged": "Ihr Passwort wurde geändert. Bitte melden Sie sich mit dem neuen Passwort an.",
  // ── Rahmen ─────────────────────────────────────────────────────────────
  "app.checkingSession": "Sitzung wird geprüft …",
  "app.loadingMeta": "Stammdaten werden geladen …",
  "nav.home": "Zur Produktübersicht",
  "nav.sections": "Bereiche",
  "nav.products": "Produkte",
  "nav.suppliers": "Geschäftspartner",
  "sup.uebersicht": "Übersicht",
  "sup.stammdaten": "Stammdaten",
  "sup.produkte": "Produkte",
  "sup.datenbedarf": "Datenbedarf",
  "sup.konditionen": "Konditionen",
  "sup.add": "+ Geschäftspartner",
  "sup.addTitle": "Neuen Geschäftspartner anlegen",
  "sup.addSave": "Partner anlegen",
  "sup.addHint": "Kurzname, Firmierung, Rolle und Status genügen. Alles Weitere wird in der Akte ergänzt — ein Lieferant braucht keinen Artikel, um zu existieren.",
  "sup.legalNameOptional": "Rechtlicher Firmenname (optional)",
  "sup.status": "Status",
  "sup.address": "Anschrift",
  "sup.addressLine1": "Adresszeile 1",
  "sup.addressLine2": "Adresszeile 2",
  "sup.addressLine2Hint": "Gebäude, Halle, Bezirk",
  "sup.countryNone": "kein Land gewählt",
  "sup.editTermsAria": "Konditionen bearbeiten",
  "sup.editingTerms": "Konditionen bearbeiten",
  "sup.groupFrame": "Rahmenbedingungen",
  "sup.frameLater": "Incoterm und Bankverbindung folgen in eigenen Blöcken.",
  "sup.groupMissing": "Fehlende Supplier-Stammdaten",
  "sup.missingScope": "Diese Liste betrifft ausschließlich Supplier-Stammdaten — nicht das Produktwissen.",
  "sup.sortBy": "Nach {feld} sortieren",
  "supStatus.active": "Aktiver Lieferant",
  "supStatus.backup": "Backup-Lieferant",
  "supStatus.sourcing": "Product Sourcing",
  "supStatus.inactive": "Inaktiv",
  "error.family_code_taken": "Diese Familienkennung ist bereits vergeben.",
  "error.parameter_set_superseded": "Dieser Parametersatz ist abgelöst. Ein neuer Wert gehört in einen neuen Stand.",
  "error.parameter_set_date_taken": "Für dieses Gültigkeitsdatum existiert bereits ein Parametersatz. Bitte ein anderes Datum wählen.",
  "error.parameter_set_locked": "Für dieses Gültigkeitsdatum existiert bereits ein Parametersatz, mit dem schon gerechnet wurde. Bitte ein anderes Gültig-ab-Datum wählen.",
  "error.family_incomplete": "Eine Produktfamilie braucht Kategorie, Kennung und Namen.",
  "error.invalid_category": "Diese Hauptkategorie gibt es nicht.",
  "error.invalid_country": "Das Land wird als Ländercode nach ISO 3166-1 geführt, zum Beispiel CN oder DE.",
  "error.unknown_status": "Dieser Lieferantenstatus ist unbekannt.",
  "error.supplier_exists": "Einen Lieferanten mit diesem Namen gibt es bereits.",
  "error.legal_equals_name": "Die Firmierung ist nicht der Kurzname. Wer keine kennt, lässt das Feld leer.",
  "error.messenger_incomplete": "Ein weiterer Kontaktkanal braucht Art und Kennung — oder keins von beidem.",
  "error.name_required": "Hier fehlt der Name.",
  "error.unknown_role": "Diese Zuständigkeit steht nicht im Katalog.",
  "error.invalid_date": "Bitte ein Datum im Format JJJJ-MM-TT eintragen.",
  "error.number_exists": "Diese Lieferantennummer ist bereits vergeben.",
  "error.primary_exists": "Es gibt bereits einen Hauptansprechpartner.",
  "error.supplier_merged": "Dieser Lieferant wurde zusammengeführt und wird nicht mehr gepflegt.",
  "sup.title": "Geschäftspartner",
  "sup.search": "Partner suchen",
  "sup.count": "{n} Partner",
  "sup.name": "Kurzname",
  "sup.shortName": "Kurzname",
  "sup.legalName": "Rechtlicher Firmenname",
  "sup.supplierNumber": "Lieferantennummer",
  "sup.optional": "optional",
  "sup.country": "Land",
  "sup.street": "Straße",
  "sup.postalCode": "PLZ",
  "sup.city": "Ort",
  "sup.province": "Provinz / Bundesstaat",
  "sup.website": "Website",
  "sup.articles": "Artikel",
  "sup.rating": "Bewertung",
  "sup.state": "Status",
  "sup.activeYes": "aktiv",
  "sup.inactive": "inaktiv",
  "sup.missing": "{n} fehlend",
  "sup.back": "Zur Liste",
  "sup.partnerSince": "Partner seit",
  "sup.createdAt": "In HOMEBASE angelegt",
  "sup.editAria": "Stammdaten bearbeiten",
  "sup.editing": "Stammdaten bearbeiten",
  "sup.editHint": "Getippte Angaben gelten erst nach dem Speichern. Der Kurzname wird hier nicht geändert.",
  "sup.groupPartner": "Partner",
  "sup.groupContact": "Hauptansprechpartner",
  "sup.groupBusiness": "Geschäftsbeziehung",
  "sup.groupOpen": "Was fehlt",
  "sup.groupCompany": "Unternehmen",
  "sup.groupAddress": "Anschrift",
  "sup.groupContacts": "Ansprechpartner",
  "sup.groupTerms": "Zahlungsbedingungen",
  "sup.nothingMissing": "Alles erfasst, was HOMEBASE heute kennt.",
  "sup.noPrimary": "Kein Hauptansprechpartner erfasst.",
  "sup.noContacts": "Noch kein Ansprechpartner erfasst.",
  "sup.noPrimaryAmong": "{n} Ansprechpartner erfasst, aber keiner davon ist der Hauptansprechpartner.",
  "sup.goMaintain": "pflegen",
  "sup.noArticles": "Diesem Lieferanten ist kein Artikel zugeordnet.",
  "sup.contacts": "Ansprechpartner",
  "sup.contactName": "Name",
  "sup.contactJob": "Funktion",
  "sup.contactRole": "Zuständigkeit",
  "sup.contactEmail": "E-Mail",
  "sup.contactPhone": "Telefon",
  "sup.contactMobile": "Mobil",
  "sup.messengerKind": "Weiterer Kanal",
  "sup.messengerNone": "kein weiterer Kanal",
  "sup.messengerId": "Kennung",
  "sup.roleNone": "keine Zuständigkeit",
  "sup.primary": "Hauptansprechpartner",
  "sup.makePrimary": "zum Hauptansprechpartner",
  "sup.removeContact": "entfernen",
  "sup.addContact": "Ansprechpartner hinzufügen",
  "sup.saveContact": "Ansprechpartner speichern",
  "sup.articleNumber": "Artikelnummer",
  "sup.articleName": "Bezeichnung",
  "sup.alsoFrom": "auch von {n} weiteren",
  "sup.terms": "Zahlungsplan",
  "sup.ownTerms": "eigene Vereinbarung",
  "sup.standardTerms": "Supplier-Standard",
  "sup.paymentTerms": "Zahlungsbedingung",
  "sup.paymentStandard": "Supplier-Standard",
  "sup.termsOpen": "Ungespeicherte Änderungen",
  "sup.termsHint": "Bewertung und Zahlungsplan werden gemeinsam gespeichert.",
  "sup.overrideHint": "Abweichende Vereinbarungen einzelner Artikel werden am Artikel gepflegt, nicht hier.",
  "supRole.sales": "Vertrieb",
  "supRole.engineering": "Technik",
  "supRole.quality": "Qualität / QC",
  "supRole.finance": "Finanzen",
  "supRole.logistics": "Logistik",
  "supRole.management": "Geschäftsleitung",
  "messenger.wechat": "WeChat",
  "messenger.whatsapp": "WhatsApp",
  "messenger.skype": "Skype",
  "messenger.teams": "Teams",
  "sup.firstName": "Vorname",
  "sup.lastName": "Nachname",
  "sup.contactRoles": "Zuständigkeiten",
  "sup.contactDepartment": "Abteilung",
  "sup.contactNote": "Notiz",
  "sup.contactActive": "aktiv",
  "sup.contactInactive": "nicht mehr aktiv",
  "sup.contactsMore": "und {n} weitere",
  "sup.editContactAria": "{name} bearbeiten",
  "sup.removeSure": "Wirklich entfernen?",
  "sup.removeYes": "entfernen",
  "sup.preferredChannel": "Bevorzugter Kanal",
  "sup.preferredNone": "kein bevorzugter Kanal",
  "sup.incoterm": "Incoterm",
  "sup.incotermNone": "keine Lieferklausel",
  "sup.currency": "Bevorzugte Währung",
  "sup.currencyNone": "keine Währung",
  "sup.groupQuality": "Datenqualität",
  "sup.openNeed": "Offener Supplier-Datenbedarf",
  "sup.openNeedValue": "{q} offene Fragen zu {a} Produkten",
  "sup.noOpenNeed": "keine offenen Fragen",
  "sup.bankCurrency": "Währung",
  "supRole.product_development": "Produktentwicklung",
  "channel.email": "E-Mail",
  "channel.phone": "Telefon",
  "channel.mobile": "Mobil",
  "channel.messenger": "Messenger",
  "sup.finanzen": "Finanzen",
  "sup.groupNotes": "Notizen",
  "sup.addNote": "+ Notiz hinzufügen",
  "sup.noNotes": "Noch keine Notiz erfasst.",
  "sup.noteText": "Notiz",
  "sup.notePlaceholder": "Was ist zu dieser Geschäftsbeziehung festzuhalten?",
  "sup.noteEdited": "bearbeitet am {datum} von {wer}",
  "sup.editNoteAria": "Notiz bearbeiten",
  "sup.groupBank": "Bankverbindungen",
  "sup.addBank": "+ Bankverbindung hinzufügen",
  "sup.noBank": "Für diesen Lieferanten ist keine Bankverbindung erfasst.",
  "sup.bankLabel": "Bezeichnung",
  "sup.bankLabelHint": "z. B. USD Account – Bank of China",
  "sup.beneficiary": "Kontoinhaber",
  "sup.accountNumber": "Kontonummer",
  "sup.iban": "IBAN",
  "sup.bankName": "Bank",
  "sup.bankAddress": "Bankanschrift",
  "sup.bankCountry": "Land der Bank",
  "sup.swift": "SWIFT / BIC",
  "sup.branch": "Filiale",
  "sup.branchHint": "Name oder Code",
  "sup.clearing": "Nationale Bankleitzahl",
  "sup.clearingHint": "CNAPS, ABA, Sort Code",
  "sup.correspondent": "Korrespondenzbank",
  "sup.payHint": "Überweisungshinweis",
  "sup.bankPrimary": "Standard",
  "sup.bankInactive": "stillgelegt",
  "sup.makeBankPrimary": "zum Standard",
  "sup.deactivate": "stilllegen",
  "sup.activate": "wieder aktivieren",
  "sup.editBankAria": "{name} bearbeiten",
  "sup.bankScope": "Bankverbindungen sind Stammdaten des Partners. Bestellungen, Rechnungen und Zahlungen entstehen hier nicht.",
  "sup.bankSummary": "Bankverbindungen",
  "sup.bankSummaryValue": "{n} · {waehrungen}",
  "nav.procurement": "Produktion & Logistik",
  "plp.title": "Produktion & Logistik",
  "plp.count": "{n} Bestellungen",
  "plp.zoom": "Zeitmaßstab",
  "plp.timeline": "Zeitachse",
  "plp.timelineScroll": "Zeitachse — waagerecht scrollbar",
  "plp.calendarWeek": "KW {n}",
  "plp.timelineHint": "Echte Zeitachse — die Lage eines Ereignisses ist sein Datum.",
  "plp.today": "Heute",
  "plp.noLanes": "Noch keine Bestellung erfasst.",
  "plp.back": "Zur Übersicht",
  "plp.addOrderShort": "+ Bestellung",
  "plp.addCn": "+ Consolidation",
  "plp.newOrder": "Bestellung aus DTE übernehmen",
  "plp.chooseSupplier": "Lieferant wählen",
  "plp.numberExample": "PO70305",
  "plp.dteNumber": "DTE-Bestellnummer",
  "plp.numberHint": "Format geprüft. NICHT gegen DTE abgeglichen — HOMEBASE vergibt keine Bestellnummern.",
  "plp.orderedAt": "Belegdatum",
  "plp.note": "Notiz",
  "plp.order": "Bestellung",
  "plp.orders": "Bestellungen",
  "plp.lines": "Positionen",
  "plp.noLines": "Noch keine Position erfasst.",
  "plp.addLine": "+ Position",
  "plp.article": "Artikel",
  "plp.chooseArticle": "Artikel wählen",
  "plp.quantity": "Menge",
  "plp.unitPrice": "Vereinbarter Preis",
  "plp.moq": "unter MOQ",
  "plp.belowMoq": "Mindestabnahme {n}",
  "plp.leadTime": "Lieferzeitregel",
  "plp.noRule": "Für diese Bestellung greift keine Lieferzeitregel. Ohne sie entsteht kein Forecast.",
  "plp.duration": "Dauer",
  "plp.days": "{min}–{max} Tage",
  "plp.daysMin": "Mindestens (Tage)",
  "plp.daysMax": "Höchstens (Tage)",
  "plp.anchor": "Bezugspunkt",
  "plp.anchorMissing": "Termin fehlt",
  /* ── DIE CHINA-PLANUNGSEBENE (0093) ──────────────────────────────
     Eine Informationsebene, keine Warnung: die Saetze sagen, was ist,
     und nicht, dass etwas nicht stimmt. */
  /* Versalien: die Spur steht nicht NEBEN den Sendungen, sondern
     ueber ihnen. Die Schreibweise sagt die Ebene. */
  "china.track": "CHINA",
  "china.editAria": "China-Planungsebene bearbeiten",
  "china.title": "China · Planungsebene",
  "china.hint": "Externe Rahmenbedingungen. Sie verändern keine Lieferzeit und keinen Termin.",
  "china.buffer": "Vorlauf {vor} Tage · Nachlauf {nach} Tage",
  "china.core": "Kernereignis",
  "china.leadIn": "Tage davor",
  "china.leadOut": "Tage danach",
  "china.name": "Bezeichnung",
  "china.from": "Beginn",
  "china.to": "Ende",
  "china.sourceNote": "Quelle",
  "china.checkedOn": "zuletzt geprüft",
  "china.add": "+ Ereignis",
  "china.deactivate": "Stilllegen",
  "china.inactive": "stillgelegt",
  "china.none": "Für diesen Zeitraum ist kein Ereignis hinterlegt.",
  "china.detailTitle": "China-Ereignis",
  "chinaStatus.bestaetigt": "amtlich bestätigt",
  "chinaStatus.vorlaeufig": "vorläufig",
  /* Zwei Gruende, zwei Saetze. „Termin fehlt" heisst: er ist noch nicht
     eingetreten. Dieser hier heisst: er KANN nicht bestimmt werden,
     solange eine Position keinen Preis traegt -- siehe
     `LEAD_TIME_ANCHOR_GAPS`. */
  "plp.anchorValueIncomplete": "Bestellwert unvollständig",
  "payAnchor.deposit_paid": "Anzahlung geleistet",
  "payAnchor.paid_in_full": "Vollständig bezahlt",
  "plp.scope": "Geltungsbereich",
  "plp.source": "Quelle",
  "plp.quoted": "Wortlaut",
  "plp.quotedHint": "z. B. 5-6 weeks after payment confirmed",
  "plp.milestones": "Termine",
  "plp.milestone": "Termin",
  "plp.noMilestones": "Noch kein Termin erfasst.",
  "plp.chooseMilestone": "Termin wählen",
  "plp.date": "Datum",
  "plp.certainty": "Terminstatus",
  "plp.whyMoved": "Warum verschiebt sich der Termin?",
  "plp.whyMovedHint": "kurzer Grund — später nicht mehr rekonstruierbar",
  "plp.moveMilestone": "Termin verschieben",
  "plp.removeMilestone": "entfernen",
  /* Bearbeiten und Entfernen sind zwei Handlungen: die eine stellt
     richtig, die andere nimmt zurueck. */
  /* Eine Zahlung ist per Definition geleistet -- sie braucht
     keinen Terminstatus und keine Zahlungsart. */
  "plp.payment": "Zahlung",
  "plp.editMilestone": "Termin bearbeiten",
  "plp.editingMilestone": "{was} vom {wann} wird bearbeitet. Ein geänderter Tag löst den bisherigen Stand ab — er bleibt als Geschichte lesbar.",
  "plp.superseded": "abgelöst",
  "plp.previously": "zuvor {wann}",
  "plp.review": "Abschluss",
  "plp.reviewStars": "Bewertung",
  "plp.reviewStarsOf": "{n} von 5 Sternen",
  "plp.reviewNone": "noch nicht bewertet",
  "plp.reviewClear": "zurücknehmen",
  "plp.reviewNote": "Rückblick / Besonderheiten",
  "plp.reviewNoteHint": "Was lief besonders gut, schlecht oder ungewöhnlich?",
  "plp.notMeasurable": "nicht bewertbar",
  "plp.dOrdered": "Bestellt",
  "plp.dReady": "Versandbereit",
  "plp.dOrderToReady": "Bestellung bis Versandbereitschaft",
  "plp.leadTimeSection": "Durchlaufzeit",
  "plp.dWaitForOthers": "Wartezeit auf die übrigen Bestellungen",
  "plp.dFirstAtForwarder": "Erste Bestellung beim Logistikpartner",
  "plp.dLastAtForwarder": "Letzte Bestellung beim Logistikpartner",
  "plp.dDays": "{n} Tage",
  "plp.dFairness": "Die Wartezeit gehört zur Sendung, nicht zur Bestellung — eine rechtzeitig fertige Bestellung wird dadurch nicht schlechter.",
  "plp.openProcessData": "Offene Prozessangaben",
  "plp.stillRequired": "Noch erforderlich",
  "plp.openTransportData": "Noch nicht erfasste Transportangaben",
  "plp.notEveryStepRequired": "Nicht jede Bestellung braucht jeden Schritt — diese Angaben sind nur noch nicht erfasst.",
  "plp.recordedBy": "erfasst von {wer} am {wann}",
  "plp.attention": "Was braucht Aufmerksamkeit?",
  "plp.severityUrgent": "Dringend",
  "plp.severityOpen": "Offen",
  "plp.window": "Konsolidierungsfenster",
  "plp.expectedReady": "Erwartet versandbereit",
  "plp.cutoff": "Cutoff",
  "plp.bufferLabel": "Planungspuffer",
  "plp.buffer": "{n} Tage",
  "plp.windowSentence": "Zeitlich könnte {po} noch in {cn} aufgenommen werden. Die Zuordnung trifft ein Mensch.",
  "plp.assign": "zuordnen",
  "plp.unassign": "Aus CN lösen",
  "plp.cnMaster": "Sendungsdaten",
  "plp.ordersCount": "{n} Bestellungen",
  "plp.atForwarderCount": "{da}/{von} beim Logistikpartner",
  "plp.transportTitle": "Transport",
  "plp.transportMode": "Transportart",
  "plp.transportUnknown": "noch nicht entschieden",
  "plp.allArrived": "Alle Bestellungen beim Logistikpartner eingetroffen",
  "plp.arrivedOf": "{da} von {alle} Bestellungen beim Logistikpartner",
  "plp.historyTitle": "Zurückgestellte Bestellungen",
  "plp.atForwarderOn": "beim Logistikpartner seit {date}",
  "plp.notAtForwarder": "noch ausstehend",
  "plp.markAtForwarder": "Eingang beim Logistikpartner erfassen",
  "plp.unmarkAtForwarder": "Eingang zurücknehmen",
  "plp.inTransitHint": "Diese Sendung ist an den Carrier übergeben. Bestellungen lassen sich nicht mehr lösen.",
  "plp.releaseFrom": "{po} aus {cn} lösen",
  "plp.releaseReason": "Grund",
  "plp.releaseReasonPlaceholder": "z. B. Produktionsverzögerung",
  "plp.releasedOrders": "Zurückgestellte Bestellungen",
  "plp.releasedOn": "gelöst am {date}",
  "plp.noActiveCn": "keine aktive Consolidation",
  "plp.heldBack": "für den nächsten Orderrun zurückgestellt",
  "plp.addOrder": "Bestellung zuordnen",
  "plp.chooseOrder": "Bestellung wählen",
  "plp.cnEmpty": "Dieser Consolidation ist noch keine Bestellung zugeordnet.",
  "plp.closeCn": "Sendung abschließen",
  "plp.discardCn": "CN verwerfen",
  "plp.deviation": "Abweichung {n} Tage",
  "plp.wasPromised": "zuvor zugesagt: {datum}",
  "plp.basisRule": "Grundlage: {min}–{max} Tage ab {anker} {datum} · {bereich} · {quelle}",
  "plp.basisOrders": "Grundlage: die {n} zugeordneten Bestellungen",
  "plp.missingRule": "keine Lieferzeitregel",
  "plp.missingAnchor": "Bezugspunkt {anker} hat kein Datum",
  "plp.moqLines": "{n} Position(en)",
  "ms.po_ordered": "Bestellt",
  "ms.pi_received": "PI erhalten",
  "ms.pi_approved": "PI freigegeben",
  "ms.deposit_due": "Anzahlung fällig",
  "ms.deposit_paid": "Anzahlung geleistet",
  "ms.artwork_sent": "Artwork gesendet",
  "ms.artwork_approved": "Artwork freigegeben",
  "ms.production_start": "Produktionsbeginn",
  "ms.production_ready": "Produktion fertig",
  "ms.qc_planned": "Prüftermin",
  "ms.qc_passed": "Prüfung bestanden",
  "ms.qc_not_required": "QC nicht erforderlich",
  "ms.ready_for_shipment": "Versandbereit",
  "ms.consolidation_cutoff": "Cutoff",
  "ms.consolidation_ready": "Consolidation bereit",
  "ms.planned_etd": "ETD",
  "cert.forecast": "Forecast",
  "cert.confirmed": "Bestätigt",
  "cert.actual": "Ist",
  "poStatus.offen": "offen",
  "poStatus.geschlossen": "geschlossen",
  "poStatus.storniert": "storniert",
  "cnStatus.geplant": "geplant",
  "cnStatus.gebucht": "gebucht",
  "cnStatus.in_transport": "in Transport",
  "cnStatus.zugestellt": "zugestellt",
  "cnStatus.geschlossen": "abgeschlossen",
  "cnStatus.verworfen": "verworfen",
  // Wie eine Sendung reist -- Codes aus `transport_modes` (0079). Eigenes
  // Praefix neben `transport.*`: jenes beschriftet die Frachtrate einer
  // Kalkulation, dieses den tatsaechlichen Weg einer Sendung.
  "cnTransport.sea": "Seefracht",
  "cnTransport.air": "Luftfracht",
  "cnTransport.train": "Bahn",
  "cnTransport.road": "Straße",
  "cnTransport.multimodal": "Multimodal",
  "cnTransport.other": "Sonstiges",
  "plpScope.supplier": "Lieferant",
  "plpScope.supplier_article": "Beziehung",
  "plpScope.purchase_order": "diese Bestellung",
  "plpSource.supplier_pi": "Proforma des Lieferanten",
  "plpSource.supplier_statement": "Angabe des Lieferanten",
  "plpSource.internal_assumption": "interne Annahme",
  "plpOrigin.manual": "manuell eingegeben",
  "plpOrigin.dte_feed": "aus dem DTE-Feed",
  "plpZoom.tag": "Tage",
  "plpZoom.woche": "Wochen",
  "plpZoom.monat": "Monate",
  "plpWindow.passt": "passt",
  "plpWindow.passt_knapp": "knapp",
  "plpWindow.passt_nicht": "passt nicht",
  "plpWindow.unbestimmt": "unbestimmt",
  "plpAttn.po_without_cn": "keiner Consolidation zugeordnet",
  "plpAttn.po_forecast_basis_missing": "Forecast-Grundlage fehlt",
  "plpAttn.po_ready_missing": "kein Termin für die Versandbereitschaft",
  "plpAttn.po_pi_overdue": "seit der Bestellung keine PI erhalten",
  "plpAttn.po_deposit_overdue": "Anzahlung fällig, aber nicht geleistet",
  "plpAttn.po_artwork_open": "Artwork gesendet, aber nicht freigegeben",
  "plpAttn.po_step_open": "eine erforderliche Prozessangabe fehlt noch",
  "plpAttn.po_qc_missing": "Produktion wird fertig, aber kein Prüftermin",
  "plpAttn.po_below_moq": "Menge unter der Mindestabnahme",
  "plpAttn.milestone_overdue": "bestätigter Termin verstrichen, kein Ist erfasst",
  "plpAttn.cn_without_po": "noch keine Bestellung zugeordnet",
  "plpAttn.cn_po_after_cutoff": "Bestellung wird erst nach dem Cutoff fertig",
  "plpAttn.cn_window_open": "eine weitere Bestellung könnte zeitlich passen",
  "plpAttnDo.po_without_cn": "Einer Sendung zuordnen.",
  "plpAttnDo.po_forecast_basis_missing": "Lieferzeitregel hinterlegen.",
  "plpAttnDo.po_ready_missing": "Versandbereitschaft erfassen.",
  "plpAttnDo.po_pi_overdue": "PI beim Lieferanten anfordern.",
  "plpAttnDo.po_deposit_overdue": "Zahlung unter Finanzen erfassen.",
  "plpAttnDo.po_artwork_open": "Artwork-Freigabe erfassen.",
  "plpAttnDo.po_step_open": "In der Akte unter „Noch erforderlich“ erfassen.",
  "plpAttnDo.po_qc_missing": "Prüftermin erfassen.",
  "plpAttnDo.po_below_moq": "Menge oder Mindestabnahme prüfen.",
  "plpAttnDo.milestone_overdue": "Tatsächlichen Termin erfassen — oder die Zusage verschieben.",
  "plpAttnDo.cn_without_po": "Bestellung zuordnen.",
  "plpAttnDo.cn_po_after_cutoff": "Zuordnung oder Cutoff prüfen.",
  "plpAttnDo.cn_window_open": "Zuordnung prüfen.",
  "supMissing.legalName": "rechtlicher Firmenname",
  "supMissing.country": "Land",
  "supMissing.address": "Anschrift",
  "supMissing.partnerSince": "Partner seit",
  "supMissing.contacts": "Ansprechpartner",
  "nav.users": "Benutzer",
  "nav.nora": "Nora HR",
  "nav.signOut": "Abmelden",
  "nav.changePassword": "Passwort ändern",
  "nav.roleTitle": "Rolle: {role}",
  // ── Benutzerrollen ─────────────────────────────────────────────────────
  "userRole.admin": "Administrator",
  "userRole.viewer": "Viewer",
  "userRole.product": "Produktmanagement",
  "userRole.marketing": "Marketing",
  "userRole.connector": "Connector",
  // ── Artikelliste ───────────────────────────────────────────────────────
  "list.searchPlaceholder": "Artikelnummer oder Bezeichnung suchen …",
  "list.search": "Suche",
  "list.category": "Produktkategorie",
  "list.family": "Produktfamilie",
  "list.role": "Artikelrolle",
  "list.allCategories": "Alle Kategorien",
  "list.allFamilies": "Alle Familien",
  "list.allRoles": "Alle Rollen",
  "list.lifecycle": "Sortimentsstatus",
  "list.lifecycleAll": "Jeder Sortimentsstatus",
  "list.lifecycleOpen": "noch nicht bestimmt",
  "list.lifecycleUnset": "Nicht bestimmt",
  "list.availability": "Verfügbarkeit",
  "list.availabilityAll": "Jede Verfügbarkeit",
  "list.availabilityYes": "Verfügbar",
  "list.availabilityNo": "Nicht verfügbar",
  "list.availabilityUnknown": "Keine Bestandsaussage",
  "list.operational": "Operativer Zustand",
  "list.operationalAll": "Jeder Zustand",
  "list.operationalStock": "Bestand",
  "list.operationalIncoming": "Zulauf",
  "list.operationalOffered": "Angeboten",
  "list.statusSuspended": "Der Statusfilter greift noch nicht: es ist keine Bestands- oder Beschaffungsquelle angeschlossen. Bis dahin ist der Zustand jedes Artikels unbestimmt, und die Liste zeigt den gesamten Bestand.",
  "list.resetFilters": "Filter zurücksetzen",
  "list.articles": "Artikel",
  "list.ofTotal": "von {total}",
  "list.emptyTitle": "Keine Artikel gefunden",
  "list.emptyHint": "Suchbegriff oder Filter anpassen.",
  "list.colNumber": "Artikelnummer",
  "list.colDescription": "Bezeichnung",
  "list.colCategory": "Kategorie",
  "list.colFamily": "Produktfamilie",
  "list.colStatus": "Status",
  "list.colRoles": "Rollen",
  "list.sortBy": "Nach {label} sortieren",
  "list.prev": "Zurück",
  "list.next": "Weiter",
  "list.page": "Seite {page} von {total}",
  // ── Auszeichnungen ─────────────────────────────────────────────────────
  "badge.primaryFamily": "primäre Produktfamilie",
  "badge.secondaryFamily": "weitere Familienbeziehung",
  "badge.openFlags": "{count} offen",
  "badge.openFlagsTitle": "{count} offene Prüfhinweise",
  // ── Artikeldetail ──────────────────────────────────────────────────────
  "detail.aria": "Artikeldetail",
  "detail.category": "Produktkategorie",
  "detail.quality": "Datenqualität",
  "detail.openFlags": "Offene Prüfhinweise",
  "detail.compatibleWith": "kompatibel mit",
  "detail.legacy": "Historische Klassifikation",
  "detail.articleNumbers": "Artikelnummern",
  // ── Benutzerverwaltung ─────────────────────────────────────────────────
  "users.title": "Benutzer",
  "users.loading": "Benutzer werden geladen …",
  "users.create": "Benutzer anlegen",
  "users.hint": "Ein {admin} darf alles. Ein {viewer} darf ausschließlich lesen – Artikel ansehen, suchen und filtern. Schreibende Zugriffe weist der Server ab, unabhängig davon, was hier angezeigt wird.",
  "users.footnote": "Das eigene Konto lässt sich weder sperren noch herabstufen, und der letzte aktive Administrator bleibt bestehen. Beim Sperren, beim Rollenwechsel und beim Setzen eines Passworts werden bestehende Sitzungen sofort beendet.",
  "users.colUsername": "Benutzername",
  "users.colName": "Anzeigename",
  "users.colRole": "Rolle",
  "users.colStatus": "Status",
  "users.colLastLogin": "Letzte Anmeldung",
  "users.colSessions": "Sitzungen",
  "users.colActions": "Aktionen",
  "users.active": "aktiv",
  "users.inactive": "gesperrt",
  "users.self": "(Sie)",
  "users.roleAria": "Rolle von {user}",
  "users.noRole": "— keine —",
  "users.setPassword": "Passwort setzen",
  "users.deactivate": "Sperren",
  "users.activate": "Entsperren",
  "users.never": "—",
  "users.formUsername": "Benutzername",
  "users.formUsernameHint": "z. B. mira",
  "users.formDisplayName": "Anzeigename",
  "users.formDisplayNameHint": "Vor- und Nachname",
  "users.formRole": "Rolle",
  "users.formPassword": "Erstes Passwort",
  "users.formPasswordHint": "mindestens {n} Zeichen",
  "users.formSubmit": "Anlegen",
  "users.formSubmitBusy": "Wird angelegt …",
  "users.msgCreated": "Konto {user} wurde angelegt.",
  "users.msgRoleChanged": "{user} hat jetzt die Rolle {role}.",
  "users.msgPasswordSet": "Passwort für {user} wurde neu gesetzt.",
  "users.msgDeactivated": "{user} wurde gesperrt.",
  "users.msgActivated": "{user} ist wieder aktiv.",
  "users.promptPassword": "Neues Passwort für „{name}“ (mindestens {n} Zeichen).\nBestehende Sitzungen werden dabei beendet.",
  // ── Eigenes Passwort ändern ────────────────────────────────────────────
  "pw.title": "Passwort ändern",
  "pw.intro": "Nach der Änderung werden alle bestehenden Sitzungen beendet. Sie melden sich anschließend mit dem neuen Passwort erneut an.",
  "pw.current": "Aktuelles Passwort",
  "pw.new": "Neues Passwort",
  "pw.repeat": "Neues Passwort wiederholen",
  "pw.rule": "mindestens {n} Zeichen",
  "pw.tooShort": "Noch zu kurz.",
  "pw.mismatch": "Die beiden Eingaben stimmen nicht überein.",
  "pw.submit": "Passwort ändern",
  "pw.submitBusy": "Wird geändert …",
  // ── Fehlertexte nach API-Fehlercode ────────────────────────────────────
  // Die Oberflaeche bildet den stabilen Fehlercode auf einen eigenen Text ab.
  // Die Meldung des Servers wird NICHT angezeigt -- sonst entstuende ein
  // zweiter, unuebersetzter Textbestand.
  /*
   * KORREKTURLAUF 005. Der Befund war EINE Meldung -- „Unbekannter
   * Fehler. (cn_not_handed_over)" --, der Rundlauf fand SIEBZIG: so
   * viele Fachcodes warf der Kern, ohne dass es dafuer einen Satz
   * gab. Jeder davon waere irgendwann so auf dem Bildschirm
   * gelandet. `verify` ME1 haelt ab jetzt nach, dass kein neuer
   * dazukommt.
   */
  "error.already_applied": "Dieser Vorschlag wurde bereits übernommen.",
  "error.already_clarified": "Dieser Wert ist bereits geklärt.",
  "error.already_decided": "Hier ist bereits entschieden worden.",
  "error.already_resolved": "Dieser Befund ist bereits erledigt.",
  "error.bad_code": "Dieser Code hat eine unzulässige Form.",
  "error.bad_group": "Diese Gruppe kennt HOMEBASE nicht.",
  "error.bad_value_type": "Dieser Wert passt nicht zur Art des Merkmals.",
  "error.bank_incomplete": "Dieser Bankverbindung fehlt eine Pflichtangabe.",
  "error.bank_primary_exists": "Für diese Währung gibt es bereits eine Standardverbindung.",
  "error.below_minimum_margin": "Dieser Preis liegt unter der Mindestmarge.",
  "error.category_code_taken": "Diesen Kategoriecode gibt es bereits.",
  "error.category_incomplete": "Dieser Kategorie fehlt eine Pflichtangabe.",
  "error.code_locked": "Dieser Code ist festgeschrieben und lässt sich nicht mehr ändern.",
  "error.code_taken": "Diesen Code gibt es bereits.",
  "error.computed_column": "Dieser Wert wird gerechnet und lässt sich nicht von Hand setzen.",
  "error.definition_in_use": "Diese Definition ist in Gebrauch und lässt sich nicht entfernen.",
  "error.definition_incomplete": "Dieser Definition fehlt eine Pflichtangabe.",
  "error.duplicate_level": "Diese Stufe gibt es in dieser Reihe bereits.",
  "error.duplicate_material": "Dieses Material steht bereits in der Liste.",
  "error.empty_customs_fact": "Zu dieser Zollangabe steht kein Wert da.",
  "error.empty_proposal": "Dieser Vorschlag enthält nichts, was zu übernehmen wäre.",
  "error.enum_not_supported": "Für diese Merkmalsart gibt es keine Werteliste.",
  "error.evidence_exists": "Zu diesem Befund liegt bereits ein Beleg vor.",
  "error.execution_taken": "Diese Ausführung gibt es in diesem Produktmodell bereits.",
  "error.flag_open": "Zu diesem Datensatz steht noch ein Befund offen.",
  "error.handoff_not_configured": "Für diese Übergabe fehlt die Einrichtung.",
  "error.in_trash": "Dieser Datensatz liegt im Papierkorb.",
  "error.invalid_code": "Dieser Code hat eine unzulässige Form.",
  "error.invalid_count": "Diese Anzahl ist keine gültige Zahl.",
  "error.invalid_flag": "Diesen Befund kennt HOMEBASE nicht.",
  "error.invalid_level": "Diese Stufe ist unzulässig.",
  "error.invalid_material": "Dieses Material kennt HOMEBASE nicht.",
  "error.invalid_result": "Dieses Prüfergebnis kennt HOMEBASE nicht.",
  "error.invalid_test_type": "Diese Prüfart kennt HOMEBASE nicht.",
  "error.invalid_measure": "Dieses Maß ist kein gültiger Wert.",
  "error.packaging_material_mismatch": "Die Materialsummen stimmen nicht mit den errechneten Verpackungsgewichten überein. Ein Verpackungsstand wird erst belastbar, wenn jede Stufe exakt aufgeht.",
  "error.invalid_net_weight": "Dieses Nettogewicht ist kein gültiger Wert.",
  "error.invalid_operator": "Diesen Vergleich kennt HOMEBASE nicht.",
  "error.invalid_origin_country": "Ein Ursprungsland besteht aus zwei Großbuchstaben.",
  "error.invalid_parameter": "Dieser Parameterwert ist unzulässig.",
  "error.invalid_payment_amount": "Ein Zahlbetrag ist eine Zahl größer als null.",
  "error.invalid_relation": "Diese Beziehung ist unzulässig.",
  "error.invalid_roles": "Diese Rollenangabe ist unzulässig.",
  "error.invalid_standard": "Diese Norm ist unzulässig.",
  "error.invalid_supplier": "Diesen Lieferanten gibt es nicht.",
  "error.invalid_swift": "Ein SWIFT/BIC hat acht oder elf Stellen aus Buchstaben und Ziffern.",
  "error.invalid_target": "Dieses Ziel ist unzulässig.",
  "error.invalid_tariff": "Diese Zolltarifnummer ist unzulässig.",
  "error.invalid_tariff_code": "Diese Zolltarifnummer ist unzulässig.",
  "error.invalid_transport_mode": "Diese Transportart kennt HOMEBASE nicht.",
  "error.minimum_margin_forbidden": "Eine Mindestmarge ist an dieser Stelle nicht vorgesehen.",
  "error.model_release_conflicts": "Die Freigabe steht im Widerspruch zu bestehenden Ausführungen.",
  "error.no_article": "Dazu gibt es keinen Artikel.",
  "error.no_family": "Dazu gibt es keine Produktfamilie.",
  "error.no_model": "Dazu gibt es kein Produktmodell.",
  "error.no_model_value": "Dazu gibt es keinen gemeinsamen Modellwert.",
  "error.no_parameter_set": "Dazu gibt es keinen Parametersatz.",
  "error.no_rule": "Dazu gibt es keine Regel.",
  "error.no_such_finding": "Diesen Befund gibt es nicht.",
  "error.no_template": "Dazu gibt es keine Vorlage.",
  "error.not_a_variant": "Dieses Merkmal ist keine Variantenachse.",
  "error.not_in_trash": "Dieser Datensatz liegt nicht im Papierkorb.",
  "error.not_latest_revision": "Dieser Stand ist nicht der aktuelle. Bitte zuerst neu laden.",
  "error.note_empty": "Eine Notiz ohne Text ist keine Notiz.",
  "error.nothing_selected": "Es ist nichts ausgewählt.",
  "error.operator_not_allowed": "Dieser Vergleich ist hier nicht zulässig.",
  "error.payment_amount_required": "Eine Zahlung braucht einen Betrag.",
  "error.payment_currency_required": "Eine Zahlung braucht eine Währung.",
  "error.preferred_channel_missing": "Der bevorzugte Kanal ist bei diesem Ansprechpartner nicht hinterlegt.",
  "error.primary_inactive": "Eine stillgelegte Angabe kann nicht der Standard sein.",
  "error.relation_in_use": "Diese Beziehung ist in Gebrauch und lässt sich nicht entfernen.",
  "error.release_exists": "Dazu gibt es bereits eine Freigabe.",
  "error.structure_incomplete": "Dieser Struktur fehlt eine Pflichtangabe.",
  "error.unit_not_allowed": "Diese Einheit ist hier nicht zulässig.",
  "error.unknown_channel": "Diesen Kontaktkanal kennt HOMEBASE nicht.",
  "error.unknown_payment_kind": "Diese Zahlungsart kennt HOMEBASE nicht.",
  "error.unknown_payment_method": "Diesen Zahlungsweg kennt HOMEBASE nicht.",
  "error.invalid_stage": "Die genannte Zahlungsstufe ist keine Kennung.",
  "error.no_payment_terms": "Für diese Bestellung gilt kein Zahlungsplan — es gibt keine Stufe, der eine Zahlung zugeordnet werden könnte.",
  "error.stage_not_in_plan": "Diese Stufe gehört nicht zum Zahlungsplan, der für diese Bestellung gilt.",
  "error.unknown_unit": "Diese Einheit kennt HOMEBASE nicht.",
  "error.unknown": "Unbekannter Fehler.",
  "error.network": "Server nicht erreichbar.",
  "error.unauthenticated": "Anmeldung erforderlich.",
  "error.forbidden": "Für diese Aktion fehlt die Berechtigung.",
  "error.invalid_credentials": "Anmeldung fehlgeschlagen.",
  "error.too_many_attempts": "Zu viele Versuche. Bitte in {minutes} Minuten erneut versuchen.",
  "error.too_many_attempts_one": "Zu viele Versuche. Bitte in einer Minute erneut versuchen.",
  "error.bad_request": "Die Eingabe ist unvollständig oder fehlerhaft.",
  "error.not_found": "Nicht gefunden.",
  /* Kein Fehler des Benutzers, sondern eine Frage an ihn: welcher
     Stand soll abgeloest werden? Der Satz sagt deshalb, was zu tun
     ist, und nicht nur, was nicht ging. */
  "error.unknown_anchor_kind":
    "Ein Bezugspunkt liegt entweder an einem Termin oder an einer Zahlung.",
  "error.unknown_payment_anchor": "Diesen Zahlungsbezug kennt HOMEBASE nicht.",
  "error.anchor_ambiguous":
    "Eine Lieferzeitregel ankert auf einem Termin ODER auf einer Zahlung \u2013 nicht auf beidem.",
  "error.china_name": "Ein China-Ereignis braucht eine Bezeichnung.",
  "error.china_span":
    "Ein China-Ereignis braucht Beginn und Ende; bei einem eintägigen Fest zweimal denselben Tag.",
  "error.china_lead": "Vorlauf und Nachlauf sind Tage ab null.",
  "error.china_status": "Ein Kerndatum ist entweder amtlich bestätigt oder vorläufig.",
  "error.china_doppelt": "Dieses Ereignis steht mit diesem Beginn bereits da.",
  "error.group_occupied":
    "In diesem Fach gilt bereits ein Stand. Legen Sie die Datei als neue Fassung ab \u2013 "
    + "dann bleibt der bisherige Stand als ältere Fassung erhalten.",
  "error.open_range_dimension": "Eine Variantenachse braucht einen bestimmten Wert oder einen vollständigen Bereich. Eine offene Grenze wie „ab 85“ beschreibt keine Ausführung.",
  "error.invalid_angle": "Ein Abstrahlwinkel braucht einen Wert. Ein zweiter Wert beschreibt eine asymmetrische Optik (30° × 70°) — eine Zoomspanne braucht beide Grenzen.",
  "error.article_in_use": "Dieser Artikel ist bereits einer Ausführung dieses Produktmodells zugeordnet.",
  "error.article_is_placeholder": "Ein Platzhalter ist keine SKU. Er kann keiner Ausführung zugeordnet werden.",
  "error.article_not_assigned": "Dieser Artikel gehört zu keiner Ausführung dieses Produktmodells.",
  "error.confirmation_required": "Dieser Schritt muss ausdrücklich bestätigt werden.",
  "error.dimension_in_use": "Auf dieser Variantenachse liegen noch Werte von Ausführungen. Zuerst die Ausführungen anpassen.",
  "error.duplicate_dimension": "Dieses Merkmal ist an diesem Produktmodell bereits eine Variantenachse.",
  "error.family_mismatch": "Artikel und Produktmodell gehören zu verschiedenen Produktfamilien.",
  "error.focus_needs_article": "Ein Schwerpunkt lässt sich nur an einer Ausführung mit Artikel setzen.",
  "error.invalid_focus": "Dieser Schwerpunktwert ist nicht zulässig.",
  "error.invalid_model": "Produktmodell erforderlich.",
  "error.invalid_provenance": "Diese Herkunft ist nicht zulässig.",
  "error.invalid_transition": "Dieser Übergang ist von hier aus nicht möglich.",
  "error.model_in_use": "An diesem Produktmodell hängen noch Ausführungen, Artikel, Texte, Merkmale, Dokumente, Verpackungsstände oder Informationsanfragen.",
  "error.value_in_use": "Diesen Wert tragen noch Ausführungen. Zuerst die Ausführungen anpassen.",
  "error.variant_exists": "Diese Kombination von Achsenwerten gibt es an diesem Produktmodell bereits.",
  // Produktdokumente. Die Codes stammen aus `core/dokumente.ts`.
  "error.document_too_large": "Die Datei ist zu groß. Höchstens 20 MB.",
  "error.document_type_unsupported": "Diese Dateiart wird nicht abgelegt. Erlaubt sind PDF, IES, LDT, TXT, ZIP, PNG und JPG.",
  "error.document_name_too_long": "Der Dateiname ist zu lang.",
  "error.model_required": "Diese Ausführung gehört zu keinem Produktmodell. Ein Dokument für alle Ausführungen braucht eines.",
  "error.conflict": "Der Stand hat sich inzwischen geändert. Bitte die Ansicht neu laden.",
  "error.method_not_allowed": "Diese Aktion ist hier nicht zulässig.",
  "error.internal_error": "Interner Fehler.",
  "error.weak_password": "Das Passwort muss mindestens {n} Zeichen lang sein und darf nicht mit Leerzeichen beginnen oder enden.",
  "error.password_mismatch": "Die beiden Eingaben des neuen Passworts stimmen nicht überein.",
  "error.current_password_wrong": "Das aktuelle Passwort ist nicht richtig.",
  "error.invalid_role": "Die Rolle muss Administrator oder Viewer sein.",
  "error.invalid_username": "Benutzername: 3 bis 32 Zeichen, Kleinbuchstaben, Ziffern, Punkt, Bindestrich, Unterstrich, beginnend mit einem Buchstaben.",
  "error.invalid_name": "Ein Anzeigename ist erforderlich.",
  "error.username_taken": "Dieser Benutzername ist bereits vergeben.",
  "error.role_missing": "Die Rolle ist im Datenbestand nicht vorhanden.",
  "error.not_editable": "Dienstkonten werden hier nicht verwaltet.",
  "error.self_demotion": "Die eigene Adminrolle kann nicht abgegeben werden.",
  "error.self_deactivation": "Das eigene Konto kann nicht gesperrt werden.",
  "error.last_admin": "Es muss mindestens ein aktiver Administrator bestehen bleiben.",
  "error.reserved_username": "Dieser Benutzername gehört zum Namensraum automatisierter Tests und ist nicht zulässig.",
  // ── Produktfamilien ────────────────────────────────────────────────────
  "nav.families": "Produktfamilien",
  "families.search": "Suche",
  "families.searchPlaceholder": "Produktfamilie suchen …",
  "families.countLabel": "Produktfamilien",
  "families.title": "Produktfamilien",
  "families.colFamilies": "Produktfamilien",
  "sl.categories": "Hauptkategorien",
  "sl.category": "Hauptkategorie",
  "sl.family": "Produktfamilie",
  "sl.categoryDetailAria": "Hauptkategorie – Detail",
  "sl.title": "Lebenszyklus der {art}",
  "sl.stateActive": "aktiv",
  "sl.stateArchived": "archiviert",
  "sl.stateTrashed": "im Papierkorb",
  "sl.stateFilter": "Zustand",
  "sl.filterActive": "Nur aktive",
  "sl.filterArchived": "Nur archivierte",
  "sl.filterTrashed": "Nur Papierkorb",
  "sl.filterAll": "Alle Zustände",
  "sl.emptyTitle": "Nichts in diesem Zustand",
  "sl.emptyHint": "Wähle einen anderen Zustand – archivierte und weggeräumte Strukturen bleiben erhalten.",
  "sl.noDependants": "Nichts hängt daran – diese Struktur lässt sich endgültig löschen, wenn sie im Papierkorb liegt.",
  "sl.dependants": "Daran hängen: {list}.",
  "sl.name": "Name",
  "sl.code": "Kennung",
  "sl.codeFree": "Änderbar, solange nichts daran hängt.",
  "sl.codeLocked": "Gesperrt: die Kennung ist der Schlüssel der Anzeigenamen und der Importzuordnungen. Der Name lässt sich jederzeit korrigieren.",
  "sl.archive": "Archivieren",
  "sl.reactivate": "Wieder aufnehmen",
  "sl.toTrash": "In den Papierkorb",
  "sl.restore": "Wiederherstellen",
  "sl.archiveExplains": "Archivieren löscht nichts: bestehende Modelle, Artikel und Texte bleiben; die Struktur wird nur bei Neuanlagen nicht mehr angeboten.",
  "sl.purgeOpen": "Endgültig löschen …",
  "sl.purgeText": "Die {art} {code} wird endgültig gelöscht. Das lässt sich nicht rückgängig machen; das Protokoll behält Kennung, Name, Person und Zeitpunkt.",
  "sl.purgeLosing": "Damit verschwinden auch: {list}.",
  "sl.purgeConfirmLabel": "Zur Bestätigung {code} eintippen",
  "sl.purge": "Endgültig löschen",
  "families.emptyTitle": "Keine Produktfamilie gefunden",
  "families.emptyHint": "Suchbegriff oder Kategorie anpassen.",
  "families.colName": "Produktfamilie",
  "families.colCategory": "Produktkategorie",
  "families.colArticles": "Artikel",
  "families.detailAria": "Detail der Produktfamilie",
  "families.code": "Kennung",
  "families.legacyAlias": "Historische Bezeichnung",
  "families.articles": "Zugeordnete Artikel",
  "families.noArticles": "Dieser Produktfamilie ist kein Artikel zugeordnet.",
  "families.primarySplit": "({primary} primär, {secondary} weitere Beziehung)",
  "families.secondary": "weitere Beziehung",
  "families.secondaryHint": "Dieser Artikel gehört primär zu einer anderen Produktfamilie.",
  "texts.emptyFamily": "Für diese Produktfamilie sind noch keine Texte hinterlegt.",
  // ── Redaktionelle Produkttexte ─────────────────────────────────────────
  "texts.section": "Texte",
  "texts.loading": "Texte werden geladen …",
  "texts.emptyAll": "Für diesen Artikel sind noch keine Texte hinterlegt.",
  "texts.noLocaleLang": "Keine Fassung auf {language}.",
  "texts.otherLangAvailable": "Auf {language} ist eine Fassung vorhanden.",
  "texts.formLanguage": "Fassung auf {language}",
  "texts.details": "Details",
  "texts.sourceOwn": "eigener Text dieser SKU",
  "texts.sourceRule": "regelgeneriert",
  "texts.sourceRuleNote": "Diese Zeile ist nicht gespeichert. HOMEBASE bildet sie aus der Auswahlmatrix der Produktfamilie und zeigt sie im Produktkopf.",
  "texts.sourceRuleAdopt": "Beim Anlegen steht sie bereits im Feld und kann übernommen oder geändert werden.",
  "texts.sourceRuleLang": "Die Regel bildet diese Zeile auf {language}. Eine Fassung in der gewählten Sprache beginnt bei null.",
  "texts.unresolved": "Nicht aufgelöste Platzhalter: {list}",
  "texts.unresolvedHint": "Der geerbte Textbaustein des Produktmodells wurde mit den Werten dieser Ausführung gefüllt. Für diese Platzhalter fehlt der Wert am Artikel — sie bleiben stehen, statt durch eine erfundene Angabe ersetzt zu werden.",
  "texts.statusAfterSave": "Prüfen, Freigeben und Zurücksetzen stehen wieder bereit, sobald die Änderung gespeichert oder verworfen ist.",
  "texts.inheritedFrom": "geerbt von der Produktfamilie {name}",
  "texts.original": "Original",
  "texts.translatedFrom": "übersetzt aus {language}",
  "texts.sourceChanged": "Das Original wurde seither geändert",
  "texts.writeOwn": "Eigenen Text für diese SKU schreiben",
  "texts.releasedBy": "freigegeben von {name} am {date}",
  "texts.basisChanged": "Textgrundlage geändert",
  "texts.basisChangedHint": "Seit der Freigabe hat sich die fachliche Grundlage dieser SKU geändert. Der Text wurde nicht verändert — er sollte geprüft werden.",
  "texts.markReview": "Zur Prüfung stellen",
  "texts.basisTitle": "Textgrundlage dieser SKU",
  "texts.basisNote": "Was über genau diese Ausführung feststeht. Grundlage für einen Produkttext — und später für die Texterzeugung.",
  "texts.basisShow": "Textgrundlage anzeigen",
  "texts.basisHide": "Textgrundlage ausblenden",
  "texts.basisCategory": "Hauptkategorie",
  "texts.basisFamily": "Produktfamilie",
  "texts.basisModel": "Produktmodell",
  "texts.basisNumber": "Artikelnummer",
  "texts.basisExecution": "Ausführung",
  "texts.basisProperties": "Merkmale dieser SKU",
  "texts.basisEmptyExecution": "Diese SKU ist keiner Ausführung eines Produktmodells zugeordnet.",
  "texts.basisEmptyProperties": "Für diese SKU sind keine Merkmale erfasst.",
  "texts.basisFingerprint": "Abdruck",
  "texts.basisGenerateLater": "Eine Texterzeugung aus dieser Grundlage ist vorbereitet, aber noch nicht angeschlossen.",
  "texts.edit": "Bearbeiten",
  "texts.editAria": "{type} auf {language} bearbeiten",
  "texts.add": "Fassung anlegen",
  "texts.addAria": "{type} auf {language} anlegen",
  "texts.addFirst": "Text anlegen",
  "texts.save": "Speichern",
  "texts.saving": "Wird gespeichert …",
  "texts.remove": "Fassung entfernen",
  "texts.removeConfirm": "Sprachfassung wirklich entfernen? Der Text ist danach in dieser Sprache nicht mehr vorhanden.",
  "texts.origin": "Herkunft",
  "texts.method": "Entstehung",
  "texts.supplier": "Supplier",
  "texts.isOriginal": "Dies ist die Originalfassung",
  "texts.charsUsed": "{used} von {max} Zeichen",
  "texts.markReviewed": "Als geprüft markieren",
  "texts.release": "Freigeben",
  "texts.backToDraft": "Zurück auf Entwurf",
  "texts.editedResetsStatus": "Eine geänderte Fassung geht zurück auf Entwurf.",
  "textType.artikelname": "Artikelname",
  "textType.kurzbeschreibung": "Kurzbeschreibung",
  "textType.langtext": "Langtext",
  "textType.ausschreibungstext": "Ausschreibungstext",
  "textType.anwendung": "Anwendung",
  "textType.hinweis": "Hinweis",
  "textStatus.entwurf": "Entwurf",
  "textStatus.geprueft": "Geprüft",
  "textStatus.freigegeben": "Freigegeben",
  "textStatus.pruefung_noetig": "Prüfung erforderlich",
  "textOrigin.supplier": "Supplier",
  "textOrigin.intern": "intern erstellt",
  "textOrigin.import": "importiert",
  "textOrigin.extern": "externe Quelle",
  "textMethod.erfasst": "originär erfasst",
  "textMethod.uebernommen": "unverändert übernommen",
  "textMethod.uebersetzt_manuell": "manuell übersetzt",
  "textMethod.uebersetzt_ki": "KI-übersetzt",
  "textMethod.erzeugt_ki": "KI-erzeugt",
  "textMethod.erzeugt_ki_bearbeitet": "KI-erzeugt, redaktionell überarbeitet",
  "textLang.de": "Deutsch",
  "textLang.en": "Englisch",
  "error.empty_body": "Ein leerer Text ist keine Sprachfassung.",
  "error.body_too_long": "Der Text ist für diesen Texttyp zu lang.",
  "error.invalid_language": "Unbekannte Sprache.",
  "error.invalid_text_type": "Unbekannter Texttyp.",
  "error.invalid_subject": "Genau ein Bezug erforderlich: Artikel oder Produktfamilie.",
  "error.level_not_allowed": "Dieser Texttyp wird auf dieser Ebene nicht geführt.",
  "error.first_must_be_original": "Die erste Sprachfassung eines Textes ist die Originalfassung.",
  "error.text_exists": "Zu diesem Bezug besteht bereits ein Text dieses Typs.",
  "error.original_not_translated": "Eine Originalfassung kann nicht übersetzt sein.",
  "error.invalid_origin": "Unbekannte Herkunft.",
  "error.invalid_method": "Unbekannte Entstehungsmethode.",
  "error.invalid_status": "Unbekannter Status.",
  "error.supplier_required": "Bei Supplier-Herkunft ist der Supplier anzugeben.",
  "error.supplier_not_allowed": "Ein Supplier gehört nur zu einer Supplier-Herkunft.",
  "error.source_missing": "Die angegebene Vorlagefassung existiert nicht.",
  "error.source_in_use": "Auf diese Fassung verweisen Übersetzungen. Sie kann nicht entfernt werden.",
  "error.review_required": "Eine Fassung wird erst geprüft und dann freigegeben.",
  "error.never_released": "Zur Prüfung fällt nur, was einmal freigegeben war.",
  // ── Kontrollierte Fachterminologie (TERMINOLOGY_DE_EN.md) ──────────────
  //
  // Ein gespeicherter Fachwert wird hier NICHT veraendert -- nur seine
  // Anzeige. Es stehen ausschliesslich die Werte hier, die einen Gegenstand
  // BESCHREIBEN. Was ihn BENENNT -- HighBay, HB PRO, RetroFix, OFFICE -- ist
  // sprachneutral und taucht in keinem Woerterbuch auf.
  "category.notlicht": "Notlicht",
  "category.komponenten": "Komponenten",
  "family.Treiber": "Treiber",
  "family.LED-Notlichtbeleuchtung": "LED-Notlichtbeleuchtung",
  "provenance.quelle": "Quelle",
  "provenance.abgeleitet": "Abgeleitet",
  "provenance.bestaetigt": "Bestätigt",
  // ── Technische Merkmale ────────────────────────────────────────────────
  "props.section": "Technische Merkmale",
  "props.loading": "Merkmale werden geladen …",
  "props.empty": "Für diesen Artikel sind noch keine technischen Merkmale erfasst.",
  "props.emptyFamily": "Für diese Produktfamilie sind noch keine Merkmale erfasst.",
  "props.add": "Merkmal hinzufügen",
  "sdb.countArticles": "Artikel",
  "sdb.countWithNeed": "davon mit Datenbedarf",
  "sdb.countItems": "offene Angaben",
  "sdb.countQuestions": "offene Fragen",
  "sdb.hint": "Was hier steht, ist gerechnet und nicht gespeichert: fehlende Informationen, die ein Lieferant grundsätzlich beantworten kann. Es ist noch keine Beschaffungsentscheidung und noch keine Anfrage.",
  "sdb.noArticles": "Diesem Partner ist kein Produkt zugeordnet. Damit gibt es auch nichts zu beschaffen.",
  "sdb.noNeed": "An den Produkten dieses Lieferanten fehlt keine Information, die er beantworten könnte.",
  "sdb.viewAria": "Ansicht wählen",
  "sdb.byQuestion": "Nach Frage",
  "sdb.byProduct": "Nach Produkt",
  "sdb.oneQuestion": "1 offene Frage",
  "sdb.nQuestions": "{n} offene Fragen",
  "sdb.selectAll": "Alle auswählen",
  "sdb.selectNone": "Auswahl aufheben",
  "sdb.selected": "{n} ausgewählt",
  "sdb.createOutput": "Ausgabe erstellen",
  "sdb.outputTitle": "Ausgabe für den Lieferanten",
  "sdb.outputHint": "Englisch, weil der Text an den Lieferanten geht. Er entsteht aus der aktuellen Auswahl und wird nirgends gespeichert — es ist keine Anfrage und kein Vorgang.",
  "sdb.copy": "In Zwischenablage kopieren",
  "sdb.copied": "kopiert",
  "sdb.supplierItemNo": "Lieferantennummer {nr}",
  "sdb.recommended": "empfohlen",
  "sdb.oneArticle": "1 Artikel",
  "sdb.nArticles": "{n} Artikel",
  "reqGroup.grundriss": "Grundmaß (Länge und Breite oder Durchmesser)",
  "reqPurpose.stammdaten": "Stammdaten",
  "reqPurpose.text": "Text",
  "reqPurpose.compliance": "Konformität",
  "reqPurpose.kalkulation": "Kalkulation",
  "reqPurpose.logistik": "Logistik",
  "req.supplierObtainable": "beim Lieferanten beschaffbar",
  "req.missing": "fehlt",
  "req.requested": "angefragt",
  "req.notApplicable": "nicht anwendbar",
  "req.derived": "aus Lichtstrom und Leistung abgeleitet",
  "req.add": "Information ergänzen",
  "props.edit": "Bearbeiten",
  "props.editAria": "{name} bearbeiten",
  "props.confirmAria": "{name} fachlich bestätigen",
  "props.unconfirmAria": "Bestätigung für {name} zurücknehmen",
  "props.remove": "Entfernen",
  "props.removeConfirm": "Diesen Merkmalswert wirklich entfernen?",
  "props.save": "Speichern",
  "props.saving": "Wird gespeichert …",
  "props.confirm": "Fachlich bestätigen",
  "props.unconfirm": "Bestätigung zurücknehmen",
  "props.confirmHint": "Eine Wertänderung nimmt die Bestätigung zurück.",
  "props.value": "Wert",
  "props.valueFrom": "von",
  "props.valueTo": "bis",
  "props.origin": "Herkunft",
  "props.method": "Entstehung",
  "props.findingModel": "Modellabweichung",
  "props.findingConflict": "Widerspruch zur Zweitquelle",
  "props.findingDte": "DTE ist nachzuziehen",
  "props.proposalCurrent": "Aktuell",
  "props.proposalNew": "Neue Referenz",
  "props.proposalAccept": "Neue Referenz übernehmen",
  "props.proposalReject": "Aktuellen Wert behalten",
  "props.proposalAlready": "Dieser Wert gilt bereits — der Vorschlag ist gegenstandslos.",
  "props.proposalHint": "Die Entscheidung wird mit Person und Zeitpunkt festgehalten. Fachlich bestätigen gilt dem bestehenden Wert und ist etwas anderes.",
  "props.proposalPending": "Der bestehende Wert bleibt unverändert, bis jemand entscheidet. Ein Entscheidungsweg in der Oberfläche fehlt noch.",
  "stock.title": "Bestand",
  "opz.aria": "Operativer Stand",
  "split.label": "Breite der Produktliste",
  "split.hint": "Ziehen verändert die Breite · Doppelklick setzt sie zurück",
  "opz.offers": "Angebote 12M",
  "opz.offersHalfYear": "davon in den letzten 6 Monaten: {n}",
  "opz.ordered": "Bestellt",
  "opz.eta": "ETA LG",
  "opz.undetermined": "nicht bestimmt",
  "stock.pieces": "Stück",
  "stock.asOf": "Stand",
  "stock.source": "Quelle",
  "stockSource.dte-lager": "DTE-Lagerbericht",
  "overview.parts": "Bestückung",
  "overview.component": "Verbaute Komponente",
  "overview.breaker": "Leuchten je LS {characteristic}{current} A",
  "overview.breakerUnit": "Leuchten",
  "props.sourceSegment": "Quellangabe",
  "props.chooseProperty": "Merkmal",
  "props.chooseValue": "Wert wählen",
  "props.yes": "ja",
  "props.no": "nein",
  "props.familyNote": "Merkmale der Produktfamilie. Sie gelten für die Familie und werden nicht auf Artikel übertragen.",
  "propGroup.lichttechnik": "Lichttechnik",
  "propGroup.elektrik": "Elektrik / Steuerung",
  "propGroup.schutz": "Schutz / Qualität",
  "propGroup.konformitaet": "Zertifizierungen, Konformitäten & Nachweise",
  "propGroup.mechanik": "Mechanik / Maße",
  "propGroup.optik": "Optik / Funktionen",
  "propGroup.identitaet": "Identität / Herkunft",
  "prop.power": "Leistung",
  "prop.luminous_flux": "Lichtstrom",
  "prop.efficacy": "Lichtausbeute",
  "prop.cct": "Farbtemperatur",
  "prop.light_colour": "Lichtfarbe",
  "prop.cct_tunable": "einstellbare Farbtemperatur",
  "prop.cri": "Farbwiedergabewert",
  "prop.sdcm": "Farbkonsistenz",
  "prop.ugr": "Blendwert / UGR",
  "prop.control_gear": "Steuerung",
  "prop.dimmable": "dimmbar",
  "prop.ip_rating": "IP-Klassifikation",
  "prop.ik_rating": "IK-Klassifikation",
  "prop.certification": "Zertifizierungen, Konformitäten & Nachweise",
  "prop.length": "Länge",
  "prop.width": "Breite",
  "prop.height": "Höhe",
  "prop.diameter": "Durchmesser",
  "prop.cutout_size": "Ausschnittmaß",
  "prop.weight": "Produktgewicht",
  "prop.housing_material": "Gehäusematerial",
  "prop.housing_colour": "Gehäusefarbe",
  "prop.beam_angle": "Abstrahlwinkel",
  "prop.sensor": "Sensorik",
  "prop.emergency_duration": "Notlichtdauer",
  "propValue.nw": "Neutralweiß",
  "propValue.ww": "Warmweiß",
  "propValue.tl": "Tageslicht",
  "propValue.ww+": "Warmweiß+",
  "propValue.tl+": "Tageslicht+",
  "propValue.IP40": "IP40",
  "propValue.IP65": "IP65",
  "propValue.IP66": "IP66",
  "propValue.IP69K": "IP69K",
  "propValue.IK08": "IK08",
  "propValue.IK09": "IK09",
  "propValue.IK10": "IK10",
  "propValue.on_off": "Ein/Aus",
  "propValue.triac": "TRIAC",
  "propValue.analog_1_10v": "1-10 V",
  "propValue.dali": "DALI",
  "propValue.dali_2": "DALI 2",
  "propValue.dali_push": "DALI Push",
  "propValue.atex": "ATEX",
  "propValue.ifs": "IFS",
  "propValue.ce_lvd": "CE (LVD)",
  "propValue.ce_emc": "CE (EMC)",
  "propValue.rohs": "RoHS",
  "propValue.tuev": "TÜV",
  "propValue.enec": "ENEC",
  "propValue.d_mark": "D-MARK",
  "propValue.nsf": "NSF",
  "propValue.haccp": "HACCP",
  "propValue.sosen": "SOSEN",
  "propValue.lifud": "LIFUD",
  "propValue.boke": "BOKE",
  "propValue.kgp": "KGP",
  "propValue.eaglerise": "EAGLERISE",
  "propValue.polycarbonat": "Polycarbonat",
  "propValue.aluminium": "Aluminium",
  "propValue.aluminium_druckguss": "Aluminium-Druckguss",
  "propValue.weiss": "weiß",
  "propValue.ral9016": "weiß (RAL 9016)",
  "propValue.schwarz": "schwarz",
  "propValue.silber": "silber",
  "propValue.daylight": "Tageslichtsensor",
  "propValue.motion": "Bewegungssensor",
  "propMethod.erfasst": "erfasst",
  "propMethod.uebernommen": "unverändert übernommen",
  "propMethod.extrahiert": "aus Freitext gewonnen",
  "propMethod.abgeleitet": "abgeleitet",
  "error.invalid_definition": "Unbekanntes Merkmal.",
  "error.invalid_number": "Bitte nur eine Zahl angeben — ohne Einheit.",
  "error.invalid_boolean": "Für dieses Merkmal ist ein Wahrheitswert erforderlich.",
  "error.invalid_enum": "Dieser Wert gehört nicht zum Wertevorrat des Merkmals.",
  "error.invalid_range": "Die untere Grenze liegt über der oberen.",
  "error.invalid_value": "Der Wert passt nicht zum Wertetyp des Merkmals.",
  "error.invalid_quality": "Unbekannter Qualitätsstatus.",
  "error.out_of_range": "Der Wert liegt außerhalb des zulässigen Bereichs.",
  "error.not_multi": "Dieses Merkmal trägt nur einen Wert.",
  "error.value_exists": "Zu diesem Bezug besteht bereits ein Wert dieses Merkmals.",
  "error.empty_value": "Ein leerer Wert ist kein Wert.",
  "error.share_sum": "Die Anteile eines Zahlungsplans ergeben zusammen 100 %.",
  "error.invalid_share": "Ein Anteil liegt über 0 und höchstens bei 100 %.",
  "error.unknown_event": "Dieses Zahlungsereignis steht nicht im Katalog.",
  "error.invalid_offset": "Eine Frist ist eine ganze Zahl ab 0 Tagen.",
  "error.offset_required": "Dieses Zahlungsereignis braucht eine Frist in Tagen.",
  "error.offset_not_allowed": "Dieses Zahlungsereignis kennt keine Frist.",
  "error.invalid_rating": "Eine Bewertung liegt zwischen 1,0 und 5,0 und geht in halben Schritten.",
  "error.asymmetric_beam_angle": "Ein asymmetrischer Abstrahlwinkel ist kein Bereich und wird nicht umgedeutet.",
  // ── Beschriftungen technischer Codes ───────────────────────────────────
  // Diese Codes stehen so in der Datenbank. Uebersetzt wird die ANZEIGE,
  // der gespeicherte Wert bleibt unveraendert.
  "lifecycle.aktiv": "Aktiv",
  "lifecycle.auslaufend": "Auslaufend",
  "lifecycle.inaktiv": "Inaktiv",
  "lifecycle.nicht_freigegeben": "Nicht freigegeben",
  "quality.belastbar": "belastbar",
  "quality.warnung": "Warnung",
  "quality.pruefung_erforderlich": "Prüfung erforderlich",
  "articleRole.hauptprodukt": "Hauptprodukt",
  "articleRole.komponente": "Komponente",
  "articleRole.zubehoer": "Zubehör",
  "articleRole.ersatzteil": "Ersatzteil",
  "articleRole.option": "Option",
  "flag.erststatus_zu_pruefen": "Erststatus zu prüfen",
  "flag.produktfamilie_zu_pruefen": "Produktfamilie zu prüfen",
  "flag.rolle_zu_pruefen": "Artikelrolle zu prüfen",
  "flag.zollsatz_zu_pruefen": "Zollsatz zu prüfen",
  "flag.verpackungsdaten_fehlen": "Verpackungsdaten fehlen",
  "flag.artikelnummer_konflikt": "Artikelnummernkonflikt",
  "flag.supplier_schreibweise": "Supplier-Schreibweise",
  "flag.fracht_ohne_volumen": "Fracht ohne Volumen",
  "flag.platzhalter_zu_pruefen": "Platzhalter zu prüfen",
  // ── Produktmodell- und Variantenebene ──────────────────────────────────
  //
  // Fachliche Quelle der Begriffe: PRODUCT_DATA_MODEL.md, Abschnitte 2, 3,
  // 22 und 23; kontrollierte DE/EN-Terminologie: TERMINOLOGY_DE_EN.md.
  "nav.models": "Produktmodelle",
  "models.loading": "Produktmodelle werden geladen \u2026",
  "models.search": "Suche",
  "models.searchPlaceholder": "Modellcode, Modellname oder Produktfamilie suchen \u2026",
  "models.countLabel": "Produktmodelle",
  "models.emptyTitle": "Keine Produktmodelle vorhanden",
  "models.emptyHint": "Die Produktmodellebene ist verfügbar, aber nicht erzwungen. Ein Artikel darf ohne Produktmodell bestehen.",
  "models.create": "Produktmodell anlegen",
  "models.detailAria": "Produktmodelldetail",
  "models.fallbackTitle": "Produktmodell",
  "models.logistics": "Logistik & Zoll",
  "models.logisticsNote": "Gilt für jede Ausführung dieses Modells, die keine eigene Angabe trägt. Eine eigene Angabe an der SKU geht vor.",
  "models.editTariff": "Tarifnummer bearbeiten",
  "models.tariffHint": "Nur Ziffern, führende Nullen bleiben erhalten. Leer lassen entfernt die Nummer am Modell; SKUs mit eigener Nummer bleiben unberührt.",
  "models.code": "Modellcode",
  "models.name": "Modellname",
  "models.colModel": "Produktmodell",
  "models.colFamily": "Produktfamilie",
  "models.colVariants": "Ausführungen",
  "models.colMaterialised": "SKUs",
  "models.confirm": "Fachlich bestätigen",
  "models.unconfirmed": "nicht bestätigt",
  "models.unconfirmedTitle": "Regelbasiert vorgeschlagen, fachlich noch nicht bestätigt.",
  "models.choose": "bitte wählen",
  "models.dimensions": "Ausführungsmerkmale",
  "models.dimensionsNote": "Merkmale, durch die sich die angebotenen Ausführungen unterscheiden. Werte, die sich aus einem anderen Merkmal ergeben – etwa die Lichtausbeute je CRI –, gehören nicht hierher.",
  "models.dimensionProperty": "Merkmal der Achse",
  "models.noDimensions": "Für dieses Produktmodell sind noch keine Ausführungsmerkmale festgelegt.",
  "models.addDimension": "Ausführungsmerkmal hinzufügen",
  "models.removeDimension": "Merkmal entfernen",
  "models.removeDimensionConfirm": "Dieses Ausführungsmerkmal wirklich entfernen?",
  "models.noValues": "Für dieses Merkmal ist noch kein zulässiger Wert festgelegt.",
  "models.addValue": "Zulässigen Wert hinzufügen",
  "models.removeValue": "Wert entfernen",
  "models.removeValueConfirm": "Diesen zulässigen Wert wirklich entfernen?",
  "models.valueVariantsTitle": "{count} Ausführungen tragen diesen Wert",
  "models.valueNumber": "Wert",
  "models.valueMin": "von",
  "models.valueMax": "bis",
  "models.valueAngleX": "Abstrahlwinkel X",
  "models.valueAngleY": "Abstrahlwinkel Y (optional)",
  "models.valueCode": "Wert",
  "models.valueText": "Wert",
  "models.variants": "Ausführungen",
  "models.variantsCount": "Ausführungen",
  "models.materialised": "mit Artikelnummer",
  "models.virtual": "ohne Artikelnummer",
  "models.noVariants": "Für dieses Produktmodell ist noch keine Ausführung angelegt.",
  "models.addVariant": "Ausführung hinzufügen",
  "models.editVariant": "Ausführung bearbeiten",
  "models.removeVariant": "Ausführung entfernen",
  "models.removeVariantConfirm": "Diese Ausführung wirklich entfernen? Ein zugeordneter Artikel bleibt bestehen.",
  "models.colVariant": "Ausführung",
  "models.colFocus": "Fokus",
  "models.colPrice": "Listenpreis",
  "models.colAvailability": "Verfügbarkeit",
  "models.priceValidFrom": "freigegeben gültig ab {date}",
  "models.colDte": "DTE",
  "models.colActions": "Aktionen",
  "models.virtualLabel": "Ausführung ohne Artikelnummer",
  "models.virtualTitle": "Diese Ausführung ist fachlich vorgesehen, besitzt aber noch keinen Artikeldatensatz. Das ist kein Fehler.",
  "models.noDteTitle": "Ohne Artikeldatensatz gibt es keinen DTE-Status — nicht „nicht gelistet\u201c.",
  "models.focusRank": "Fokus {rank}",
  "models.focusTitle": "Fokusvariante. Fokus ist eine bewusste geschäftliche Priorisierung und entsteht niemals automatisch.",
  "models.focus": "Fokusrang",
  "models.focusPlaceholder": "leer = kein Fokus",
  "models.focusNote": "Fokus wird gesetzt und niemals aus Bestand, Umsatz, Bestellhistorie oder DTE-Status abgeleitet. Er setzt eine materialisierte SKU voraus.",
  "models.sku": "SKU",
  "models.notMaterialised": "ohne Artikelnummer",
  "models.variantLabel": "Bezeichnung",
  "models.placeholders": "Platzhalterdatensätze",
  "models.placeholderBadge": "Platzhalter",
  "models.placeholderTitle": "Die Artikelnummer enthält einen unaufgelösten Dimensionswert. Keine vollständig konkretisierte SKU.",
  "models.placeholderNote": "Diese Datensätze gehören zum Produktmodell, sind aber keine vollständig konkretisierte SKU. Sie werden weder als Variante geführt noch in DTE gelistet.",
  "models.otherArticles": "Zubehör & Komponenten",
  "models.articleSection": "Produktmodell und Systembeziehung",
  "models.model": "Produktmodell",
  "models.noModel": "kein Produktmodell",
  "models.assign": "Zuordnen",
  "models.reassign": "Ändern",
  "models.noModelsInFamily": "In den Produktfamilien dieses Artikels besteht noch kein Produktmodell.",
  "models.variant": "Variante",
  "models.noVariantValues": "keine Achsenwerte gefasst",
  "dte.label": "DTE-Listung",
  "dte.change": "Status ändern",
  "dte.note": "Bemerkung",
  "dte.notePlaceholder": "Bemerkung (bei Fehlschlag erforderlich)",
  "dte.since": "seit {date}",
  "dte.delistConfirm": "Diese SKU wirklich entlisten? Eine Entlistung ist nur zulässig, solange in DTE kein Bestand und keine Bewegung besteht.",
  "dte.notListedNote": "Nicht in DTE gelistet bedeutet: kein Bestandsdatum vorhanden. Es bedeutet nicht Bestand 0.",
  "dte.nicht_gelistet": "nicht gelistet",
  "dte.vorgemerkt": "vorgemerkt",
  "dte.gelistet": "gelistet",
  "dte.fehlgeschlagen": "fehlgeschlagen",
  "props.sectionModel": "Modellmerkmale",
  "props.modelNote": "Ein Modellmerkmal gilt für alle Varianten dieses Modells. Es wird nicht auf die SKUs kopiert — eine SKU zeigt es mit, sie speichert es nicht.",
  "props.emptyModel": "Für dieses Produktmodell sind noch keine Modellmerkmale erfasst.",
  "texts.sectionModel": "Modellweite Textbausteine",
  "texts.noteModel": "Diese Texte beschreiben die Baureihe, nicht eine einzelne Ausführung. Sie gelten nur, wenn die Aussage für ALLE Ausführungen dieses Produktmodells zutrifft. Der Produkttext einer SKU entsteht an der SKU.",
  "texts.emptyModel": "Für dieses Produktmodell sind noch keine modellweiten Textbausteine erfasst.",
  "texts.inheritedFromModel": "geerbt vom Produktmodell {name}",
  "common.yes": "ja",
  "common.no": "nein",
  "common.edit": "Bearbeiten",
  "common.remove": "Entfernen",
  "common.save": "Speichern",
  // ── Pruefwarteschlange der Produktmerkmale ────────────────────────────────
  "nav.cleanup": "Bereinigung",
  "cleanup.title": "Artikelstamm-Bereinigung",
  "cleanup.lead": "Diese Ansicht sagt, wo der gewachsene Artikelstamm noch gepflegt werden muss — Familie für Familie, statt 357 Akten einzeln zu öffnen. Familie wählen, Modell wählen, die realen Artikel prüfen. Bestätigt wird hier nichts: die Entscheidung über einen Wert bleibt in der Produktakte.",
  "cleanup.sumRow": "Alle Familien",
  "cleanup.sumHint": "Summen über alle Produktfamilien — gerechnet aus den Zeilen dieser Tabelle, keine zweite Quelle.",
  "cleanup.chooseModel": "Modell wählen",
  "cleanup.noModels": "Diese Familie führt noch kein Produktmodell.",
  "cleanup.noFamilies": "Keine Produktfamilie mit Artikeln.",
  "cleanup.colFamily": "Produktfamilie",
  "cleanup.colModels": "Modelle",
  "cleanup.colArticles": "Artikel",
  "cleanup.colAssigned": "zugeordnet",
  "cleanup.colUnassigned": "ohne Modell",
  "cleanup.colConflicts": "Konflikte",
  "cleanup.colUnconfirmed": "unbestätigt",
  "cleanup.colFlags": "Hinweise",
  "cleanup.conflictsConfirmedHint": "Davon {n} trotz offenem Widerspruch als belastbar bestätigt.",
  "cleanup.skus": "SKUs dieses Modells ({n})",
  "cleanup.noSkus": "Diesem Modell ist noch kein Artikel zugeordnet.",
  "cleanup.unassigned": "Artikel derselben Familie ohne Modell ({n})",
  "cleanup.unassignedHint": "Diese Artikel gehören zur selben Produktfamilie und tragen noch kein Modell. Das ist KEIN Zuordnungsvorschlag — eine ähnliche Artikelnummer ist kein Beleg. Die Zuordnung erfolgt bewusst in der Produktakte.",
  "cleanup.noUnassigned": "Alle Artikel dieser Familie sind einem Modell zugeordnet.",
  "cleanup.colArticle": "Artikel",
  "cleanup.colDescription": "Bezeichnung (HOMEBASE)",
  "cleanup.colProps": "Merkmale",
  "cleanup.colConflict": "Widerspruch zur Quelle",
  "cleanup.colPrice": "Listenpreis",
  "cleanup.colStock": "Verfügbarkeit / Bestand",
  "cleanup.colSupplier": "Lieferant",
  "cleanup.colOpen": "offen",
  "cleanup.propsHint": "bestätigt / Warnung / Prüfung erforderlich",
  "cleanup.focus": "Fokus {n}",
  "cleanup.confirmedDespite": "bestätigt trotz Widerspruch",
  "cleanup.confirmedDespiteHint": "Der Wert wurde von Hand auf belastbar gesetzt, während dieser Widerspruch offen stand. Das ist eine Entscheidung, kein Fehler — aber sie gehört überprüft.",
  "cleanup.priceValidFrom": "freigegeben gültig ab {date}",
  "cleanup.asOf": "Stand {date}",
  "cleanup.asOfHint": "Quelle {source}. Der Stichtag ist das Datum der Quelldatei, nicht der Importzeitpunkt.",
  "cleanup.proposals": "{n} offene Wertvorschläge",
  "cleanup.infoRequests": "{n} offene Informationsfragen",
  "cleanup.markDte": "DTE-Korrekturbedarf",
  "cleanup.resolve": "erledigt",
  "cleanup.dteNoteLabel": "Was ist in DTE falsch oder veraltet?",
  "cleanup.dteNotePlaceholder": "z. B.: DTE führt 34.000 lm, richtig sind 32.000 lm.",
  "cleanup.dteSave": "Hinweis festhalten",
  "cleanup.cancel": "Abbrechen",
  "cleanup.noDteWrite": "HOMEBASE schreibt nichts nach DTE. Der Hinweis wird hier festgehalten; die Korrektur in DTE erfolgt von Hand.",
  "cleanup.dteScope": "Was sich gegen DTE vergleichen lässt",
  "cleanup.comparable": "vergleichbar",
  "cleanup.notComparable": "nicht vergleichbar — HOMEBASE speichert dazu keinen DTE-Wert",
  "cleanup.field.merkmale": "Technische Merkmale",
  "cleanup.field.bestand": "Bestand",
  "cleanup.field.bezeichnung": "Bezeichnung",
  "cleanup.field.preis": "Preis",
  "cleanup.field.lieferant": "Lieferant",
  "texts.draft": "Entwurf erzeugen",
  "texts.draftTitle": "Bildet einen Entwurf aus der Auswahlmatrix der Produktfamilie bzw. dem Textbaustein des Produktmodells. Der Entwurf wird nicht gespeichert — er erscheint im Eingabefeld.",
  "texts.draftMissing": "Der Entwurf ist unvollständig. Diese Angaben fehlen am Artikel: {list}",
  "texts.draftReady": "Entwurf vollständig aus den strukturierten Werten gebildet. Nichts wurde ergänzt oder formuliert.",
  "textMethod.erzeugt_regel": "regelbasiert gebildet",
  "cleanup.colClassified": "davon eingeordnet",
  "cleanup.classifiedHint": "Zubehör, Ersatzteil oder Komponente — ohne Produktmodell richtig eingeordnet, kein Pflegerückstand.",
  "cleanup.roleNone": "keine Rolle",
  "tk.driverBrand": "Treiber Marke",
  "tk.driverModel": "Treiber Modell",
  "tk.componentOpen": "{number} öffnen",
  "tk.evidenceOpen": "noch nicht bestätigt",
  "tk.evidenceOpenHint": "Der Nachweis ist erfasst, aber fachlich noch nicht bestätigt. Ein Text darf sich erst dann darauf berufen.",
  "tk.evidenceFromDocuments": "Die Eigenschaft ergibt sich aus ihrem Nachweis (Norm) -- gepflegt unter Dokumente.",
  "tk.evidencePartial": "{ok} von {total} Nachweisen geändert. Fehler: {error}",
  "capability.ballwurfsicher": "Ballwurfsicher",
  "prop.surge_line_earth": "Überspannungsschutz line-earth",
  "prop.surge_line_line": "Überspannungsschutz line-line",
  "nav.review": "Merkmalsprüfung",
  "review.title": "Prüfung der Produktmerkmale",
  "review.lead": "Jeder maschinell gewonnene Wert steht hier mit seinem Quellwortlaut und dem Befund der Auswertung. Ein Befund ist eine technische Feststellung — bestätigt wird ein Wert erst durch eine Person.",
  "review.loading": "Merkmalswerte werden geladen …",
  "review.values": "Merkmalswerte",
  "review.search": "Suche",
  "review.searchPlaceholder": "Artikelnummer oder Quellwortlaut …",
  "review.findingClass": "Befundklasse",
  "review.allClasses": "Alle Befundklassen",
  "review.property": "Merkmal",
  "review.allProperties": "Alle Merkmale",
  "review.quality": "Qualitätsstatus",
  "review.allQualities": "Alle Qualitätsstatus",
  "review.role": "Artikelrolle",
  "review.allRoles": "Alle Artikelrollen",
  "review.confirm": "Bestätigen",
  "review.defer": "Zurückstellen",
  "review.edit": "Im Artikel bearbeiten",
  "review.openArticle": "Artikel öffnen",
  "review.emptyTitle": "Keine Merkmalswerte",
  "review.emptyHint": "Zu dieser Auswahl liegt kein Wert vor. Filter zurücksetzen zeigt wieder alle.",
  "review.progressAria": "{done} von {total} Werten fachlich bestätigt",
  "review.runInfo": "Befunde aus dem Auswertungslauf · Quellprüfsumme {checksum} · Zweitquelle {second}",
  "review.noSecondSource": "keine",
  "review.runStale": "Die Kurzbeschreibung hat sich seit der Auswertung geändert — die Befunde sind überholt.",
  "review.noRun": "Es liegt noch kein Auswertungslauf vor. Ohne ihn erscheint zu keinem Wert ein Befund.",
  "reviewClass.A": "bestätigt — zweite Quelle trägt dieselbe Aussage",
  "reviewClass.B": "Wert korrekt, Quelle nur indirekt",
  "reviewClass.C": "korrigierbar",
  "reviewClass.D": "widersprüchlich",
  "reviewClass.E": "nicht strukturiert abbildbar",
  "reviewClass.F": "Datenfehler in der Quelle",
  "finding.dte_bestaetigt": "Zweitquelle bestätigt",
  "finding.keine_zweitquelle": "keine Zweitquelle",
  "finding.zweitquelle_schweigt": "Zweitquelle schweigt",
  "finding.zweitquelle_ungenauer": "Zweitquelle ungenauer",
  "finding.nicht_maschinell_nachpruefbar": "nicht maschinell nachprüfbar",
  "finding.quelle_nennt_weitere_lichtfarben": "Quelle nennt weitere Lichtfarben",
  "finding.abweichung_erstquelle": "Abweichung zur Quellangabe",
  "finding.dte_konflikt": "Quellkonflikt",
  "finding.winkel_asymmetrisch": "asymmetrischer Abstrahlwinkel",
  "finding.cri_schwelle": "CRI als Schwellenwert",
  "finding.leistung_geteilt": "aufgeteilte Leistung",
  "finding.leistung_stufen": "schaltbare Leistungsstufen",
  "finding.ausschnitt_zweiachsig": "zweiachsiges Ausschnittmaß",
  "finding.dte_nicht_abbildbar": "Zweitquelle nicht abbildbar",
  "finding.flaecheneinheit_bei_laenge": "Flächeneinheit bei einer Länge",
  "finding.einheit_doppelt": "Einheit doppelt geschrieben",
  "finding.kelvin_mit_schranke": "Farbtemperatur mit oberer Schranke",
  // ── Logistik: Supplier-Produkt-Beziehung und Verpackung ────────────────
  //
  // Arbeitsbenennung nach dem Auftrag „Logistik & Beschaffung V1". Die
  // endgueltige DE/EN-Fachterminologie fuer diesen Bereich ist in
  // TERMINOLOGY_DE_EN.md noch nicht verankert -- siehe offener Punkt.
  "log.inheritedFrom": "geerbt von {model}",
  "log.tariffInheritHint": "Die Nummer kommt vom Produktmodell {model}. Eine hier eingetragene Nummer gilt nur für diese SKU; leer lassen heißt: weiter die des Modells.",
  "log.packagingInheritHint": "Diese SKU hat keinen eigenen Verpackungsstand; es gilt der des Produktmodells {model}. Ein hier erfasster Stand ersetzt ihn für diese SKU. Gepflegt wird der Modellstand am Produktmodell.",
  "log.tariffCode": "Zolltarifnummer",
  "log.packagingDetails": "Verpackungsstände im Detail",
  "log.undetermined": "nicht bestimmt",
  "log.notApplicable": "n.a.",
  "log.lengthOrDiameter": "Länge / Ø",
  "log.heightShort": "Höhe",
  "log.productWeight": "Produktgewicht",
  "log.groupPackagingAct": "VerpackungsG",
  "log.materialShare": "Materialanteil",
  "log.tariffPlaceholder": "z. B. 94054200",
  "log.tariffHint": "Code, keine Zahl. Führende Nullen bleiben erhalten. Keine automatische Einreihung.",
  "log.noRelations": "Für diesen Artikel ist keine Supplier-Beziehung erfasst.",
  "log.addRelation": "Supplier-Beziehung hinzufügen",
  "log.removeRelation": "Beziehung lösen",
  "log.supplier": "Supplier",
  "log.chooseSupplier": "Supplier wählen …",
  "log.supplierArticleNumber": "Supplier-Artikelnummer",
  "log.moq": "MOQ",
  "log.orderMultiple": "Bestellvielfaches",
  "log.leadTime": "Lieferzeit",
  /*
   * Einkaufspreis und Zollsatz im Arbeitsbereich -- dieselben Werte, die die
   * Produktakte schon zeigt. Der Wortlaut folgt der Akte, damit nicht zwei
   * Beschriftungen fuer eine Zahl entstehen.
   *
   * "EXW" bleibt unuebersetzt: es ist ein Incoterm, kein Wort.
   */
  "log.dutyRate": "Zollsatz",
  "log.since": "seit {date}",
  "log.days": "{n} Tage",
  "log.confirm": "Als belastbar bestätigen",
  "log.origin": "Herkunft",
  "log.method": "Entstehungsweise",
  "log.provenance": "Herkunft und Entstehung",
  "log.noPackaging": "Für diese Beziehung ist noch kein Verpackungsstand erfasst.",
  "log.addVersion": "Neue Verpackung erfassen",
  "log.removeVersion": "Aktuellen Stand zurücknehmen",
  "log.revision": "Revision {n}",
  "log.current": "aktuell",
  "log.historic": "historisch",
  "log.showHistory": "{n} frühere Stände anzeigen",
  "log.hideHistory": "Frühere Stände ausblenden",
  "log.changeReason": "Änderungsgrund",
  "log.changeNote": "Erläuterung zur Änderung",
  "log.provider": "Verpackung gestellt von",
  "log.providerUnknown": "nicht bestimmt",
  "log.validFrom": "Gültig ab",
  "log.datePlaceholder": "JJJJ-MM-TT",
  "log.productDims": "Produktmaße dieses Stands",
  "tech.coreLegend": "Hervorgehoben: die Kernmerkmale dieser Kategorie.",
  "log.levelProduct": "Produkt",
  "log.innerMaterials": "Material Innenverpackung",
  "log.masterMaterials": "Material Masterkarton",
  "log.gramShort": "g",
  "log.dimsFromRevision": "(Angabe des Verpackungsstands)",
  "log.weightBalance": "Gewichtsbilanz",
  /*
   * „berechnet" steht an jedem Wert, der aus anderen entsteht. Ohne das Wort
   * sieht eine gerechnete Zahl im selben Raster aus wie eine gewogene -- und
   * jemand versucht, sie zu korrigieren.
   */
  "log.computed": "berechnet",
  /*
   * Zwei Knöpfe, weil es zwei Handlungen sind: „Leeren" ist die fachliche
   * Aussage „wir wissen es nicht mehr", „Zurücksetzen" verwirft nur die
   * ungespeicherte Eingabe. Ein Knopf für beides löschte irgendwann ein
   * gewogenes Gewicht, weil sich jemand vertippt hatte.
   */
  "log.levelClear": "Werte leeren",
  "log.levelReset": "Eingaben zurücksetzen",
  "log.packagingWeight": "Verpackungsgewicht",
  "log.residualWeight": "davon nicht zugeordnet",
  "log.perProduct": "je Produkt",
  "log.balanceContent": "Inhalt ({n} Stück)",
  /*
   * Die Beschriftung NENNT den Inhalt.
   *
   * „− 18,3 kg Inhalt" laesst offen, was da gewogen wurde. Genau diese
   * Auskunft fehlte, als die Bilanz vom Masterkarton noch sechsmal das
   * Produktgewicht abzog statt sechsmal den Innenkarton -- der Satz las sich
   * plausibel und war um 1,8 kg falsch.
   */
  "log.balanceContentLevel": "Inhalt ({n} × {level})",
  /*
   * Ein Gramm ist kein Fehler.
   *
   * Am TP154 stehen 300 g berechnete Innenverpackung gegen 299 g gewogenes
   * Material -- der Unterschied zwischen zwei Waagen. Wer ihn als Lücke
   * anzeigt, erzieht zum Wegsehen und übersieht die echte Abweichung.
   */
  "log.materialPerUnit": "Material je Artikel",
  "log.materialRecorded": "erfasst",
  /*
   * Der abgeleitete Wert traegt sein Zustandekommen im Wort. Ohne das waere
   * er in einer spaeteren VerpackungsG-Meldung nicht mehr von einem
   * gewogenen zu unterscheiden.
   */
  "log.materialDerived": "abgeleitet aus Gewichtsbilanz",
  /*
   * Die Menge steht in der Frage, weil sie gerechnet ist und nicht
   * eingetragen wird. Wer sie abtippen müsste, könnte sich vertippen --
   * und eine eingetragene Zahl sieht später aus wie eine gerechnete.
   */
  "log.materialFrom": "{level}, {n} Produkte je Einheit",
  /*
   * Der Satz muss zwei Dinge zugleich leisten: sagen, was fehlt -- und
   * verhindern, dass jemand den Rest der Gewichtsbilanz direkt darüber
   * dafür hält. 6,8 kg − 5,5 kg = 1,3 kg ist der nicht zugeordnete Rest;
   * er kann Einlagen, Zubehör, Feuchtigkeit und Messabweichung enthalten.
   */
  "log.materialMissing": "Für die Ebene {level} ist noch kein Materialgewicht erfasst — je Artikel lässt sich daraus nichts ableiten. Der nicht zugeordnete Rest der Gewichtsbilanz ist kein Materialgewicht.",
  "log.balanceImpossible": "— das Bruttogewicht kann so nicht stimmen",
  "log.balancePackagingWeight": "Verpackungsgewicht",
  "log.balanceMaterialSum": "Materialsumme",
  "log.balanceDifference": "Differenz",
  "log.balanceMatches": "stimmt",
  "log.balanceMismatchHint": "Die Materialsumme stimmt noch nicht mit dem Verpackungsgewicht überein. Bitte Materialwerte korrigieren oder Messung wiederholen.",
  "log.residualHistoric": "früher zugeordnet: {material}",
  "log.confirmBlockedBalance": "Erst belastbar, wenn jede Stufe exakt aufgeht — siehe Differenz in der Gewichtsbilanz.",
  "log.productDimsDeviation": "Abweichende Annahme dieses Stands",
  "log.newRevisionHint": "Die Revisionsnummer vergibt der Server. Ein neuer Stand ersetzt keinen alten.",
  "log.cbmComputedHint": "CBM wird aus den Außenmaßen berechnet und nicht eingegeben.",
  "log.noLevels": "Für diesen Stand ist keine Verpackungsebene erfasst.",
  "log.dimLength": "Länge / Ø",
  "log.dimWidth": "Breite",
  "log.dimHeight": "Höhe",
  "log.unitCount": "Stück",
  "log.grossWeight": "Bruttogewicht",
  "log.netWeight": "Nettogewicht",
  "log.netWeightHint": "Produkt ohne Verpackung",
  "log.editAria": "Logistik bearbeiten",
  "log.editing": "Logistik bearbeiten",
  "log.editHint": "Getippte Maße gelten erst nach dem Speichern. Volumen und Volumen je Stück werden gerechnet und bleiben stehen.",
  "log.save": "Änderungen speichern",
  "log.materialWeight": "Gewicht in Gramm",
  "log.groupPackaging": "Verpackung",
  "log.groupCustoms": "Zoll",
  // Zollstammdaten (0080) -- Ursprungsland und Nettogewicht. Beides erfasst
  // und bestaetigt, nichts davon abgeleitet.
  "cust.articleDefault": "Artikelwert",
  "cust.originCountry": "Ursprungsland",
  "cust.originCountryPlaceholder": "CN",
  "cust.netWeight": "Nettogewicht",
  "cust.netWeightCustoms": "Nettogewicht für Zoll",
  "cust.fromProductNet": "aus Produkt-Nettogewicht übernommen",
  "cust.supplierStated": "{name} – Lieferantenangabe",
  "cust.recordExplicit": "Eigene Zollangabe erfassen",
  "cust.netWeightPlaceholder": "kg",
  "cust.quality": "Belastbarkeit",
  "cust.confirm": "bestätigt",
  "cust.note": "Bemerkung",
  "cust.notePlaceholder": "Quelle der Angabe",
  "cust.missing": "fehlt",
  "cust.fromArticle": "vom Artikel",
  "cust.fromRelation": "von dieser Lieferbeziehung",
  "cust.customsTruth": "gilt für den Zoll",
  "cust.notCustomsTruth": "noch nicht belastbar bestätigt",
  "cust.record": "erfassen",
  "cust.addOverride": "Abweichung erfassen",
  "cust.hint": "Weder das Land des Lieferanten noch das Kalkulationsgewicht werden übernommen. Nur belastbar bestätigte Angaben gelten für den Zoll.",
  "bew.title": "Lieferantenbewertung",
  "bew.production": "Produktionsqualität",
  "bew.reliability": "Zuverlässigkeit",
  "bew.communication": "Kommunikation",
  "bew.price": "Preis-Leistungsverhältnis",
  "bew.paymentTerms": "Zahlungsbedingungen",
  "bew.overall": "Gesamtbewertung",
  "bew.overallFrom": "Ø aus {n} Kriterien",
  "bew.overallNone": "noch kein Kriterium bewertet",
  "bew.notRated": "Nicht bewertet",
  "bew.clear": "zurücknehmen",
  "bew.ratedBy": "Zuletzt bewertet von {wer} am {wann}.",
  "ek.groupProduct": "Produkt",
  "ek.groupPricing": "Preis & Konditionen",
  "ek.incoterm": "Incoterm {term}",
  "ek.validSince": "gültig seit {date}",
  "ek.supplier": "Lieferant",
  "ek.supplierArtNo": "Supplier-Art.-Nr.",
  "ek.ratingTitle": "Lieferantenbewertung (Durchschnitt) -- gepflegt im Lieferantenportal",
  "ek.openSupplierRating": "{name} im Lieferantenportal öffnen -- mit Bewertung",
  "ek.price": "Einkaufspreis",
  "ek.exw": "EXW",
  "ek.paymentTerms": "Zahlungsbedingung",
  "ek.termsFromSupplier": "Supplier-Standard",
  "ek.termsFromArticle": "produktspezifische Vereinbarung",
  "ek.termsAfterDays": "{n} Tage",
  "ek.termsEditingSupplier": "Gilt als Standard dieses Lieferanten.",
  "ek.termsEditingArticle": "Gilt nur für diesen Artikel.",
  "ek.termsOnlyThis": "nur für diesen Artikel",
  "ek.termsDropArticle": "Abweichung zurücknehmen",
  "ek.termsSupplierWide": "Änderungen wirken für alle Artikel dieses Lieferanten.",
  "ek.stageAdd": "Stufe hinzufügen",
  "ek.stageShare": "Anteil in Prozent",
  "ek.stageEvent": "Zahlungsereignis",
  "ek.stageOffset": "Tage",
  "ek.stageNote": "Zusatz",
  "ek.stageRemove": "Stufe entfernen",
  "ek.stageSum": "Summe {n} %",
  "payEvent.deposit": "Anzahlung",
  /* Nur fuer die EINE Stufe ueber 100 %. Eine Anzahlung ist der Teil,
     den man vorab zahlt; wer alles vorab zahlt, zahlt keine Anzahlung.
     Siehe `zahlplanSatz`. */
  "ek.termsOnOrder": "bei Auftragserteilung",
  "payEvent.after_qc": "nach Warenprüfung",
  "payEvent.before_bl": "vor Konnossement",
  "payEvent.on_shipment": "bei Verladung",
  "payEvent.on_arrival": "bei Ankunft",
  "payEvent.after_invoice": "nach Rechnung",
  "payMethod.bank_transfer": "Überweisung",
  "ord.orderable": "Bestellfähig",
  "ord.blocked": "Nicht bestellfähig",
  "orderBlock.number_placeholder": "Platzhalternummer – noch keine Artikelnummer",
  "orderBlock.no_model_link": "keine Produktmodellzuordnung",
  "orderBlock.variant_incomplete": "Ausführung nicht vollständig bestimmt",
  "orderBlock.lifecycle_blocks": "Sortimentsstatus lässt keine Bestellung zu",
  "orderBlock.no_supplier_link": "keine Lieferantenzuordnung",
  "payMethod.letter_of_credit": "Akkreditiv",
  "payMethod.paypal": "PayPal",
  "payMethod.credit_card": "Kreditkarte",
  "payMethod.cash": "Barzahlung",
  "payMethod.other": "sonstiger Weg",
  "ek.stageLabel": "Bezeichnung",
  "ek.stageMethod": "Zahlungsweg",
  "ek.stageMethodNone": "nicht vereinbart",
  "fin.stages": "Tatsächliche Zahlungen",
  "fin.stageDue": "Soll",
  "fin.stageShare": "Anteil",
  "fin.stageStatus": "Status",
  "fin.stagePartly": "teilweise",
  "fin.stageUnknown": "nicht bestimmbar",
  "fin.stagePaid": "bezahlt",
  "fin.stageRest": "Rest",
  "fin.stageSettled": "erfüllt",
  "fin.stageOpen": "offen",
  "fin.stageNoDue": "ohne Bestellwert kein Sollbetrag",
  "fin.stageAssign": "Stufe zuordnen",
  "fin.stageNone": "keiner Stufe zugeordnet",
  "fin.unassigned": "Zahlungen ohne Stufe",
  "fin.unassignedHint": "Sie zählen in der Summe mit. Zugeordnet werden sie nicht geraten.",
  "fin.methodDiffers": "weicht von der Vereinbarung ab",
  "payMethod.none": "nicht erfasst",
  "ek.editAria": "Einkauf bearbeiten",
  "ek.editHint": "Getippte Angaben gelten erst nach dem Speichern. Ein neuer Einkaufspreis wird über „Einkaufspreis erfassen“ angelegt.",
  "log.dimDiameter": "Durchmesser",
  "log.productDimsHint": "Produktmaße und Produktgewicht sind Merkmalswerte. Geändert werden sie im Bereich Technik.",
  "unit.gram": "g",
  "unit.ampere": "A",
  "log.errDimension": "{feld}: bitte ein Maß größer als null eintragen.",
  "log.errWeight": "Bruttogewicht: bitte ein Gewicht größer als null eintragen oder das Feld leer lassen.",
  "log.errUnitCount": "Stück je Einheit: bitte eine ganze Zahl ab 1 eintragen.",
  "log.errMaterial": "Materialgewicht: bitte eine Zahl größer als null eintragen oder das Feld leer lassen.",
  "log.cbm": "CBM",
  "log.cbmPerUnit": "CBM je Stück",
  "log.master": "Masterkarton",
  "log.innerOptional": "Inner Box (optional)",
  "log.lengthMm": "Länge mm",
  "log.widthMm": "Breite mm",
  "log.heightMm": "Höhe mm",
  "log.innerLength": "Inner Box Länge",
  "log.innerWidth": "Inner Box Breite",
  "log.innerHeight": "Inner Box Höhe",
  "log.innerUnits": "Inner Box Stück",
  "log.innerWeight": "Inner Box Bruttogewicht",
  "log.masterLength": "Masterkarton Länge",
  "log.masterWidth": "Masterkarton Breite",
  "log.masterHeight": "Masterkarton Höhe",
  "log.masterUnits": "Masterkarton Stück",
  "log.masterWeight": "Masterkarton Bruttogewicht",
  "log.addTest": "Nachweis hinzufügen",
  "log.testType": "Nachweisart",
  "log.testResult": "Ergebnis",
  "log.performedOn": "Durchgeführt am",
  "log.testStandard": "Norm",
  "log.testReference": "Referenz",
  "log.testReferencePlaceholder": "z. B. Drop Test Report 2026-08",
  "log.testNote": "Notiz",
  "packLevel.inner": "Innenkarton",
  "packLevel.master": "Masterkarton",
  "packLevel.pallet": "Palette",
  "packReason.initial": "Erstanlage",
  "packReason.product_change": "Produktänderung",
  "packReason.complaint": "Reklamation",
  "packReason.optimization": "Optimierung",
  "packReason.supplier_change": "Supplierwechsel",
  "packReason.other": "Sonstiges",
  "packProvider.supplier": "Supplier",
  "packProvider.greenius": "greenius",
  "packProvider.mixed": "gemischt",
  "packMaterial.cardboard": "Pappe",
  "packMaterial.plastic": "Kunststoff",
  "packMaterial.wood": "Holz",
  "packMaterial.other": "Sonstiges",
  "packTestType.drop_test": "Falltest",
  "packResult.passed": "bestanden",
  "packResult.failed": "nicht bestanden",
  "packResult.open": "offen",
  "numberKind.aktuell": "aktuell",
  "numberKind.historisch": "historisch",
  "numberKind.alternativ": "alternativ",
  // ── Artikelarbeitsseite: Erkennen, Verstehen, Bearbeiten ──────────────────
  "head.kind": "Artikel (SKU)",
  "head.sourceLabel": "Quellbezeichnung aus dem Import",
  "attn.aria": "Handlungsbedarf",
  "attn.show": "Anzeigen",
  "attn.review_flag_open": "offene Prüfhinweise",
  "attn.property_conflict": "widersprüchliche Merkmale",
  "attn.property_model_limit": "Merkmale außerhalb des Modells",
  "attn.core_property_missing": "fehlende Kernangaben",
  "attn.requirement_missing": "erwartete Informationen fehlen",
  "attnItem.tariff_code": "Zolltarifnummer",
  "attnItem.moq": "Mindestabnahme",
  "otexts.aria": "Beschreibungen",
  "otexts.title": "Beschreibung",
  "otexts.langAria": "Inhaltssprache",
  "otexts.more": "weiterlesen",
  "otexts.less": "weniger",
  "head.priceReleased": "freigegeben ab {date}",
  "head.priceCalculated": "berechnet · nicht freigegeben",
  "head.priceNone": "nicht berechnet",
  "head.listPrice": "Listenpreis netto",
  "head.imageNone": "Kein Produktbild",
  "head.imageAlt": "Produktabbildung der Produktfamilie",
  "tech.aria": "Technische Übersicht",
  "tech.title": "Technische Daten",
  "propColumn.licht": "Lichttechnik",
  "propColumn.strom": "Stromtechnik",
  "propColumn.bau": "Konstruktion & Schutz",
  "work.logistik": "Logistik",
  "log.sectionPackaging": "Logistik & Verpackung",
  "log.sectionPurchasing": "Einkauf",
  "attn.weight_missing": "Produktgewicht fehlt",
  "attn.tariff_code_missing": "Zolltarifnummer fehlt",
  "attn.moq_missing": "Mindestabnahme fehlt",
  "otexts.emptyLanguage": "In dieser Sprache liegt noch kein Text vor.",
  "prov.section": "Herkunft & Historie",
  "prop.led_brand": "LED-Hersteller",
  "prop.led_type": "LED-Typ",
  "prop.led_count": "LED-Anzahl",
  "prop.lifetime": "Lebensdauer",
  "prop.lumen_maintenance": "Lichtstromerhalt",
  "prop.power_adjustable": "Leistung einstellbar",
  "prop.voltage": "Versorgungsspannung",
  "prop.frequency": "Netzfrequenz",
  "prop.control": "Steuerung",
  "prop.control_gear_supply": "Betriebsgerät / Lieferzustand",
  "prop.manufacturer_brand": "Hersteller / Marke",
  "prop.dc_output_voltage.atLuminaire": "DC-Betriebsspannung",
  "prop.dc_output_current.atLuminaire": "Betriebsstrom",
  "prop.wiring": "Verdrahtung",
  "prop.cover_material": "Abdeckungsmaterial",
  "prop.ambient_temperature": "Umgebungstemperatur",
  "propValue.integriert": "integriert",
  "propValue.separat": "separat",
  "propValue.ohne": "ohne",
  "propValue.dali2": "DALI-2",
  "propValue.1_10v": "1–10 V",
  "propValue.casambi": "Casambi",
  "propValue.through_wiring": "Durchgangsverdrahtung",
  "propValue.terminal_block": "Klemmleiste",
  "propValue.plug_connector": "Steckverbinder",
  "propValue.pmma": "PMMA",
  "propValue.glas": "Glas",
  "propValue.glas_gehaertet": "gehärtetes Glas",
  "propValue.opal_diffusor": "Opal-Diffusor",
  "propOperator.lt": "kleiner als",
  "propOperator.le": "höchstens",
  "propOperator.gt": "größer als",
  "propOperator.ge": "mindestens",
  "infoStatus.offen": "offen",
  "infoStatus.angefragt": "angefragt",
  "infoStatus.nicht_zutreffend": "nicht zutreffend",
  "infoStatus.bestaetigt": "bestätigt",
  "work.aria": "Arbeitsbereiche",
  "work.technik": "Technik",
  "work.modell": "Modell",
  "work.einkauf": "Einkauf",
  "work.texte": "Texte",
  "work.dokumente": "Dokumente",
  "work.herkunft": "Herkunft",
  "work.stateModelVariant": "{model} · Variante",
  // ── Dokumente ──────────────────────────────────────────────────────────
  //
  // Die fünf Fächer sind ein festes Vokabular; ihre Codes stehen in
  // `DOCUMENT_GROUPS`. Zugeordnet werden sie in `ArticleDocuments.tsx`
  // wörtlich — deshalb braucht es hier keine tCode-Ausnahme.
  "doc.section": "Dokumente",
  "doc.loading": "Dokumente werden geladen …",
  "doc.groupLichtplanung": "Lichtplanung / IES",
  "doc.groupDatenblatt": "Produktdatenblatt",
  "doc.groupTreiber": "LED-Treiber-Datenblatt",
  "doc.groupZertifikate": "Zertifikate & Konformität",
  "doc.groupAnleitung": "Produktanleitung",
  "doc.groupPruefberichte": "Prüfberichte & sonstige Dateien",
  "doc.more": "Weitere {n} anzeigen",
  "doc.less": "Weniger anzeigen",
  "doc.none": "nicht vorhanden",
  "doc.open": "Öffnen",
  "doc.download": "Download",
  "doc.inherited": "geerbt",
  "doc.inheritedFrom": "Gepflegt am Produktmodell {model} — gilt für alle Ausführungen.",
  "doc.dateLabel": "Stand {date}",
  "doc.sizeKb": "{n} KB",
  "doc.sizeMb": "{n} MB",
  "doc.previous": "Vorgängerstände ({n})",
  "doc.replacedOn": "ersetzt am {date}",
  "doc.add": "Datei hinzufügen",
  "doc.replace": "Ersetzen",
  "doc.replaceInherited": "Am Modell ersetzen",
  "doc.remove": "Entfernen",
  "doc.removeInherited": "Am Modell entfernen",
  "doc.removeAsk": "Wirklich entfernen?",
  "doc.removeAskModel": "Für alle Ausführungen entfernen?",
  "doc.removeYes": "Entfernen",
  "doc.adding": "Neue Datei",
  "doc.replacing": "Ersetzt: {name}",
  "doc.file": "Datei",
  "doc.formats": "PDF, IES, LDT, TXT, ZIP, PNG, JPG · höchstens {mb} MB",
  "doc.level": "Gilt für",
  "doc.levelArticle": "nur diese Ausführung",
  "doc.levelModel": "alle Ausführungen von {model}",
  "doc.languageLabel": "Sprache",
  "doc.languageNone": "keine Angabe",
  "doc.standLabel": "Stand",
  "doc.upload": "Hochladen",
  "doc.uploading": "Wird hochgeladen …",
  "doc.proven": "nachgewiesen",
  "doc.editing": "Bearbeitungsmodus",
  "doc.editHint": "Dateien hinzufügen, ersetzen und entfernen.",
  "doc.editAria": "Dokumente bearbeiten",
  "doc.done": "Fertig",
  "list.compactAria": "Artikelauswahl",
  /* ── Zentrale Produktakte ─────────────────────────────────────────────── */
  "akte.loading": "Produktakte wird geladen …",
  "akte.back": "Zurück zur Produktansicht",
  "akte.openWork": "Offene Arbeit",
  "akte.openProposals": "{count} Änderungsvorschläge zu entscheiden",
  "akte.openChecks": "{count} Angaben müssen geprüft werden",
  "akte.openFlags": "{count} offene Prüfhinweise",
  "akte.jumpAria": "Abschnitte der Produktakte",
  "akte.articleNumber": "Artikelnummer",
  "akte.category": "Kategorie",
  "akte.family": "Produktfamilie",
  "akte.model": "Produktmodell",
  "akte.variant": "Ausführung",
  "akte.sourceLabel": "Bezeichnung",
  "akte.lifecycle": "Sortimentsstatus",
  "akte.lifecycleUnset": "nicht bestimmt",
  "akte.stockingType": "Sortimentsrolle",
  "akte.stockingUnset": "nicht bestimmt",
  "stocking.lagerware": "Lagerware",
  "stocking.projektware": "Projektware",
  "list.stocking": "Sortimentsrolle",
  "list.stockingAll": "Jede Sortimentsrolle",
  "list.stockingOpen": "noch nicht bestimmt",
  "akte.roles": "Rollen",
  "akte.editBaseData": "Grunddaten bearbeiten",
  "akte.dutyRate": "Zollsatz",
  "akte.setDutyRate": "Zollsatz erfassen",
  "akte.dutyNeedsTariff": "Ein Zollsatz hängt an der Zolltarifnummer. Ohne sie gibt es nichts, worauf er sich beziehen könnte.",
  "akte.since": "seit {date}",
  "akte.validFrom": "Gültig ab",
  "akte.validFromDate": "gültig ab {date}",
  "akte.validFromRevision": "gültig ab {date} · Revision {revision}",
  "akte.herkunft_eingabe": "Eingabe",
  "akte.herkunft_vorgabe": "Vorgabe",
  "akte.herkunft_ergebnis": "Ergebnis",
  "akte.dutyFrom": "Zollsatz {rate} % der Tarifnummer {code}",
  "akte.exw": "EXW",
  "akte.amount": "Betrag",
  "akte.currency": "Währung",
  "akte.setPrice": "Einkaufspreis erfassen",
  "form.why.priceMissing": "Preis fehlt -- bitte einen Betrag über 0 eintragen.",
  "form.why.dateMissing": "Gültig-ab-Datum fehlt -- ab wann gilt der Wert?",
  "form.why.marginBlocked": "Unterschreitet die Zielmarge -- freigeben darf das nur, wer das Ausnahmerecht hat.",
  "form.why.reasonMissing": "Begründung für die Ausnahme fehlt.",
  "form.why.conflictsUnconfirmed": "Abweichende Freigaben der Varianten -- bitte bewusst bestätigen.",
  "form.why.amountMissing": "Betrag fehlt -- bitte einen Einkaufspreis über 0 eintragen.",
  "form.why.rateMissing": "Zollsatz fehlt -- bitte einen Wert von 0 bis 100 % eintragen.",
  "akte.parameterSet": "Parametersatz",
  "akte.noCalculation": "Für diesen Artikel wurde noch nicht gerechnet.",
  "akte.missing": "Noch nicht bekannt: {items}",
  "akte.volumePerUnit": "Volumen je Stück",
  /*
   * „Fracht" und nicht „Zugfracht": seit es Sea, Train und Air gibt, benennt
   * die Zeile daneben die Transportart. Zwei Stellen, die dasselbe sagen,
   * widersprechen sich irgendwann -- und „Zugfracht" an einer Luftsendung
   * wäre schlicht falsch.
   */
  "akte.freight": "Fracht",
  "akte.csef": "CSEF",
  "akte.duty": "Zoll",
  "akte.landedUsd": "Landed Cost",
  /*
   * VerpackungsG und ElektroG sind zwei verschiedene Abgaben und tragen
   * deshalb zwei Zeilen. Zusammengefasst zu „Umweltabgaben" wüsste niemand,
   * welcher Teil am Material hängt und welcher am Produktgewicht -- und ein
   * Satzwechsel bei einem von beiden wäre nicht mehr zuzuordnen.
   */
  "akte.packagingAct": "VerpackungsG",
  "akte.packagingActPart": "{g} g {material} zu {rate} EUR/t",
  "akte.electroAct": "ElektroG",
  "akte.electroActFrom": "{kg} kg Produktgewicht zu {rate} EUR/kg",
  /*
   * Der Satz sagt, was er IST. greenius hatte bisher keine EAR-Abholung; ihn
   * als ermittelten Abholpreis zu bezeichnen wäre eine Behauptung über eine
   * Erfahrung, die es nicht gibt.
   */
  "akte.electroActNote": "kalkulatorischer Umlagesatz, keine ermittelte Abholgebühr",
  "akte.costBase": "Kostenbasis",
  "param.packaging_act_cardboard_eur_per_kg": "VerpackungsG Pappe/Papier/Karton",
  "param.packaging_act_plastic_eur_per_kg": "VerpackungsG Kunststoff",
  "param.electro_act_eur_per_kg": "ElektroG",
  "calcInput.product_weight": "Produktgewicht",
  /*
   * Die Regel, nach der aus Kubikmetern Volumenkilogramm werden. Sie ist eine
   * kaufmännische Setzung und keine Naturkonstante -- solange sie nicht
   * getroffen ist, kann Luftfracht nicht gerechnet werden.
   */
  "calcInput.usd_eur_calc_rate": "Kalkulationskurs (Abschlag zu hoch)",
  "calcInput.usd_eur_safety_discount": "Sicherheitsabschlag",
  "calcInput.sea_freight_usd_per_cbm": "Seefrachtsatz",
  "calcInput.air_freight_usd_per_kg": "Luftfrachtsatz",
  "calcInput.packaging_materials": "Verpackungsmaterialien",
  "calcInput.packaging_act_cardboard_eur_per_kg": "VerpackungsG-Satz Pappe",
  "calcInput.packaging_act_plastic_eur_per_kg": "VerpackungsG-Satz Kunststoff",
  "calcInput.electro_act_eur_per_kg": "ElektroG-Satz",
  "akte.landedEur": "Landed Cost",
  "akte.atRate": "Kurs {rate}",
  "akte.showCalculation": "Berechnung anzeigen",
  "akte.hideCalculation": "Berechnung ausblenden",
  "release.forModel": "Listenpreis für alle Ausführungen des Produktmodells {model} anwenden",
  "release.appliesTo": "Gilt für {n} SKUs",
  "release.conflictsTitle": "{n} abweichende Freigabe(n) an Varianten.",
  "release.conflictsText": "Nichts wird still überschrieben: die neue Freigabe gilt ab ihrem Datum, die bisherige bleibt als Vorgänger stehen.",
  "release.conflictLine": "{sku}: freigegeben {alt} EUR ab {date} → neu {neu} EUR",
  "release.confirmConflicts": "Abweichende Preise bewusst durch diese Freigabe ablösen",
  "stufen.netBeforeCommission": "Nettoerlös vor Provision",
  "stufen.netBeforeCommissionFrom": "Kostenbasis {k} EUR ÷ (1 − {m} %) -- sichert die Zielmarge",
  "stufen.commissionMeaning": "Provision eines externen Vermittlers auf den provisionsfähigen Nettoverkaufspreis -- on top der Zielmarge",
  "stufen.roundedUp": "Auf nächsten {step}-EUR-Schritt erhöht, damit die Zielmarge von {m} % nicht unterschritten wird.",
  "stufen.salesNet": "Provisionsfähiger Nettoverkaufspreis",
  "stufen.salesNetFrom": "Nettoerlös vor Provision ÷ (1 − {p} %)",
  "stufen.commissionAmount": "Provision",
  "stufen.commissionAmountFrom": "{p} % von {s} EUR -- nicht von der Kostenbasis",
  "stufen.netAfterCommission": "Nettoerlös nach Provision",
  "stufen.netAfterCommissionMeaning": "bleibt nach Zahlung der Provision -- die Zielmarge von {m} % ist vollständig erhalten",
  "stufen.roundedNormal": "Kaufmännisch auf den {step}-EUR-Schritt gerundet; die Zielmarge von {m} % bleibt gewahrt.",
  "stufen.listPriceRaw": "Listenpreis vor Rundung",
  "stufen.listPriceFactor": "Listenpreisfaktor",
  "stufen.marginAfterRounding": "Marge nach Provision und Rundung",
  "kalk.rounding": "Rundung",
  "kalk.listPriceCalc": "Listenpreiskalkulation",
  "kalk.expand": "Listenpreiskalkulation aufklappen",
  "kalk.collapse": "Listenpreiskalkulation einklappen",
  "satz.divisorFrom": "gespeichert als Divisor {divisor} · Listenpreisfaktor × {faktor}",
  "satz.scopeFamily": "Gilt für die Produktfamilie {family} -- für alle Artikel dieser Familie. Geändert wird die Familienabweichung, kein Artikelwert. Danach wird dieser Artikel neu gerechnet.",
  "satz.nextRevision": "Für den {date} besteht bereits Revision {revision} -- gespeichert wird Revision {next}. Frühere Revisionen und ihre Kalkulationen bleiben unverändert.",
  "satz.scopeCentral": "Gilt zentral für alle Artikel ohne Familienabweichung -- als neue Revision des Parameterstands ab {date}. Kein Artikelwert. Danach wird nur dieser Artikel neu gerechnet.",
  "strecke.discountBasis": "Rabattbasis",
  "strecke.discountBasisFrom": "Rabattbasis {basis} % · Listenpreisfaktor × {faktor}",
  "vergleich.title": "Transportvergleich",
  "importweg.title": "Listenpreis nach Importweg",
  "importweg.section": "Listenpreis",
  "importweg.none": "Noch nicht berechnet -- „Neu rechnen“ in der Listenpreiskalkulation darunter.",
  "importweg.laufzeit": "Transportlaufzeit",
  "importweg.laufzeitTage": "ca. {n} Tage",
  "importweg.laufzeitWoche": "ca. 1 Woche",
  "importweg.laufzeitWochen": "ca. {n} Wochen",
  "importweg.nutzen_sea": "Kostengünstigster Weg",
  "importweg.nutzen_train": "Standardweg",
  "importweg.nutzen_air": "Schnellster Weg",
  "importweg.hinweis": "Die Listenpreise sind kalkulierte Werte auf Basis der aktuellen Parameter. Sie sind noch nicht freigegeben und stellen keine verbindlichen Kundenpreise dar.",
  "vergleich.note": "Interner Vergleich. Freigebbar ist nur der aktive Weg; die Vergleichspreise werden nicht gespeichert und nicht ausgegeben.",
  "vergleich.active": "aktiv",
  "vergleich.notComputable": "nicht berechenbar",
  "vergleich.rateMissing": "Frachtsatz fehlt",
  "vergleich.inputsMissing": "Angaben fehlen",
  "vergleich.airRateMissing": "Air-Frachtsatz fehlt",
  "vergleich.masterDimensionsMissing": "Masterkarton-Abmessungen fehlen",
  "vergleich.masterGrossMissing": "Masterkarton-Bruttogewicht fehlt",
  "vergleich.masterUnitsMissing": "Stück/Master fehlt",
  "vergleich.divisorMissing": "Volumengewichts-Divisor fehlt",
  "luft.master": "Masterkarton",
  "luft.masterValue": "{l} × {b} × {h} mm",
  "luft.gross": "Master brutto",
  "luft.units": "Stück/Master",
  "luft.unitsShort": "{n} Stk/Master",
  "luft.divisor": "Volumengewichts-Divisor",
  "luft.volumetric": "Volumengewicht",
  "luft.chargeable": "Chargeable Weight",
  "luft.basis_volumen": "Basis: Volumengewicht -- höher als das tatsächliche Gewicht",
  "luft.basis_gewicht": "Basis: tatsächliches Gewicht -- mindestens so hoch wie das Volumengewicht",
  "luft.basisShort_volumen": "Volumengewicht",
  "luft.basisShort_gewicht": "tatsächliches Gewicht",
  "luft.chargeableShort": "abrechenbar {kg} kg ({basis})",
  "luft.rate": "Air-Frachtsatz",
  "luft.rateMissing": "nicht gepflegt",
  "luft.freightMaster": "Air-Fracht je Master",
  "luft.freightUnit": "Air-Fracht je Stück",
  "luft.freightShort": "{rate} USD/kg · Master {master} USD · je Stück {unit} USD",
  "calcInput.master_dimensions": "Masterkarton-Abmessungen",
  "calcInput.master_gross_weight": "Masterkarton-Bruttogewicht",
  "calcInput.master_unit_count": "Stück je Masterkarton",
  "calcInput.air_volumetric_divisor_cm3_per_kg": "Volumengewichts-Divisor",
  "param.air_volumetric_divisor_cm3_per_kg": "Volumengewichts-Divisor Luftfracht",
  "vergleich.diff": "{value} EUR ggü. aktiv",
  "vergleich.stale": "Die Eingaben haben sich seit der letzten Rechnung geändert – „Neu rechnen“ aktualisiert den aktiven Preis.",
  "vergleich.newerSet": "Seit der letzten Rechnung gilt ein neuerer Parameterstand – „Neu rechnen“ übernimmt ihn in Kalkulation und Vergleich.",
  "vergleich.error": "Der Vergleich konnte nicht gerechnet werden.",
  "kalk.showDetails": "Berechnungsdetails",
  "kalk.hideDetails": "Berechnungsdetails schließen",
  "kalk.basis": "Berechnungsgrundlage",
  "kalk.steps": "Rechenweg",
  "kalk.releasedOther": "freigegeben: {value} EUR ab {date}",
  "strecke.exw": "EXW USD",
  "strecke.landed": "HH Landed",
  "strecke.commission": "Provision",
  "strecke.minMargin": "Zielmarge",
  "strecke.edit": "{what} ändern",
  "strecke.recalc": "Übernehmen und neu rechnen",
  "strecke.exwHint": "Neue Preisstufe ab dem gewählten Datum; der bisherige Preis bleibt als Vorgänger. Danach wird neu gerechnet.",
  "strecke.freightHint": "Gewählt wird die Transportart. Der Frachtsatz kommt aus dem geltenden Parametersatz und bleibt dort.",
  "kette.label": "Kalkulation vom Einkaufspreis zum Listenpreis",
  "kette.ek": "EK",
  "kette.rate": "Kalkulationskurs",
  "kette.freight": "Fracht",
  "kette.duty": "Zoll",
  "kette.packagingAct": "VerpackungsG",
  "kette.electroAct": "ElektroG",
  "kette.costBase": "Einstand",
  "kette.margin": "Marge",
  "kette.listPrice": "Listenpreis",
  "akte.recalculate": "Neu rechnen",
  "akte.calculatedAt": "gerechnet am {date} von {user}",
  "akte.minimumMargin": "Zielmarge",
  "akte.resultingMargin": "Erzielte Marge",
  "akte.minimumWas": "Zielmarge {value} %",
  "akte.belowMinimumTitle": "Zielmarge unterschritten.",
  "akte.belowMinimumWarning": "Eine Ausnahmefreigabe ist möglich, verlangt aber eine Begründung und bleibt dauerhaft sichtbar.",
  "akte.belowMinimumReason": "Begründung der Ausnahme",
  "akte.belowMinimumRecorded": "Unterschreitet die Zielmarge: {margin} % statt {minimum} %.",
  "akte.releaseException": "Ausnahmefreigabe unter Zielmarge",
  "akte.belowMinimumBlocked": "Freigabe nicht möglich.",
  "akte.belowMinimumBlockedText": "Der Preis unterschreitet die geltende Zielmarge.",
  "akte.exceptionRecorded": "Ausnahmefreigabe.",
  "akte.marginFromFamily": "Abweichung der Familie {family}",
  "akte.marginStandard": "globaler Standard",
  "akte.marginWhereEdited": "Nicht am Artikel änderbar: die Zielmarge gilt global oder je Produktfamilie und wird im Parametersatz gepflegt.",
  "akte.calculatedListPrice": "Berechneter Listenpreis",
  "akte.releases": "Freigegebene Listenpreise",
  "akte.noRelease": "Für diesen Artikel ist noch kein Listenpreis freigegeben.",
  "akte.releasedPrice": "Listenpreis",
  "akte.releasedBy": "Freigegeben von",
  "akte.release": "Listenpreis freigeben",
  "akte.note": "Notiz",
  "akteSection.identitaet": "Artikelidentität",
  "akteSection.varianten": "Variantenraum",
  "varianten.lead": "Welche Ausführungen es gibt — nicht, was dieser Artikel ist. Der konkrete Wert dieser SKU steht in den technischen Abschnitten.",
  "varianten.standard": "Standard",
  "varianten.optional": "Optional",
  "varianten.noStandard": "gleichrangige Ausführungen ohne benannten Standard",
  "varianten.empty": "Für diesen Artikel ist kein Variantenraum hinterlegt.",
  "varianten.source": "Quelle",
  "varianten.noSku": "Eine Ausführung aus diesem Raum ist noch kein Artikel. Eine eigene Artikelnummer entsteht erst, wenn sie tatsächlich angeboten werden soll.",
  "akteSection.lichttechnik": "Lichttechnik",
  "akteSection.stromtechnik": "Stromtechnik",
  "akteSection.konstruktion": "Konstruktion",
  "akteSection.verpackung": "Verpackung & Logistik",
  "akteSection.zoll": "Zoll",
  "akteSection.einkauf": "Einkauf",
  "akteSection.zuschlaege": "Zuschläge & Fracht",
  "akteSection.importkalkulation": "Importkalkulation",
  "akteSection.verkaufspreis": "Verkaufspreis",
  "nav.parameters": "Kalkulation",
  /*
   * Die Seitenüberschrift trägt den vollen Namen, der Menüpunkt den kurzen.
   * Das ist kein Zufall: mit dem langen Namen war die Kopfzeile bei 1400 px
   * vier Pixel zu breit, und die ganze Anwendung scrollte waagerecht.
   */
  "param.title": "Kalkulationsparameter",
  "param.card.waehrung": "Währung",
  "param.card.fracht": "Fracht",
  "param.card.verpackungsg": "VerpackungsG",
  "param.card.elektrog": "ElektroG",
  "param.usd_eur_safety_discount": "Sicherheitsabschlag",
  /*
   * „Kalkulationskurs" und nicht „zweiter Wechselkurs": er ist kein zweiter
   * gepflegter Wert, sondern die Differenz. Ein Name, der ihn wie eine eigene
   * Eingabe klingen lässt, lädt dazu ein, ihn einzeln zu ändern.
   */
  "param.usd_eur_calc_rate": "USD/EUR Kalkulationskurs",
  "param.calcRateFrom": "{ref} − {ab} Sicherheitsabschlag",
  "param.sea_freight_usd_per_cbm": "Sea",
  "akte.transportMode": "Transportart",
  "akte.freightRate": "Frachtsatz",
  /*
   * Die Transportarten tragen ihre englischen Namen, weil das Haus sie so
   * nennt -- „Bahnfracht" stünde in keiner Buchungsbestätigung.
   */
  "transport.sea": "Sea",
  "transport.train": "Train",
  "transport.air": "Air",
  "param.air_freight_usd_per_kg": "Air",
  "param.electroActNote": "Kalkulatorischer Umlagesatz für Gebühren & Co. — greenius hatte bisher keine EAR-Abholung; dies ist kein aus tatsächlichen Abholungen ermittelter Preis.",
  "param.edit": "Kalkulationsparameter bearbeiten",
  "param.save": "Speichern",
  "param.cancel": "Abbrechen",
  "param.why.readyRevision": "Für den {date} besteht bereits Revision {revision} -- gespeichert wird Revision {next} auf ihrer Grundlage. Frühere Revisionen bleiben erhalten.",
  "param.unchanged": "Keine Änderung gegenüber Revision {revision} des Stands ab {date} -- es wurde nichts gespeichert.",
  "param.savedRevision": "Gespeichert als Revision {revision} des Stands ab {date}. Frühere Revisionen bleiben in der Historie.",
  "param.replacedByRevision": "korrigiert durch Revision {revision}",
  "param.savedAt": "gespeichert",
  "param.revision": "Revision",
  "param.validFromRevision": "Geltender Stand seit {date} · Revision {revision} · gespeichert {at} · {by}",
  "param.why.ready": "Speichert genau einen neuen Stand, gültig ab {date}. Der bisherige bleibt erhalten.",
  "param.why.noDate": "Gültig-ab-Datum fehlt -- ab wann gilt der neue Stand?",
  "param.why.invalid": "{field}: bitte eine gültige Zahl eintragen (ab 0; ein gepflegter Wert lässt sich nicht leeren).",
  "param.why.noChange": "Noch keine Änderung -- ändern Sie mindestens einen Wert.",
  "param.validFromShort": "gültig ab",
  "param.newValidFrom": "Gültig ab",
  /*
   * Ein Stand, mit dem schon gerechnet wurde, ist unveränderlich. Ab wann ein
   * neuer gilt, ist eine kaufmännische Entscheidung -- „heute" zu unterstellen
   * wäre eine Aussage darüber, ab welchem Tag das Haus anders kalkuliert.
   */
  "param.history": "Historie · {n} Stände",
  "param.status": "Status",
  "param.values": "Werte",
  "param.current": "geltend",
  "param.superseded": "abgelöst",
  "param.future": "vorbereitet",
  "param.past": "vergangen",
  "param.inUse": "in Kalkulationen verwendet",
  /*
   * „Referenzkurs" und nicht „Wechselkurs": daneben steht der
   * KALKULATIONSKURS, und wenn beide „Wechselkurs" hießen, wäre nicht zu
   * sehen, welcher der Tageskurs ist und welcher in die Rechnung geht.
   */
  "param.usd_eur_rate": "USD/EUR Referenzkurs",
  /*
   * „Train" und nicht „Zugfracht": daneben stehen Sea und Air. Eine deutsche
   * Bezeichnung zwischen zwei englischen liest sich wie eine andere Art von
   * Angabe -- und das Haus bucht unter diesen drei Namen.
   */
  "param.rail_freight_usd_per_cbm": "Train",
  "param.csef_percent": "CSEF",
  "param.commission_percent": "Provision",
  "param.minimum_margin_percent": "Zielmarge",
  "param.list_price_divisor": "Listenpreis-Divisor",
  "param.rounding_step_eur": "Rundungsschritt",
  "calcInput.exw": "Einkaufspreis",
  "calcInput.volume_per_unit": "Volumen je Stück",
  "calcInput.tariff_code": "Zolltarifnummer",
  "calcInput.duty_rate": "Zollsatz",
  "calcInput.usd_eur_rate": "Wechselkurs",
  "calcInput.rail_freight_usd_per_cbm": "Zugfracht",
  "calcInput.csef_percent": "CSEF",
  "calcInput.commission_percent": "Provision",
  "calcInput.minimum_margin_percent": "Zielmarge",
  "calcInput.list_price_divisor": "Listenpreis-Divisor",
  "calcInput.rounding_step_eur": "Rundungsschritt",
  "detail.openDossier": "Produktakte",
  "list.createArticle": "+ Produkt anlegen",
  "neu.title": "Produkt anlegen",
  "neu.articleNumber": "Artikelnummer",
  "neu.articleNumberHint": "Die Artikelnummer ist die Identität des Artikels und lässt sich danach nicht mehr ändern.",
  "neu.familyChoose": "Bitte wählen",
  "neu.familyHint": "Die Familie bestimmt die Kategorie und die Zielmarge.",
  "neu.categoryFollows": "Kategorie: {category}",
  "neu.shortDescription": "Bezeichnung",
  "neu.shortDescriptionHint": "Optional. Eine Quellbezeichnung, kein Produktname – der Produktname entsteht später als redaktioneller Text.",
  "neu.roles": "Rollen",
  "neu.stepCategory": "Hauptkategorie",
  "neu.stepCategoryHint": "Sie grenzt die Familienliste ein. Die Kategorie des Artikels folgt später der Familie.",
  "neu.stepFamily": "Produktfamilie",
  "neu.stepBase": "Ausgangsprodukt",
  "neu.stepBaseHint": "Was es in dieser Familie schon gibt — zur Orientierung bei Nummer und Bezeichnung.",
  "neu.baseNone": "In dieser Familie ist noch kein Artikel angelegt.",
  "neu.stepVariant": "Variantenparameter",
  "neu.stepVariantHint": "In welchen Ausführungen es das Ausgangsprodukt gibt.",
  "neu.variantNoBase": "Ohne Ausgangsprodukt gibt es hier nichts zu zeigen.",
  "neu.variantNone": "Für dieses Produkt ist kein Variantenraum erfasst.",
  "neu.stepIdentity": "Identität",
  "neu.stepSummary": "Zusammenfassung",
  "neu.modelAxesHint": "Dieses Produkt gehört zum Produktmodell {model}. Die gewählten Ausprägungen werden als Variante festgehalten — ohne Merkmale zu kopieren.",
  "neu.variantTaken": "Diese Ausführung gibt es bereits: {number}. Ändere eine Ausprägung — zwei Produkte mit derselben Ausführung wären dasselbe Produkt.",
  "neu.variantTakenVirtual": "eine noch nicht angelegte Variante",
  "neu.modelFromBase": "wie Vorbild",
  "neu.modelTitle": "Produktmodell",
  "neu.modelKnowledge": "Gilt über das Produktmodell {model} — wird nicht kopiert, die Herkunft bleibt beim Modell.",
  "neu.modelChanges": "Variantenänderungen",
  "neu.modelUnchanged": "Unverändert gegenüber dem Vorbild",
  "neu.modelSkuOwn": "SKU-spezifisch",
  "neu.modelNoChange": "Keine Ausprägung unterscheidet sich vom Vorbild.",
  "neu.stepKind": "Anlageart",
  "neu.stepKindHint": "Entsteht eine Ausführung eines vorhandenen Produkts — oder ein Produkt ohne Vorbild?",
  "neu.kindVariant": "Variante eines bestehenden Produkts",
  "neu.kindVariantHint": "{n} Produkte dieser Familie stehen als Vorbild bereit.",
  "neu.kindVariantNone": "In dieser Familie gibt es noch kein Produkt als Vorbild.",
  "neu.kindPlain": "Produkt ohne Vorbild",
  "neu.kindPlainHint": "Nummer, Bezeichnung und Rollen werden selbst vergeben.",
  "neuCase.A": "Fall A — Variante eines bestehenden Produkts.",
  "neuCase.B": "Fall B — neues Produkt in einer bestehenden Produktfamilie.",
  "neuCase.C": "Fall C — erstes Produkt einer neu angelegten Produktfamilie.",
  "neu.familyAdd": "+ Neue Produktfamilie",
  "neu.categoryAdd": "+ Neue Hauptkategorie",
  "neu.categoryAddTitle": "Neue Hauptkategorie",
  "neu.categoryCode": "Kategoriekennung",
  "neu.categoryCodeHint": "Kurz und eindeutig, z. B. triproof. Gliedert den ganzen Katalog – nur anlegen, wenn wirklich eine neue Produktwelt beginnt.",
  "neu.categoryName": "Kategoriename",
  "neu.categoryCreate": "Hauptkategorie anlegen",
  "neu.categorySimilar": "Es gibt bereits eine ähnliche Hauptkategorie:",
  "neu.categorySimilarHint": "Prüfe, ob es dieselbe Produktwelt ist. HOMEBASE führt nichts zusammen und benennt nichts um.",
  "neu.familyAddTitle": "Neue Produktfamilie",
  "neu.familyCode": "Familienkennung",
  "neu.familyCodeHint": "Kurz und eindeutig, z. B. HB UGR. Über alle Kategorien hinweg nur einmal vergeben.",
  "neu.familyName": "Name der Produktfamilie",
  "neu.familyCreate": "Produktfamilie anlegen",
  "neu.familyArticles": "{n} Produkte",
  "neu.familySimilar": "Es gibt bereits eine ähnliche Produktfamilie:",
  "neu.familySimilarHint": "Prüfe, ob es dieselbe Baureihe ist. HOMEBASE führt nichts zusammen und benennt nichts um.",
  "neu.numberBase": "Das Vorbild trägt {number}. Die Nummernbildung ist je Familie verschieden — HOMEBASE schlägt deshalb keine vor.",
  "neu.numberTaken": "Diese Artikelnummer gibt es in dieser Familie bereits.",
  "neu.shortDescriptionFromBase": "Wörtlich aus {number} übernommen — bitte prüfen und anpassen.",
  "neu.shortDescriptionUnchanged": "Die Bezeichnung ist unverändert, obwohl sich Ausführungen unterscheiden.",
  "neu.shortDescriptionMissing": "Ohne Bezeichnung entsteht ein Produkt, das in keiner Liste zu erkennen ist.",
  "neu.twinTitle": "Möglicher fachlicher Doppelgänger:",
  "neu.twinHint": "Gleiche Familie, gleiche Ausführung. Prüfe, ob dieses Produkt schon existiert.",
  "neu.inheritTitle": "Wird übernommen",
  "neu.inheritFamily": "Produktfamilie als primäre Zuordnung",
  "neu.inheritCategory": "Hauptkategorie — sie folgt der Familie",
  "neu.inheritDescription": "Bezeichnung, wörtlich aus {number}",
  "neu.inheritModel": "Zugehörigkeit zum Produktmodell {model} samt gewählter Ausprägungen",
  "neu.notPropertiesModel": "Technische Merkmale — sie bleiben beim Vorbild; gemeinsames Wissen gehört ans Modell",
  "neu.notProperties": "Technische Merkmale",
  "neu.notTexts": "Produkttexte",
  "neu.notSupplier": "Lieferanten, Einkaufspreise und Konditionen",
  "neu.notLogistics": "Verpackung und Logistik",
  "neu.notCompliance": "Zertifizierungen",
  "neu.openTitle": "Danach zu klären",
  "neu.openLifecycle": "Sortimentsstatus — das Produkt startet als nicht freigegeben; die Freigabe ist eine eigene Entscheidung",
  "neu.openProperties": "Technische Merkmale in der Produktakte erfassen",
  "neu.openFamily": "Die neue Produktfamilie um ihre weiteren Angaben ergänzen",
  "neu.notRecordedTitle": "Wird NICHT mit angelegt",
  "neu.notRecordedHint": "Ausgangsprodukt und Ausführung dienen hier nur der Orientierung. Der neue Artikel entsteht mit Nummer, Familie, Bezeichnung und Rollen — eine Herkunft aus einem anderen Artikel wird nicht festgehalten.",
  "neu.back": "Zurück",
  "neu.next": "Weiter",
  "neu.create": "Anlegen",
  /* ── Technik: kompakte Ansicht und Bearbeitungsmodus ─────────────────── */
  "tk.editAria": "Technik bearbeiten",
  "tk.editing": "Technik bearbeiten",
  "tk.editHint": "Getippte Werte gelten erst nach dem Speichern. Bestätigen, Zurücknehmen und Entfernen wirken sofort — Speichern ist keine fachliche Bestätigung.",
  "tk.save": "Änderungen speichern",
  "tk.savedAll": "{n} Änderung(en) gespeichert.",
  "tk.savedSome": "{ok} gespeichert, {offen} nicht. Die offenen Eingaben stehen weiterhin da.",
  "tk.savedNone": "Nichts gespeichert. Die Eingaben stehen weiterhin da.",
  "tk.unconfirmed": "Noch nicht bestätigt",
  "tk.savedUnconfirmed": "Gespeichert · Noch nicht fachlich bestätigt",
  "tk.done": "Fertig",
  "tk.breaker": "Leuchten je Leitungsschutzschalter",
  "tk.breakerRow": "Leuchten je LS {breaker}",
  "tk.breakerEmpty": "Nicht bestimmt.",
  "tk.breakerCount": "{n} Leuchten",
  "tk.breakerCharacteristic": "Charakteristik",
  "tk.breakerCurrent": "Nennstrom",
  "tk.breakerMax": "maximale Anzahl",
  "tk.breakerErrCurrent": "Bitte einen Nennstrom als ganze Zahl ab 1 eintragen.",
  "tk.breakerErrCount": "Bitte eine Anzahl als ganze Zahl ab 1 eintragen.",
  "tk.changed": "Geändert, nicht gespeichert",
  "tk.invalid": "Eingabefehler",
  "tk.confirmBusy": "Erst speichern, dann bestätigen.",
  "tk.sources": "Quellen dieser Gruppe",
  /*
   * Der Pruef- und Befundstand als eine Zeile ueber dem Technikbereich.
   *
   * Ein- und Mehrzahl sind eigene Schluessel, weil diese Uebersetzung
   * bewusst keine Pluralregeln kennt (`i18n/index.tsx`). „1 offene
   * Vorschläge" waere in einer Zeile, die Ruhe herstellen soll, genau der
   * Stolperstein, der sie wieder nimmt.
   *
   * Die Wortwahl ist gezaehlt und nicht bewertet: „technische Werte", nicht
   * „gepflegte Merkmale"; „noch nicht bestaetigt" kommt hier gar nicht vor,
   * weil die Zeile sagt, was DA IST -- nicht, was fehlt.
   */
  "tk.standWert": "1 technischer Wert",
  "tk.standWerte": "{n} technische Werte",
  "tk.standBestaetigt": "{n} fachlich bestätigt",
  "tk.standBefund": "1 Befund",
  "tk.standBefunde": "{n} Befunde",
  "tk.standVorschlag": "1 offener Vorschlag",
  "tk.standVorschlaege": "{n} offene Vorschläge",
  "tk.inherited": "Modell",
  "tk.confirmAtModel": "Bestätigung am Produktmodell",
  "tk.confirmStored": "Gespeicherten Wert bestätigen …",
  "tk.clarifyReason": "Warum ist das kein Widerspruch?",
  "tk.clarifyNote": "Die Begründung bleibt im Protokoll. Ändert sich die Quelle später, erscheint der Widerspruch erneut.",
  "tk.clarifySave": "Bestätigen",
  "tk.fromExecution": "Ausführung",
  "tk.fromExecutionTitle": "Wert der Modellausführung, in der diese SKU steht. Er wurde beim Zuordnen übernommen und gehört seitdem zur SKU.",
  "tk.ownValue": "eigener Wert",
  "tk.ownValueTitle": "An dieser SKU erfasst – weder vom Produktmodell geerbt noch aus der Ausführung übernommen.",
  "tk.inheritedTitle": "Geerbt vom Produktmodell {model}. Eine Änderung legt einen eigenen Wert dieser SKU an; das Modell bleibt unverändert.",
  "tk.errEmpty": "Bitte einen Wert eintragen oder den Wert entfernen.",
  "tk.errNumber": "Bitte eine Zahl eintragen.",
  "tk.errInteger": "Bitte eine ganze Zahl eintragen.",
  "tk.errOrder": "Der obere Wert darf nicht kleiner sein als der untere.",
  "tk.leaveTitle": "Ungespeicherte Änderungen",
  "tk.leaveText": "In der Technik stehen Änderungen, die noch nicht gespeichert sind.",
  "tk.leaveSave": "Speichern und fortfahren",
  "tk.leaveDiscard": "Verwerfen und fortfahren",
  "tk.leaveStay": "Weiter bearbeiten",
  "trash.open": "Papierkorb",
  "trash.openTitle": "Gelöschte Produkte ansehen",
  "trash.back": "Zurück",
  "trash.title": "Papierkorb",
  "trash.intro": "Weggeräumte Produkte. Sie erscheinen in keiner Produktliste, bleiben aber vollständig erhalten und können wiederhergestellt werden.",
  "trash.empty": "Der Papierkorb ist leer.",
  "trash.number": "Artikelnummer",
  "trash.description": "Bezeichnung",
  "trash.family": "Produktfamilie",
  "trash.deletedAt": "Gelöscht am",
  "trash.deletedBy": "Gelöscht von",
  "trash.reason": "Löschgrund",
  "trash.noDescription": "ohne Bezeichnung",
  "trash.restore": "Wiederherstellen",
  "trash.purgeOpen": "Endgültig löschen …",
  "trash.preflightTitle": "Endgültig löschen: {number}",
  "trashKind.anlage": "entsteht bei der Anlage",
  "trashKind.fachdaten": "Produktwissen",
  "trashKind.historie": "betriebliche Historie",
  "trashKind.nachweis": "Nachweis, bleibt erhalten",
  "trashStatus.safe": "Sicher löschbar",
  "trashStatus.requires_review": "Prüfung erforderlich",
  "trashStatus.blocked": "Nicht löschbar",
  "trash.confirmLabel": "Zur Bestätigung {number} eingeben:",
  "trash.purgeConfirm": "Endgültig löschen",
  "trash.blockedHint": "Der Artikel bleibt im Papierkorb. Endgültig gelöscht wird nur, was keine betriebliche Historie und kein Produktwissen mehr trägt.",
  "trash.close": "Schließen",
  "akte.trash": "In den Papierkorb verschieben",
  "akte.trashTitle": "Produkt weglegen",
  "akte.trashHeading": "{number} in den Papierkorb verschieben?",
  "akte.trashText": "Das Produkt verschwindet aus allen Produktlisten. Merkmale, Texte und Beziehungen bleiben erhalten, und es kann jederzeit wiederhergestellt werden.",
  "akte.trashReason": "Löschgrund",
  "akte.trashNote": "Erläuterung",
  "akte.trashNotePlaceholder": "Woran lag es?",
  "akte.trashConfirm": "In den Papierkorb",
  "akte.trashCancel": "Abbrechen",
  "deletionReason.irrtuemlich_angelegt": "Irrtümlich angelegt",
  "deletionReason.dublette": "Dublette",
  "deletionReason.testartikel": "Testartikel",
  "deletionReason.anlage_abgebrochen": "Anlage abgebrochen",
  "deletionReason.sonstiger_grund": "Sonstiger Grund",
  "error.article_number_taken": "Diese Artikelnummer ist bereits vergeben.",
  "error.article_number_in_trash": "Diese Artikelnummer liegt im Papierkorb. Der Artikel kann dort geprüft und wiederhergestellt werden.",
  "error.article_number_previously_deleted": "Diese Artikelnummer wurde früher verwendet und endgültig gelöscht. Eine Wiederverwendung muss ausdrücklich bestätigt werden.",
  "error.already_trashed": "Dieses Produkt liegt bereits im Papierkorb.",
  "error.not_trashed": "Dieses Produkt liegt nicht im Papierkorb.",
  "error.reason_required": "Bitte einen Löschgrund wählen.",
  "error.invalid_reason": "Diesen Löschgrund gibt es nicht.",
  "error.note_required": "Bei diesem Löschgrund ist eine Erläuterung erforderlich.",
  "error.delete_blocked": "Dieses Produkt kann nicht endgültig gelöscht werden. Der Löschbefund nennt den Grund.",
  "error.confirmation_mismatch": "Zur Bestätigung muss die Artikelnummer genau eingegeben werden.",
  "neu.numberInTrash": "{number} liegt im Papierkorb. Der Artikel kann dort geprüft und wiederhergestellt werden.",
  "neu.numberInTrashOpen": "Papierkorb öffnen",
  "error.invalid_article_number": "Artikelnummer: Buchstaben, Ziffern, Punkt, Bindestrich, Schrägstrich, Plus.",
  "error.invalid_family": "Diese Produktfamilie gibt es nicht.",
  "error.invalid_article": "Diesen Artikel gibt es nicht.",
  "error.invalid_lifecycle": "Diesen Sortimentsstatus gibt es nicht.",
  "error.invalid_stocking_type": "Diese Sortimentsrolle gibt es nicht.",
  "error.invalid_relation_type": "Diese Beziehungsart gibt es nicht.",
  "error.invalid_characteristic": "Charakteristik: B, C, D oder A nach IEC 60898-1.",
  "error.relation_exists": "Diese Beziehung besteht bereits.",
  "error.self_relation": "Ein Artikel steht nicht zu sich selbst in Beziehung.",
  "error.capacity_exists": "Für diese Charakteristik und diesen Strom besteht bereits eine Angabe.",
  "error.asked_at_required": "Bei „angefragt“ ist das Datum der Anfrage erforderlich.",
  "error.lifecycle_missing": "Der Sortimentsstatus „Noch nicht freigegeben“ fehlt im Wertevorrat. Das ist ein Fehler der Einrichtung, kein Eingabefehler.",
  "models.category": "Hauptkategorie",
  "models.sectionPlacement": "Einordnung",
  "models.sectionModel": "Produktmodell",
  "models.familyAfterCategory": "zuerst Hauptkategorie wählen",
  "models.codeHint": "Kurz und eindeutig, z. B. TP154.",
  "models.nameHint": "Sprechend, z. B. TP PRO TP154.",
  "models.textsLater": "Beschreibungen und Langtexte gehören zum fertigen Modell – sie stehen dort im Reiter „Texte & Dokumente“.",
  "neu.model": "Produktmodell",
  "neu.modelChoose": "Bitte wählen",
  "neu.modelHint": "Die technische Plattform innerhalb dieser Produktfamilie. Sie bestimmt, welche Variantenparameter zur Wahl stehen.",
  "neu.modelOnly": "Produktmodell {model} — das einzige dieser Produktfamilie.",
  "neu.modelNone": "Für diese Produktfamilie gibt es noch kein Produktmodell. Unter Produktmodelle lässt sich eines anlegen; ohne Modell zeigt dieser Schritt nur den Variantenraum des Vorbilds.",
  "neu.modelNoAxes": "Das Produktmodell {model} führt noch keine Variantenparameter. Unter Produktmodelle lassen sich Achsen und zulässige Werte pflegen.",
  "neu.modelNoneHere": "Für {family} gibt es noch kein Produktmodell.",
  "neu.modelAdd": "+ Neues Produktmodell",
  "neu.modelAddTitle": "Neues Produktmodell",
  "neu.modelForFamily": "Es gehört zur Produktfamilie {family}.",
  "neu.modelCode": "Modellkennung",
  "neu.modelCodeHint": "Kurz und eindeutig, z. B. HB200-U. Die technische Plattform, nicht die Artikelnummer.",
  "neu.modelName": "Name des Produktmodells",
  "neu.modelCreate": "Produktmodell anlegen",
  /* Produktmodelle 002 -- Modellseite V2 und sichere Modellfreigabe. */
  "mtab.overview": "Übersicht",
  "mtab.common": "Gemeinsame Daten",
  "mtab.executions": "Ausführungen",
  "mtab.content": "Texte & Dokumente",
  "mtab.history": "Verlauf",
  "mp.proposal": "Vorschlag – bitte bestätigen",
  "mp.editMaster": "Stammdaten bearbeiten",
  "mp.kpiExecutions": "Ausführungen",
  "mp.kpiSkus": "Artikel/SKUs",
  "mp.kpiCalculated": "kalkuliert",
  "mp.kpiReleased": "Preis freigegeben",
  "mp.note": "Notiz",
  "mp.codeReadonly": "Der Modellcode {code} bleibt hier unverändert: er steht in freigegebenen Modelltexten und Modellfreigaben.",
  "mp.familyReadonly": "Die Produktfamilie wird hier nicht gewechselt – alle zugeordneten Artikel müssten mitwechseln.",
  "mp.statusTitle": "Zustand je Ausführung",
  "mp.commonLabel": "Gemeinsam:",
  "mp.appliesToAll": "gilt für alle angelegten Ausführungen",
  "mp.furtherValue": "Weiterer verfügbarer Wert ({prop}):",
  "mp.noExecution": "keine Ausführung angelegt",
  "mp.noExecutionCell": "Für diese Kombination ist keine Ausführung angelegt.",
  "mp.stTechnik": "Technik",
  "mp.stEinkauf": "Einkauf",
  "mp.stZoll": "Zoll",
  "mp.stVerpackung": "Verpackung",
  "mp.stKalkulation": "kalkulierbar",
  "mp.inheritedFromModel": "vom Produktmodell geerbt",
  "mp.priceReleased": "{amount} € freigegeben",
  "mp.priceCalculated": "{amount} € berechnet",
  "mp.priceNone": "kein Listenpreis",
  "mp.colSupplier": "Lieferant",
  "mp.colExw": "EXW",
  "mp.colCalculable": "Kalkulierbar",
  "mp.colLatest": "Letzter Stand",
  "mp.colCalculated": "Listenpreis berechnet",
  "mp.colReleased": "Listenpreis freigegeben",
  "mp.missingShort": "Es fehlt heute:",
  "mp.inheritedShort": "(geerbt)",
  "mp.matrixRows": "Zeilen: {a}",
  "mp.matrixCols": "Spalten: {a}",
  "mp.packOwn": "eigener Stand",
  "mp.latestIncomplete": "(unvollständig)",
  "mp.noCalculation": "nicht kalkuliert",
  "mp.notOnModel": "nicht am Modell",
  "mp.commonValue": "Gemeinsamer Wert",
  "mp.axisProperty": "Ausführungsmerkmal",
  "mp.axisValues": "je Ausführung verschieden",
  "mp.axisWhere": "gepflegt im Reiter „Ausführungen“",
  "mp.axisHasModelValue": "Ausführungsmerkmal mit Modellwert",
  "mp.axisHasModelValueTitle": "Dieses Merkmal unterscheidet die Ausführungen und trägt trotzdem einen gemeinsamen Modellwert. Klicken, um ihn zu entfernen – die Werte der Ausführungen bleiben.",
  "mp.toggleOnTitle": "Diesen beobachteten Wert als gemeinsamen Modellwert übernehmen",
  "mp.toggleOffTitle": "Diesen gemeinsamen Modellwert wieder entfernen",
  "mp.toggleNoValue": "Es gibt keinen beobachteten Wert, der übernommen werden könnte.",
  "mp.toggleAmbiguous": "Die Ausführungen tragen verschiedene Werte – bitte in der Vorschau entscheiden.",
  "mp.chooseCandidate": "mehrere verschiedene Werte",
  "mp.ambiguousNote": "Die Ausführungen tragen verschiedene Werte. Ein gemeinsamer Wert entsteht hier nicht automatisch – entweder ist es ein Ausführungsmerkmal, oder die abweichenden Werte gehören zuerst korrigiert.",
  "mp.removeResult": "kein gemeinsamer Wert mehr",
  "mp.removeLosing": "{n} Ausführungen zeigen diesen Wert heute geerbt – danach nicht mehr. Ihre eigenen Werte bleiben unberührt.",
  "mp.removeNoLoss": "Keine Ausführung erbt diesen Wert – das Entfernen ändert nichts an den SKUs.",
  "mp.coverage": "gilt für {n} von {total} Ausführungen",
  "mp.onlyOnSkus": "nur an {n} von {total} Ausführungen gepflegt",
  "mp.ownValues": "{n} mit eigenem Wert",
  "mp.ownSame": "{n} mit eigenem, gleichem Wert",
  "mp.dropOwnTitle": "Diese Ausführungen tragen denselben Wert noch einmal selbst. Klicken, um den doppelten eigenen Wert abzugeben – danach erben sie den Modellwert.",
  "mp.dropOwnTitel": "Doppelt gepflegten Wert abgeben",
  "mp.dropOwnFuture": "Diese Ausführungen erben danach den Modellwert:",
  "mp.dropOwnConfirm": "Ausgewählte eigene Werte abgeben",
  "mp.dropOwnOriginLost": "Eigene Herkunft entfällt: {eigen} – die Ausführung zeigt danach {modell}.",
  "mp.dropOwnSegmentLost": "Der festgehaltene Quellwortlaut „{segment}“ entfällt mit.",
  "mp.dropOwnQualityBlocked": "Gesperrt: Diese Ausführung trägt den identischen Wert mit einer stärkeren Bestätigung als das Produktmodell. Bitte zuerst den Modellwert bestätigen. Erst danach kann der eigene Wert abgegeben werden.",
  "mp.dropOwnClarificationBlocked": "Gesperrt: Zu diesem Eigenwert existiert noch eine Klärung. Bitte lösen Sie diesen Punkt zuerst, bevor der eigene Wert abgegeben werden kann.",
  "mp.dropOwnProposalBlocked": "Gesperrt: Zu diesem Eigenwert existiert noch ein offener Wertvorschlag. Bitte lösen Sie diesen Punkt zuerst, bevor der eigene Wert abgegeben werden kann.",
  "mp.dropOwnNoneFree": "Keine dieser Ausführungen kann ihren eigenen Wert zurzeit abgeben.",
  "mp.dropOwnNote": "{n} Ausführung(en) geben ihren eigenen Wert ab und erben ihn danach vom Modell: {list}. Der gemeinsame Modellwert bleibt unverändert.",
  "mp.ownDiffers": "{n} mit abweichendem Wert",
  "mp.adopt": "Als gemeinsamen Wert übernehmen …",
  "mp.adoptPack": "Diesen Stand als gemeinsame Verpackung übernehmen …",
  "mp.packMaster": "Masterkarton {l} × {b} × {h} mm",
  "mp.packNoMaster": "ohne Masterkarton",
  "mp.packUnits": "{n} Stück je Master",
  "mp.packRevision": "Rev. {n}",
  "mp.commonNote": "Werte am Produktmodell gelten für jede Ausführung ohne eigenen Wert. Ein eigener Wert an der Ausführung geht vor und bleibt sichtbar.",
  "mp.cardMasse": "Maße & Gewicht",
  "mp.cardVerpackung": "Verpackung & Masterkarton",
  "mp.cardZoll": "Zoll",
  "mp.cardTechnik": "Technik",
  "mp.cardZert": "Zertifizierungen / Konformitäten",
  "mp.cardNachweise": "Nachweise",
  "mp.cardEmpty": "Noch keine gemeinsamen Werte.",
  "mp.onModel": "Am Modell",
  "mp.ownStand": "eigener Stand",
  "mp.inheritsFromModel": "erbt vom Modell",
  "mp.none": "keiner",
  "mp.tariffOnModel": "Zolltarifnummer am Modell",
  "mp.differsNote": "Unterscheiden sich je Ausführung (siehe Reiter Ausführungen): {list}",
  "mp.evidenceNotModel": "Nachweise hängen heute nur an der einzelnen Ausführung – am Modell sind sie noch nicht pflegbar (folgt mit BLOCK 003).",
  "mp.editDirect": "Gemeinsame Daten direkt pflegen",
  "mp.refresh": "Abdeckung neu laden",
  "mp.adoptTitle": "Vorschau: gemeinsamer Wert am Modell",
  "mp.adoptFuture": "Künftiger Modellwert:",
  "mp.adoptKeepsOwn": "behält seinen eigenen Wert: {value}",
  "mp.adoptInherits": "erbt künftig vom Modell",
  "mp.adoptNote": "Die Werte der Ausführungen bleiben unverändert – nichts wird gelöscht. Der Modellwert beginnt ungeprüft.",
  "mp.adoptFromArticle": "Werte aus bestehendem Artikel übernehmen",
  "mp.adoptFromArticleNote": "Ein bestehender Artikel dieses Modells kann die Quelle für gemeinsame Modellwerte sein. Vorgeschlagen wird nur, was modellweit gelten kann – Ausführungsmerkmale nie.",
  "mp.adoptSource": "Quellartikel",
  "mp.adoptAnalyse": "Werte ansehen",
  "mp.adoptCandidates": "{n} übernehmbare Werte aus {number}",
  "mp.adoptNothing": "Aus diesem Artikel lässt sich derzeit nichts übernehmen.",
  "mp.adoptValues": "{n} Werte",
  "mp.adoptSkipped": "Nicht vorgeschlagen:",
  "mp.adoptWhyAxis": "Ausführungsmerkmal",
  "mp.adoptWhyModel": "das Modell trägt bereits einen Wert",
  "mp.adoptWhyLevel": "auf Modellebene nicht geführt",
  "mp.adoptSelected": "{n} Werte übernehmen",
  "mp.adoptedCount": "{n} Werte als gemeinsame Modellwerte übernommen.",
  "mp.adoptConfirm": "Übernehmen",
  "mp.deviationsTitle": "Worin sich die Ausführungen unterscheiden",
  "mp.deviationsNote": "Nur Merkmale mit unterschiedlichen Werten. Gemeinsame Werte stehen unter „Gemeinsame Daten“.",
  "mp.colProperty": "Merkmal",
  "mp.editAxes": "Ausführungsmerkmale bearbeiten",
  "mp.documentsTitle": "Dokumente der Baureihe",
  "mp.editDocuments": "Dokumente bearbeiten",
  "mp.documentsNote": "Hier abgelegte Dokumente gelten für alle Ausführungen und erscheinen an jeder SKU als geerbt.",
  "mp.historyEmpty": "Noch keine Änderungen protokolliert.",
  "mp.colWhen": "Zeitpunkt",
  "mp.colWho": "Benutzer",
  "mp.colArea": "Bereich",
  "mp.colAction": "Aktion",
  "mp.colChange": "Änderung",
  "mp.blocker.no_calculation": "kein Kalkulationsstand",
  "mp.blocker.calculation_incomplete": "letzter Stand unvollständig",
  "mp.blocker.basis_incomplete": "Kalkulationsbasis heute unvollständig",
  "mpArea.master": "Stammdaten",
  "mpArea.executions": "Ausführungen",
  "mpArea.logistics": "Logistik & Zoll",
  "mpArea.properties": "Merkmale",
  "mpArea.common": "Gemeinsame Daten",
  "modelLog.created": "Modell angelegt",
  "modelLog.deleted": "Modell gelöscht",
  "modelLog.code": "Modellcode geändert",
  "modelLog.name": "Modellname geändert",
  "modelLog.family": "Produktfamilie geändert",
  "modelLog.provenance": "Modell bestätigt",
  "modelLog.note": "Notiz geändert",
  "modelLog.dimension_added": "Ausführungsmerkmal hinzugefügt",
  "modelLog.dimension_removed": "Ausführungsmerkmal entfernt",
  "modelLog.dimension_value_added": "Zulässigen Wert hinzugefügt",
  "modelLog.dimension_value_removed": "Zulässigen Wert entfernt",
  "modelLog.variant_created": "Ausführung angelegt",
  "modelLog.variant_deleted": "Ausführung entfernt",
  "modelLog.variant_article": "Artikel der Ausführung geändert",
  "modelLog.variant_values": "Werte der Ausführung geändert",
  "modelLog.focus_rank": "Fokus geändert",
  "modelLog.article_assigned": "Artikel zugeordnet",
  "modelLog.article_unassigned": "Artikelzuordnung gelöst",
  "modelLog.common_value_adopted": "Gemeinsamen Wert übernommen",
  "modelLog.tariff_code": "Zolltarifnummer gesetzt",
  "modelLog.packaging_created": "Verpackungsstand angelegt",
  "modelLog.packaging_deleted": "Verpackungsstand entfernt",
  "modelLog.packaging_reason": "Änderungsgrund geändert",
  "modelLog.packaging_provider": "Bereitsteller geändert",
  "modelLog.packaging_origin": "Herkunft der Verpackung geändert",
  "modelLog.packaging_method": "Entstehung der Verpackung geändert",
  "modelLog.packaging_quality": "Prüfstand der Verpackung geändert",
  "modelLog.packaging_residual": "Restmaterial bestätigt",
  "modelLog.level_added": "Verpackungsebene hinzugefügt",
  "modelLog.level_changed": "Verpackungsebene geändert",
  "modelLog.level_removed": "Verpackungsebene entfernt",
  "modelLog.materials_set": "Verpackungsmaterialien gesetzt",
  "modelLog.test_added": "Verpackungsprüfung hinzugefügt",
  "modelLog.test_removed": "Verpackungsprüfung entfernt",
  "modelLog.property_created": "Merkmalswert angelegt",
  "modelLog.property_deleted": "Merkmalswert entfernt",
  "modelLog.property_value": "Merkmalswert geändert",
  "modelLog.property_quality": "Prüfstand geändert",
  "modelLog.property_origin": "Herkunft geändert",
  "modelLog.property_method": "Entstehung geändert",
  "modelLog.property_provenance": "Herkunft geändert",
  "modelLog.property_befund_geklaert": "Prüfbefund geklärt",
  "release.previewTitle": "Margenprüfung je Ausführung",
  "release.notVerifiable": "{n} Ausführung(en) können nicht geprüft werden – eine Modellfreigabe verlangt für jede Ausführung eine bestimmbare Marge.",
  "release.colSku": "SKU",
  "release.colCostBase": "Kostenbasis",
  "release.colPrice": "Freigabepreis",
  "release.colMargin": "Marge",
  "release.colTarget": "Zielmarge",
  "release.colStatus": "Status",
  "release.statusOk": "OK",
  "release.statusBelow": "unter Zielmarge",
  "release.statusNotVerifiable": "NICHT PRÜFBAR",
  "form.why.modelNotVerifiable": "{n} Ausführung(en) nicht prüfbar – Modellfreigabe gesperrt.",
  "error.model_release_not_verifiable": "Mindestens eine Ausführung kann nicht geprüft werden – eine Modellfreigabe verlangt für jede Ausführung eine bestimmbare Marge.",
  "error.not_a_candidate": "Dieser Wert ist nicht (mehr) als gemeinsamer Wert übernehmbar.",
  "error.axis_property": "Dieses Merkmal unterscheidet in diesem Produktmodell die Ausführungen und kann deshalb kein gemeinsamer Modellwert sein.",
  "error.common_value_exists": "Das Produktmodell trägt zu diesem Merkmal einen gemeinsamen Wert. Er muss entfernt werden, bevor das Merkmal die Ausführungen unterscheiden kann.",
  "error.value_differs": "Diese Ausführung trägt einen anderen Wert als das Modell. Ein abweichender Wert wird hier nicht entfernt – darüber entscheidet ein Mensch.",
  "error.no_own_value": "Diese Ausführung trägt zu diesem Merkmal keinen eigenen Wert.",
  "error.quality_would_drop": "Diese Ausführung trägt den identischen Wert mit einer stärkeren Bestätigung als das Produktmodell. Bitte zuerst den Modellwert bestätigen.",
  "error.clarification_or_proposal_present": "Zu diesem Eigenwert besteht noch eine Klärung oder ein offener Wertvorschlag. Bitte lösen Sie diesen Punkt zuerst.",
  /* Produktmodelle 002A -- Artikelzuordnung und sicheres Loeschen. */
  "mp.noArticle": "Kein Artikel zugeordnet",
  "mp.kpiOpen": "{n} Ausführungen ohne Artikelnummer",
  "mp.moreActions": "Weitere Aktionen",
  "mz.open": "Artikel zuordnen",
  "mz.title": "Artikel dieser Ausführung zuordnen",
  "mz.existing": "Bestehenden Artikel zuordnen",
  "mz.new": "Neuen Artikel anlegen",
  "mz.waysNote": "Zugeordnet wird immer ein HOMEBASE-Artikel – keine bloße Artikelnummer. Ein neuer Artikel entsteht über den Produktassistenten, mit dieser Ausführung vorbelegt.",
  "mz.searchPlaceholder": "Artikelnummer oder Bezeichnung suchen …",
  "mz.candidatesNote": "Angeboten werden nur Artikel der Produktfamilie dieses Modells. Gesperrte stehen mit Grund da.",
  "mz.noCandidates": "Keine Artikel gefunden.",
  "mz.blocked": "gesperrt",
  "mz.fits": "passt",
  "mz.fitsWithAdopt": "passt – fehlende Werte würden übernommen",
  "mz.model": "Produktmodell",
  "mz.execution": "Ausführung",
  "mz.article": "Ausgewählter Artikel",
  "mz.chkFamily": "Familie passend",
  "mz.chkCategory": "Kategorie passend",
  "mz.chkValues": "Ausführungsmerkmale passend",
  "mz.missingValues": "{n} fehlen am Artikel",
  "mz.chkOtherModel": "bereits anderem Modell zugeordnet",
  "mz.chkOtherExecution": "bereits andere Ausführung",
  "mz.chkConflicts": "Konflikte",
  "mz.colExecution": "Ausführung",
  "mz.colArticle": "Artikel",
  "mz.status.ok": "passt",
  "mz.status.conflict": "Widerspruch",
  "mz.status.missing": "fehlt – übernehmbar",
  "mz.status.unclear": "fehlt – nicht sicher übertragbar",
  "mz.adoptMissing": "Fehlende Werte aus der Ausführung am Artikel anlegen: {list}",
  "mz.why.adoptMissing": "Am Artikel fehlen Ausführungswerte – bitte die Übernahme ausdrücklich bestätigen.",
  "mz.assign": "Zuordnen",
  "mz.replace": "Wechseln und zuordnen",
  "mz.currentArticle": "Aktuell zugeordnet:",
  "mz.confirmReplace": "Bisherige Zuordnung von {old} lösen und {neu} zuordnen",
  "mz.confirmReplaceNote": "{old} wird NICHT gelöscht – nur seine Verbindung zu dieser Ausführung geht. Die Artikelnummer bleibt belegt.",
  "mz.why.confirmReplace": "Diese Ausführung trägt bereits einen Artikel – bitte den Wechsel ausdrücklich bestätigen.",
  "mz.back": "Anderen Artikel wählen",
  "mz.block.trashed": "Der Artikel liegt im Papierkorb.",
  "mz.block.placeholder": "Die Artikelnummer ist ein Platzhalter.",
  "mz.block.family_mismatch": "Der Artikel gehört nicht zur Produktfamilie dieses Modells.",
  "mz.block.category_mismatch": "Die Kategorie des Artikels passt nicht.",
  "mz.block.other_model": "Der Artikel gehört bereits zu einem anderen Produktmodell – er wird nicht umgehängt.",
  "mz.block.other_execution": "Der Artikel ist bereits einer anderen Ausführung zugeordnet.",
  "mz.block.execution_taken": "Diese Ausführung hat bereits einen Artikel.",
  "mz.block.value_conflict": "Ein Merkmal des Artikels widerspricht der Ausführung – nichts wird überschrieben.",
  "mz.block.not_main_product": "Zubehör, Komponenten und Ersatzteile sind keine Ausführung – sie hängen ohne Ausführungsbezug am Modell.",
  "mz.block.value_unclear": "Ein fehlender Wert lässt sich nicht sicher aus der Ausführung übertragen.",
  "mz.deleteOpen": "Produktmodell löschen …",
  "mz.deleteTitle": "Produktmodell löschen",
  "mz.deleteRemoves": "Beim Löschen werden entfernt:",
  "mz.deleteModel": "das Produktmodell {code}",
  "mz.deleteExecutions": "{n} ausschließlich diesem Modell gehörende Ausführungen ohne Artikel",
  "mz.deleteAxes": "{n} Ausführungsmerkmale mit {values} zulässigen Werten",
  "mz.deleteNoArticles": "Es werden KEINE Artikel, Preise, Dokumente oder Fachdaten gelöscht.",
  "mz.deleteHistory": "{n} Verlaufseinträge bleiben erhalten.",
  "mz.deleteConfirm": "Ich will {code} endgültig löschen.",
  "mz.deleteButton": "Endgültig löschen",
  "mz.notDeletable": "Dieses Produktmodell kann nicht gelöscht werden, weil daran noch Fachdaten hängen:",
  "mz.archiveLater": "Archivieren folgt mit PRODUKTMODELLE 003.",
  "mz.dep.articles": "{n} zugeordnete Artikel",
  "mz.dep.executions_with_article": "{n} Ausführungen mit Artikel",
  "mz.dep.texts": "{n} Modelltexte",
  "mz.dep.properties": "{n} Modellmerkmale",
  "mz.dep.documents": "{n} Dokumente",
  "mz.dep.packaging": "{n} Verpackungsstände",
  "mz.dep.requests": "{n} Informationsanfragen",
  "neu.fromExecution": "Neuer Artikel für die Ausführung {execution}",
  "modelLog.execution_assigned": "Artikel einer Ausführung zugeordnet",
  "error.assignment_blocked": "Dieser Artikel kann der Ausführung nicht zugeordnet werden.",
  "error.values_missing": "Am Artikel fehlen Ausführungswerte – die Übernahme muss ausdrücklich bestätigt werden.",
  "error.execution_in_use": "Die Zuordnung kann wegen vorhandener Fachdaten nicht entfernt werden.",
  "mp.statusEmpty": "Noch keiner Ausführung ist ein Artikel zugeordnet – der Zustand erscheint, sobald eine Ausführung ihren Artikel hat.",
  "mp.inTrash": "im Papierkorb: {number}",
  "mz.replacesTrashed": "Diese Ausführung hält noch {number} im Papierkorb. Eine neue Zuordnung ersetzt ihn; seine Wiederherstellung bringt die Ausführung dann nicht zurück.",
  /* Produktmodelle 002B -- Korrekturworkflow. */
  "mk.actions": "Aktionen",
  "mk.catalog": "Merkmalskatalog",
  "mk.catalogNote": "Fehlt ein Merkmal, entsteht es hier – und wird sofort im Modell verwendbar. Ein Merkmal aus diesem Modell zu entfernen ist etwas anderes: das erledigt der Schalter „Gemeinsamer Wert“ in der Zeile.",
  "mk.newProperty": "+ Merkmal anlegen",
  "mk.manageExisting": "Vorhandenes Merkmal pflegen",
  "mk.code": "Technischer Schlüssel",
  "mk.codeHint": "Kleinbuchstaben, Ziffern, Unterstriche – z. B. dc_output_current. Er ist später nicht mehr änderbar.",
  "mk.nameDe": "Name (deutsch)",
  "mk.nameEn": "Name (englisch)",
  "mk.group": "Merkmalsgruppe",
  "mk.valueType": "Datentyp",
  "mk.type.range": "Bereich oder Einzelwert",
  "mk.type.integer": "Ganze Zahl",
  "mk.type.decimal": "Dezimalzahl",
  "mk.type.text": "Text",
  "mk.type.boolean": "Ja/Nein",
  "mk.unit": "Einheit",
  "mk.unitHint": "Symbol einer bekannten Einheit, z. B. mA oder V. Nur bei Zahlenmerkmalen.",
  "mk.similar": "Es gibt bereits ähnliche Merkmale:",
  "mk.similarInUse": ", in Gebrauch",
  "mk.create": "Merkmal anlegen",
  "mk.structure": "Struktur",
  "mk.structureFree": "Datentyp und Einheit sind noch änderbar",
  "mk.structureLocked": "Datentyp und Einheit sind gesperrt",
  "mk.confirmLabel": "Zur Bestätigung {code} eintippen",
  "mk.delete": "Systemweit löschen",
  "mk.openArticle": "Artikel öffnen",
  "mk.change": "Zuordnung ändern …",
  "mk.unassignOpen": "Zuordnung lösen …",
  "mk.discardOpen": "Fehlerhafte Anlage verwerfen …",
  "mk.unassignTitle": "Artikelzuordnung lösen",
  "mk.unassignText": "Du löst {number} von dieser Ausführung.",
  "mk.unassignKeepsArticle": "Der Artikel wird NICHT gelöscht – er bleibt mit allen Daten bestehen.",
  "mk.unassignKeepsNumber": "Die Artikelnummer bleibt belegt.",
  "mk.unassignFree": "Die Ausführung steht danach wieder für einen Artikel zur Verfügung.",
  "mk.unassignKeepData": "Am Artikel hängen Fachdaten; sie bleiben bei ihm: {list}.",
  "mk.unassignBlocked": "Die Zuordnung kann nicht gelöst werden: {list}. Bitte den bestehenden Artikel korrigieren.",
  "mk.unassign": "Zuordnung lösen",
  "mk.bind.calculations": "Kalkulationsstände vorhanden",
  "mk.bind.price_releases": "Preisfreigaben vorhanden",
  "mk.bind.offers": "Angebote vorhanden",
  "mk.bind.stock": "Lagerbestand vorhanden",
  "mk.bind.incoming": "Zulauf vorhanden",
  "mk.bind.dte_events": "DTE-Listungsereignisse vorhanden",
  "mk.bind.dte_listed": "in DTE vorgemerkt oder gelistet",
  "mk.bind.no_article": "Diese Ausführung trägt keinen Artikel.",
  "mk.discardTitle": "Fehlerhafte Anlage verwerfen",
  "mk.discardSteps": "Beim Verwerfen passiert der Reihe nach:",
  "mk.stepUnassign": "Die Zuordnung zur Modellausführung wird gelöst.",
  "mk.stepTrash": "Der Artikel wird in den Papierkorb verschoben.",
  "mk.stepPurge": "Der Artikel wird endgültig gelöscht – mit Grabstein im Protokoll.",
  "mk.stepNumberFree": "Danach ist die Artikelnummer {number} wieder frei.",
  "mk.discardLosing": "Damit verschwinden auch: {list}.",
  "mk.discardConfirmLabel": "Zur Bestätigung {number} eintippen",
  "mk.discard": "Verwerfen und endgültig löschen",
  "mkRef.calculations": "Kalkulationsstände",
  "mkRef.price_releases": "Preisfreigaben",
  "mkRef.offers": "Angebote",
  "mkRef.stock": "Lagerbestände",
  "mkRef.incoming": "Zuläufe",
  "mkRef.dte_events": "DTE-Ereignisse",
  "mkRef.supplier_articles": "Lieferantenbeziehungen",
  "mkRef.properties": "Merkmalswerte",
  "mkRef.texts": "Texte",
  "mkRef.documents": "Dokumente",
  "mp.kpiAssigned": "{n} von {total} Ausführungen mit Artikel verknüpft",
  "mp.kpiCompleteOf": "von {total} fachlich vollständig",
  "neu.reuseNumber": "Die Artikelnummer {number} wurde endgültig gelöscht. Ich verwende sie bewusst erneut.",
  "modelLog.execution_unassigned": "Artikelzuordnung gelöst",
  "modelLog.execution_reassigned": "Artikel der Ausführung gewechselt",
  "modelLog.failed_creation_discarded": "Fehlerhafte Anlage verworfen",
  "error.discard_blocked": "Dieser Artikel besitzt betriebliche Historie und kann nicht verworfen werden.",
  /* ── Produktions- und Logistikportal: Nachtrag aus der Produktivabnahme ── */
  "plp.currency": "Währung",
  "plp.currencyLocked": "In dieser Bestellung stehen bereits Preise. Die Währung lässt sich nur ändern, solange keine Position einen Preis trägt — sonst bekämen vereinbarte Beträge still eine andere Bedeutung.",
  "plp.currencyMissing": "Diese Bestellung hat noch keine Währung. Bitte zuerst oben an der Bestellung festlegen — ein Preis ohne Währung ist eine Zahl ohne Aussage.",
  "plp.supplierLocked": "Diese Bestellung trägt bereits Positionen ihres bisherigen Lieferanten. Der Partner lässt sich erst wechseln, wenn keine Position mehr daran hängt.",
  "plp.orderValue": "Bestellwert",
  "plp.noValue": "kein Preis erfasst",
  "plp.valueIncomplete": "Bestellwert unvollständig",
  "plp.valuePartial": "{n} Position(en) ohne Preis — der Bestellwert ist noch unvollständig.",
  "plp.lineTotal": "Gesamt",
  "plp.lineKind": "Art der Position",
  "plp.lineFromCatalog": "Artikel aus HOMEBASE",
  "plp.lineFree": "Freie Position",
  "plp.lineFreeHint": "Freie Position — keinem HOMEBASE-Artikel zugeordnet",
  "plp.unitPriceIn": "Vereinbarter Preis ({w})",
  "plp.removeLine": "entfernen",
  "plp.editAria": "Bestellung bearbeiten",
  "plp.certaintyOnlyActual": "Dieses Ereignis tritt ein — es wird als Ist erfasst.",
  "plp.certaintyOnlyConfirmed": "Dieser Termin wird zugesagt, nicht vollzogen — er wird als Bestätigt erfasst.",
  /* ── Die Absagen des Portals, als Sätze ──────────────────────────────── */
  "error.number_required": "Eine Bestellung braucht ihre DTE-Nummer. HOMEBASE vergibt keine.",
  "error.invalid_po_number": "Ungültige PO-Nummer. Bitte im Format PO70302 eingeben — der Einkauf trägt den Nummernkreis 7.",
  "error.po_exists": "Diese Bestellnummer ist bereits erfasst.",
  "error.po_not_empty": "Diese Bestellung trägt bereits Positionen, Termine oder eine Consolidation. Sie wird storniert, nicht entfernt.",
  "error.po_supplier_locked": "Diese Bestellung trägt bereits Positionen ihres bisherigen Lieferanten. Der Partner lässt sich erst wechseln, wenn keine Position mehr daran hängt.",
  "error.po_currency_locked": "In dieser Bestellung stehen bereits Preise. Die Währung lässt sich nur ändern, solange keine Position einen Preis trägt.",
  "error.po_currency_required": "Diese Bestellung hat noch keine Währung. Bitte sie zuerst an der Bestellung festlegen — ein Preis ohne Währung ist eine Zahl ohne Aussage.",
  "error.po_already_consolidated": "Diese Bestellung ist bereits einer Consolidation zugeordnet.",
  "error.date_required": "Hier fehlt ein Datum.",
  "error.unknown_incoterm": "Diese Lieferklausel steht nicht im Katalog.",
  "error.unknown_currency": "Diese Währung steht nicht im Katalog.",
  "error.invalid_quantity": "Eine Bestellposition braucht eine ganze Menge größer als null.",
  "error.invalid_price": "Der Preis ist keine positive Zahl.",
  "error.line_exists": "Dieser Artikel steht bereits als Position in dieser Bestellung.",
  "error.line_foreign_supplier": "Diese Beziehung gehört einem anderen Lieferanten. Eine Bestellung trägt nur Positionen ihres eigenen Partners.",
  "error.cn_closed": "Diese Consolidation ist für Zuordnungen geschlossen und nimmt keine Bestellung mehr auf.",
  "error.unknown_subject": "Dieses Objekt kennt HOMEBASE nicht.",
  "error.unknown_milestone": "Diesen Termin kennt HOMEBASE nicht.",
  "error.invalid_review_stars": "Eine Bewertung geht von einem bis fünf Sternen — oder gar nicht.",
  "error.milestone_wrong_subject": "Dieser Termin gehört zu einem anderen Objekt.",
  "error.milestone_not_manual": "Dieser Termin steht an seinem Fachobjekt und wird dort gepflegt.",
  "error.certainty_not_allowed": "Dieser Terminstatus passt nicht zu diesem Termin: ein Ereignis tritt ein, eine Fälligkeit wird zugesagt.",
  "error.milestone_superseded": "Dieser Stand ist bereits abgelöst. Ein abgelöster Stand bleibt stehen — geändert wird der aktuelle.",
  "error.milestone_has_history": "Zu diesem Termin gibt es bereits eine Historie. Er wird verschoben, nicht entfernt.",
  "error.forecast_not_storable": "Gespeichert werden nur bestätigte und eingetretene Termine. Ein Forecast wird gerechnet.",
  "error.anchor_not_allowed": "Auf diesem Termin lässt sich keine Lieferzeit aufsetzen.",
  "error.status_derived": "Dieser Zustand entsteht aus den erfassten Ereignissen und wird nicht gesetzt. Von Hand gibt es nur den Abschluss und das Verwerfen.",
  "error.cn_not_handed_over": "Departed lässt sich erst erfassen, nachdem die Ware vom Carrier übernommen wurde.",
  "error.cn_not_landed": "An den Logistikpartner Hamburg wird erst übergeben, nachdem die Sendung in Hamburg angekommen ist (HH landed).",
  "error.bank_no_account": "Eine Bankverbindung braucht eine IBAN oder eine Kontonummer. Liegt eine IBAN vor, genügt sie.",
  "error.cn_not_delivered": "Diese Sendung ist noch nicht zugestellt. Abgeschlossen wird nach der tatsächlichen Anlieferung.",
  "error.unknown_transport_mode": "Diese Transportart kennt HOMEBASE nicht.",
  "error.cn_orders_not_received": "Es sind noch nicht alle Bestellungen dieser Sendung beim Logistikpartner eingetroffen. Wer nicht mitfährt, wird vorher aus der Sendung gelöst.",
  "error.group_missing": "Diese Dokumentgruppe gibt es an einer Bestellung nicht.",
  "error.cn_empty": "Diese Consolidation trägt keine aktive Bestellung. Eine leere Sendung wird nicht an den Carrier übergeben.",
  "error.cn_in_transport": "Diese Sendung ist bereits an den Carrier übergeben. Daran lässt sich nichts mehr ändern.",
  "error.release_reason_required": "Zum Lösen gehört ein Grund. Ohne ihn wäre es eine Löschung mit anderem Namen.",
  "error.already_handed_over": "Diese Bestellung ist bereits an den Logistikpartner übergeben. Eine Korrektur ist eine Umbuchung und kein Lösen.",
  "error.cn_handed_over": "Aus dieser Consolidation ist bereits Ware übergeben. Sie lässt sich nicht mehr auf dem normalen Weg verwerfen.",
  "error.anchor_deprecated": "Dieser Termin wird nicht mehr erfasst. Eine neue Lieferzeitregel darf nicht darauf aufsetzen; bestehende Regeln bleiben gültig.",
  "error.rule_scope": "Eine Lieferzeitregel gilt für genau einen Bereich: Lieferant, Beziehung oder Bestellung.",
  "error.rule_days": "Die Dauer braucht einen Mindestwert größer als null, und der Höchstwert liegt nicht darunter.",
  "error.unknown_source": "Diese Quelle einer Lieferzeitangabe gibt es nicht.",
  /* ── Zentrale Geschaeftspartner ──────────────────────────────────────── */
  "sup.roles": "Rollen",
  "sup.roleAll": "Alle",
  "sup.roleFilter": "Nach Rolle filtern",
  "partnerRole.lieferant": "Lieferant",
  "partnerRole.forwarder": "Forwarder",
  /* Zwei Logistikpartner je Sendung (0086) -- Fernost sammelt, Hamburg
     fuehrt weiter. Das Konsolidierungsfenster ist abgeleitet und wird
     nicht gepflegt; der Altvorgangssatz sagt, dass es das Feld damals
     nicht gab -- und gerade NICHT, dass etwas offen ist. */
  "plp.originForwarder": "Logistikpartner Fernost",
  "plp.destForwarder": "Logistikpartner Hamburg",
  "plp.chooseDestForwarder": "Logistikpartner Hamburg wählen",
  "plp.noDestForwarder": "kein Logistikpartner Hamburg",
  /* Korrekturlauf 005. „Keine offenen Prozessangaben" ist die wahre und
     schwaechere Aussage -- ein Altvorgang traegt Angaben, die niemand mehr
     erfasst. Plan und Ist gliedern die Terminpflege; der Satz zur
     Voraussetzung steht VOR dem Speichern, nicht danach. */
  "plp.noOpenProcessData": "Keine offenen Prozessangaben.",
  "plp.groupPlanned": "Erwartung",
  "plp.groupActual": "Tatsächlich",
  "plp.stepNeedsFirst": "{was} kann erst erfasst werden, wenn „{erst}“ vorliegt.",
  "plp.intakeWindowClosedLegacy": "GESCHLOSSEN (Altvorgang)",
  /* CN UX SIMPLIFICATION 001. Die Sendungsakte fuehrt ab hier: EIN
     naechster Schritt statt dreizehn Angeboten, drei Plan-Ist-Paare statt
     des ganzen Katalogs, und der Verlauf eingeklappt. Ein fehlender
     Planwert heisst „noch nicht geplant" und nicht „noch offen" -- er ist
     keine Aufgabe. */
  "plp.whatNow": "Was ist jetzt zu tun?",
  "plp.noOpenAction": "Keine offene Aktion.",
  "plp.nextStep": "Als Nächstes",
  "plp.recordNow": "Jetzt erfassen",
  "plp.intakeMissing": "{n} Bestellungen noch nicht beim Logistikpartner eingegangen.",
  "plp.intakeMissingOne": "Eine Bestellung ist noch nicht beim Logistikpartner eingegangen.",
  "plp.recordIntake": "Eingang erfassen",
  "plp.notPlanned": "noch nicht geplant",
  "plp.legStart": "Abfahrt Fernost",
  "plp.legHamburg": "Hamburg",
  "plp.legLueneburg": "Lüneburg",
  "plp.colExpected": "Erwartung",
  "plp.colActual": "Tatsächlich",
  "plp.consolidation": "Konsolidierung",
  "plp.consolidationOpenHint": "Die Sendung kann noch um weitere Bestellungen ergänzt werden.",
  "plp.consolidationClosedHint": "An Carrier übergeben am {tag}.",
  "plp.consolidationClosedLegacyHint": "Altvorgang — die Konsolidierung ist nachweislich vorbei.",
  "plp.processTrail": "Prozessverlauf",
  "plp.trailDone": "{n} von {alle} Prozessschritten erledigt",
  "plp.trailNext": "nächster Schritt",
  "plp.planVsActual": "Plan gegen Ist",
  "plp.waitingTimes": "Wartezeiten",
  "plp.goodsTitle": "Enthaltene Ware",
  "plp.goodsFor": "in {cn}",
  "plp.goodsEmpty": "Dieser Lieferung ist noch keine Ware zugeordnet.",
  "plp.goodsPieces": "{n} Stk.",
  "plp.goodsNoArticle": "{n} Position(en) ohne greenius-Artikelnummer — sie stehen in der Bestellung.",
  "plp.goodsHint": "Mengen über alle Bestellungen dieser Lieferung zusammengefasst.",
  "plp.goodsOpenFile": "Vollständige Sendungsakte",
  "help.timeline.title": "Die Zeitachse lesen",
  "help.timeline.body": "Ein ausgefülltes grünes Feld ist eingetreten — das Ereignis hat stattgefunden. Ein Feld mit grüner Umrandung ist geplant oder zugesagt, aber noch nicht geschehen. Eine gestrichelte Umrandung ist gerechnet: sie kommt aus einer Lieferzeitregel, niemand hat sie zugesagt. Die leicht hinterlegten Zeilen sind Sendungen; die Bestellungen darüber laufen in sie hinein.",
  "help.cn.transport.title": "Erwartung und Tatsächlich",
  "help.cn.transport.body": "Links steht, wann etwas erwartet wird, rechts, wann es wirklich passiert ist. ETD ist der geplante Abfahrtstag, Departed der tatsächliche. ETA Hamburg ist die erwartete Ankunft, HH landed die eingetretene. ETA Lüneburg und LG landed stehen für die Anlieferung. Solange rechts „Noch offen“ steht, ist das Ereignis nicht eingetreten.",
  "help.po.documents.title": "Die Dokumente einer Bestellung",
  "help.po.documents.body": "Die Purchase Order zeigt, was greenius bestellt hat. Die Proforma Invoice zeigt, was der Lieferant bestätigt und berechnet. Die Packing List zeigt, welche Ware tatsächlich für den Versand vorbereitet wurde. Alle drei gehören zur Bestellung und werden versioniert: eine neue Fassung ersetzt die alte nicht, sie löst sie ab.",
  "pod.title": "Dokumente",
  "pod.po": "Purchase Order",
  "pod.pi": "Proforma Invoice",
  "pod.packing": "Packing List",
  "pod.present": "vorhanden",
  "pod.missing": "erforderlich · fehlt",
  /* „Noch nicht erforderlich" ist KEINE Warnung und traegt deshalb
     auch kein Warnzeichen. Ein Dokument, das im Ablauf noch gar
     nicht an der Reihe ist, fehlt nicht -- es ist noch nicht dran.
     Siehe `DOCUMENT_OBLIGATIONS`, Abschnitt 18. */
  "pod.notYet": "noch nicht erforderlich",
  "pod.upload": "Hochladen",
  "pod.replace": "Neue Fassung",
  "pod.uploading": "wird abgelegt …",
  "pod.versions": "Ältere Fassungen ({n})",
  "pod.uploadedOn": "abgelegt am {datum}",
  "pod.documentDate": "Dokumentdatum {datum}",
  "pod.supersededNote": "Ältere Fassungen bleiben erhalten — eine neue Fassung ersetzt sie nicht, sie löst sie ab.",
  "pod.ofOrders": "Dokumente der Bestellungen",
  "pod.cnReadOnly": "Die Dokumente hängen an den Bestellungen. Hier werden sie nur angezeigt — abgelegt wird in der Bestellakte.",
  "pod.noOrders": "Dieser Sendung ist keine Bestellung zugeordnet.",
  "help.modeOn": "Hilfe einschalten",
  "help.modeOff": "Hilfe ausschalten",
  "help.ov.cnwahl.title": "Welche Lieferung Sie gerade sehen",
  "help.ov.cnwahl.body": "Oben wählen Sie die Sendung aus. Zeitachse und ankommende Ware zeigen danach genau diese Sendung und ihre Bestellungen — die übrigen werden ausgeblendet. Der Bereich „Was braucht Aufmerksamkeit?“ bleibt bewusst vollständig: ein dringender Punkt soll nicht verschwinden, weil gerade eine andere Sendung gewählt ist.",
  "help.ov.ware.title": "Was mit dieser Lieferung ankommt",
  "help.ov.ware.body": "Hier steht die Ware der gesamten Sendung, nicht die einer einzelnen Bestellung. Kommt derselbe Artikel aus mehreren Bestellungen, sind die Mengen zusammengezählt. Welche Bestellung welchen Anteil trägt, steht in der Sendungsakte.",
  "help.cn.arbeitszone.title": "Was jetzt zu tun ist",
  "help.cn.arbeitszone.body": "HOMEBASE zeigt hier den nächsten Schritt dieser Sendung — nicht alle möglichen. Steht ein Schritt als wartend da, fehlt ihm noch eine Voraussetzung; sie ist daneben genannt.",
  "help.cn.planist.title": "Plan gegen Ist",
  "help.cn.planist.body": "Die Abweichung zwischen erwartetem und tatsächlichem Datum, in Tagen. Sie sagt, WAS war — nicht, wer sie verursacht hat. Eine späte Abfahrt kann eine bewusste Entscheidung gewesen sein.",
  "help.po.incoterm.title": "Lieferklausel (Incoterm)",
  "help.po.incoterm.body": "Die Lieferklausel legt fest, ab welchem Punkt greenius Kosten und Risiko des Transports trägt. EXW heißt ab Werk des Lieferanten, FOB ab Verladehafen, DAP bis zum vereinbarten Zielort.",
  "help.po.leadtime.title": "Bezugspunkt der Lieferzeit",
  "help.po.leadtime.body": "Ab diesem Ereignis beginnt die vom Lieferanten zugesagte Lieferzeit zu laufen. Ohne den Bezugspunkt lässt sich kein Forecast rechnen — eine Dauer ohne Startpunkt ist keine Aussage.",
  "help.po.payments.title": "Zahlungen und Nachweise",
  "help.po.payments.body": "Hier stehen die zur Bestellung gehörenden Zahlungsvorgänge und ihre Zahlungsnachweise. Anzahlung, Teilzahlung und Restzahlung sind eigene Vorgänge; der Nachweis — Bankbeleg oder Zahlungsbestätigung — gehört an die konkrete Zahlung und nicht an die Bestellung.",
  "plp.unassigned": "Nicht zugeordnet",
  "plp.shipments": "Lieferungen",
  "plp.etaLueneburg": "ETA Lüneburg {datum}",
  "pay.evidence": "Zahlungsnachweis",
  "pay.evidenceMissing": "Nachweis fehlt",
  "pay.evidenceUpload": "Nachweis hochladen",
  "pay.evidenceNew": "Neue Fassung",
  "plp.trailBlocked": "erst möglich nach „{erst}“",
  "plp.needsIntake": "Eingang aller Bestellungen beim Logistikpartner",
  "plp.editMilestones": "Termine bearbeiten",
  "plp.deltaDays": "{n} Tage",
  "plp.deltaEarly": "{n} Tage früher",
  "plp.deltaOnTime": "pünktlich",
  "plp.intakeWindowOpen": "OFFEN",
  "plp.intakeWindowClosed": "GESCHLOSSEN",
  "plp.legacyUndocumented": "nicht dokumentiert (Altvorgang)",
  "plp.intakeLegacyHint": "Eingang beim Logistikpartner nicht dokumentiert (Altvorgang) — dieses Feld gab es bei Anlage der Sendung noch nicht.",
  "plp.chooseForwarder": "Logistikpartner Fernost wählen",
  "plp.noForwarder": "kein Logistikpartner Fernost",
  "plp.manageForwarders": "Logistikpartner verwalten",
  "plp.forwarderFromPartners": "Zur Auswahl stehen Geschäftspartner mit der Rolle Forwarder. Weitere lassen sich unter Geschäftspartner ergänzen.",
  "plp.noForwarderYet": "Noch kein Geschäftspartner trägt die Rolle Forwarder. Die Rolle lässt sich unter Geschäftspartner an einer bestehenden Organisation ergänzen — oder dort eine neue anlegen.",
  "error.unknown_partner_role": "Diese Partnerrolle steht nicht im Katalog.",
  "error.roles_required": "Ein Geschäftspartner braucht mindestens eine Rolle — Lieferant, Forwarder oder beides. Ohne sie stünde er in keiner Liste.",
  "error.partner_role_in_use": "Diese Rolle lässt sich nicht entfernen: eine Consolidation führt diese Organisation als Forwarder. Bitte die Zuordnung dort zuerst lösen.",
  "error.unknown_forwarder": "Diesen Logistikpartner gibt es nicht.",
  "error.not_a_supplier": "Dieser Geschäftspartner trägt die Rolle Lieferant nicht. Sie lässt sich in seiner Akte ergänzen — eine Organisation kann mehrere Rollen haben.",
  "error.not_a_forwarder": "Dieser Geschäftspartner trägt die Rolle Forwarder nicht. Sie lässt sich in seiner Akte ergänzen — eine Organisation kann mehrere Rollen haben.",
  /* ── Bestellerfassung: Upload, Vorschlag, gemeinsame Maske ───────────── */
  "plp.uploadOrder": "Bestellung hochladen",
  "plp.manualOrder": "Manuell anlegen",
  "plp.uploadHint": "Das PDF ist Beleg und Evidenz — keine bestätigte Wahrheit. HOMEBASE liest daraus einen Vorschlag; die Bestellung entsteht erst, wenn Sie ihn geprüft und bestätigt haben.",
  "plp.captureTitle": "Bestellung aus Beleg übernehmen",
  "plp.captureFindings": "Was HOMEBASE im Beleg gesehen hat",
  "plp.captureSource": "Beleg",
  "plp.captureSourceValue": "{datei} — hochgeladen von {wer} am {wann}",
  "plp.captureRawNumber": "Bestellnummer im Beleg",
  "plp.captureNothing": "nicht erkannt",
  "plp.captureClean": "Alle Kopfangaben und alle Positionen wurden gelesen. Bitte trotzdem gegen den Beleg prüfen — bestätigt wird, was hier steht.",
  "plp.captureDuplicate": "Die Bestellung {nr} ist bereits erfasst. HOMEBASE legt keine zweite an und ändert die bestehende nicht.",
  "plp.captureOpenExisting": "bestehende Bestellung öffnen",
  "plp.captureSupplierOne": "Im Beleg steht „{name}“ — ein Geschäftspartner passt dazu und ist vorausgewählt.",
  "plp.captureSupplierMany": "Im Beleg steht „{name}“ — {n} Geschäftspartner passen dazu. Bitte wählen.",
  "plp.captureSupplierNone": "Im Beleg steht „{name}“ — dazu passt kein Geschäftspartner. Bitte wählen oder zuerst anlegen.",
  "plp.captureRawItem": "im Beleg: {nr}",
  "plp.captureAmbiguous": "mehrere Treffer",
  "plp.noArticle": "— ohne Artikel (Kostenposition) —",
  "plp.lineDescription": "Bezeichnung",
  "plp.unit": "Einheit",
  "plp.documentTotal": "Gesamtwert laut Beleg",
  "plp.documentTotalHint": "Der im Beleg ausgewiesene Betrag. Er ersetzt den gerechneten Bestellwert nicht.",
  "plp.totalsDiffer": "Die Positionen ergeben {summe}, der Beleg weist {beleg} aus — eine Abweichung von {rest}. HOMEBASE gleicht nichts an und vermutet weder Rabatt noch Fracht, Gebühr oder Steuer. Bitte prüfen.",
  "plp.confirmOrder": "Bestellung bestätigen",
  "plp.confirmHint": "Erst mit der Bestätigung entsteht die Bestellung. Nummer, Lieferant und Belegdatum werden dafür gebraucht.",
  "beleg.kein_text": "Aus diesem PDF ließ sich kein Text lesen — vermutlich ein Scan. Die Felder bleiben leer; bitte von Hand erfassen.",
  "beleg.verschluesselt": "Dieses PDF ist verschlüsselt und lässt sich nicht lesen.",
  "beleg.keine_nummer": "Keine Bestellnummer erkannt.",
  "beleg.kein_datum": "Kein Belegdatum erkannt.",
  "beleg.kein_lieferant": "Kein Lieferantenname erkannt.",
  "beleg.keine_waehrung": "Keine Währung erkannt.",
  "beleg.kein_gesamtwert": "Kein Gesamtwert im Beleg erkannt.",
  "beleg.keine_positionen": "Keine Positionen erkannt.",
  "beleg.keine_tabelle": "Keine Positionstabelle gefunden.",
  "beleg.summe_weicht_ab": "Positionssumme und Gesamtwert des Belegs weichen voneinander ab.",
  "beleg.menge_fehlt": "Menge nicht erkannt",
  "beleg.menge_abgeleitet": "Menge aus Wert und Preis abgeleitet",
  "beleg.preis_fehlt": "Preis nicht erkannt",
  "beleg.wert_fehlt": "Positionswert nicht erkannt",
  "beleg.rechnung_geht_nicht_auf": "Menge × Preis ergibt nicht den Positionswert",
  "beleg.keine_artikelnummer": "keine Artikelnummer im Beleg",
  "error.beleg_kein_pdf": "Als Bestellbeleg nimmt HOMEBASE heute ein PDF entgegen.",
  "error.capture_not_open": "Dieser Erfassungsvorgang ist bereits abgeschlossen.",
  "error.line_needs_subject": "Eine Position braucht einen Artikel oder eine Bezeichnung. Ein Betrag ohne Gegenstand ist keine Bestellposition.",
  "error.invalid_document_total": "Der Gesamtwert des Belegs ist keine Zahl.",
  /* ── Kaufmaennische Sicht der Bestellung ─────────────────────────────── */
  "plp.finance": "Finanzen",
  "plp.paymentTerms": "Zahlungsvereinbarung",
  "plp.termsWhereEdited": "Gepflegt wird die Vereinbarung dort, wo sie herkommt — am Lieferanten oder an der Artikelbeziehung.",
  "plp.noPaymentTerms": "Keine Zahlungsvereinbarung hinterlegt — weder für diese Bestellung noch beim Lieferanten.",
  "plp.termsFromOrder": "für diese Bestellung vereinbart",
  "plp.termsTakenOver": "aus dem Lieferantenstandard übernommen",
  "plp.termsFromArticle": "aus der Artikelbeziehung",
  "plp.termsFromSupplier": "Standard des Lieferanten",
  "plp.paidOn": "Zahlungsdatum",
  "plp.paidOnHint": "Wann gezahlt wurde — nicht, wann Sie es hier erfassen. Stichtagsauswertungen rechnen danach.",
  "plp.paymentKind": "Art",
  "plp.paymentAmount": "Betrag",
  "plp.paymentAmountIn": "Betrag ({w})",
  "plp.paymentNote": "Notiz",
  "plp.paymentReference": "Referenz",
  "plp.noPayments": "Noch keine Zahlung erfasst.",
  "plp.paidTotal": "Bezahlt gesamt",
  "plp.stillOpen": "Noch offen",
  "plp.addPayment": "+ Zahlung erfassen",
  "plp.removePayment": "entfernen",
  "plp.recordedOn": "erfasst von {wer} am {wann}",
  "plp.foreignCurrency": "andere Währung",
  "plp.financeSeparation": "Bezahlt ist nicht erfüllt: ob die Ware da ist, sagen die Termine — nicht dieser Abschnitt.",
  "payKind.deposit": "Anzahlung",
  "payKind.partial": "Teilzahlung",
  "payKind.balance": "Restzahlung",
  "payKind.other": "sonstige",
  "finBefund.ueberzahlt": "Es wurde mehr bezahlt als bestellt. HOMEBASE korrigiert das nicht — bitte prüfen.",
  "finBefund.fremdwaehrung": "Mindestens eine Zahlung ist in einer anderen Währung als die Bestellung. Sie wird nicht umgerechnet und zählt nicht in „Bezahlt gesamt“.",
  "finBefund.kein_bestellwert": "Es sind Zahlungen erfasst, aber die Bestellung hat keinen Wert — der offene Betrag lässt sich nicht bilden.",
  "finBefund.keine_waehrung": "Die Bestellung hat keine Währung.",
  "finBefund.zahlung_vor_bestellung": "Mindestens eine Zahlung liegt vor dem Bestelldatum. Das kann richtig sein — bitte prüfen.",
  "finBefund.bezahlt_ohne_wareneingang": "Vollständig bezahlt, aber noch kein Wareneingang erfasst. Bezahlt ist nicht erfüllt.",
  "finBefund.ware_da_rest_offen": "Die Ware ist eingegangen, ein Restbetrag ist noch offen.",
  "finBefund.bestellwert_unvollstaendig": "Mindestens eine Position hat keinen Preis. Der Bestellwert ist richtig gerechnet, aber noch nicht der ganze Auftrag.",
  "finBefund.wert_nicht_rekonstruierbar": "Der Bestellwert zu diesem Stichtag lässt sich nicht zurückrechnen: mindestens eine Position wurde entfernt, bevor HOMEBASE dabei Menge und Preis festhielt. Der Wert bleibt leer — geraten wird nicht.",
  "ms.eta_hamburg": "ETA Hamburg",
  /* ETA HH ist die Erwartung, HH landed das Ereignis. */
  "ms.hh_landed": "HH landed",
  "ms.customs_cleared": "Zollfreigabe erfolgt",
  "ms.eta_lueneburg": "ETA Lüneburg",
  /* ABFAHRT IST NICHT UEBERGABE. `carrier_handover` bleibt die Uebergabe
     am Ausgangsort; `departed` ist die tatsaechliche Abfahrt. Der sichtbare
     Begriff „Departed" ist in beiden Sprachen derselbe -- so festgelegt. */
  "ms.departed": "Departed",
  "ms.hh_handover": "An Logistikpartner Hamburg übergeben",
  /* BERICHTIGT. „Ware vom Carrier übernommen" las sich, als habe der
     Logistikpartner etwas bekommen. Gemeint ist das Gegenteil: er hat die
     konsolidierte Sendung an das Transportunternehmen ABGEGEBEN. Ab da ist
     der Inhalt fix. Der technische Code bleibt `carrier_handover`.
     NICHT dasselbe wie „Departed" -- der Carrier HAT die Sendung, er ist
     noch nicht abgefahren. */
  "ms.carrier_handover": "An Carrier übergeben",
  "ms.goods_delivered": "LG landed",
  "ms.goods_received": "Wareneingang",
  "ms.packing_list_received": "Packing List erhalten",
  "ms.freight_requested": "Frachtanfrage gestellt",
  "ms.freight_quoted": "Frachtangebot erhalten",
  "ms.freight_ordered": "Frachtauftrag erteilt",
  /* Der laengere Satz ist Absicht: „Ware uebernommen" allein liesse sich
     fuer den Wareneingang bei greenius lesen -- und das ist ein anderer
     Termin an einem anderen Objekt. */
  "ms.goods_handed_over": "Ware vom Logistikpartner übernommen",
  "ms.customs_docs_sent": "CI & Packing List für Zollanmeldung übermittelt",
} as const;
/** Der Schluesselbestand. Jede Sprache muss ihn vollstaendig bedienen. */
export type TranslationKey = keyof typeof de;
export type Translations = Record<TranslationKey, string>;
